export const DataESP = [
  {
    ID: 0,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Title: "Disminución del número verificado de niños detenidos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,HT,NG,SO,YE",
    Image: "1POLICY1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=58"
  },
  {
    ID: 1,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Title: "Aumento en la firma de planes de acción, protocolos de entrega y otros compromisos entre las Naciones Unidas y las partes en conflicto para hacer cesar y prevenir las violaciones graves contra los niños",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=59"
  },
  {
    ID: 2,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Title: "Disminución del número de niños reclutados y utilizados por las partes en situaciones de conflicto armado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=60"
  },
  {
    ID: 3,
    BudgetSection: 1,
    Entity: "OSRSG-CAAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General para la Cuestión de los Niños y los Conflictos Armados",
    Title: "Más niños liberados de las fuerzas y grupos armados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=60"
  },
  {
    ID: 4,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Title: "Aumento de la implicación nacional a fin de prevenir la violencia sexual relacionada con los conflictos y ofrecer justicia a las personas supervivientes: el caso de Ucrania",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UA",
    Image: "1POLICY5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=71"
  },
  {
    ID: 5,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Title: "Refuerzo de la prestación de servicios de atención a la violencia sexual relacionada con los conflictos y de la respuesta de la justicia a esa violencia por parte de las autoridades nacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DJ,ER,ET,SO,SD,QQ",
    Image: "1POLICY6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=72"
  },
  {
    ID: 6,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Title: "Fortalecimiento de la respuesta judicial de las autoridades nacionales para impulsar la justicia centrada en los supervivientes y la rendición de cuentas por la violencia sexual relacionada con los conflictos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CO,CF,CD,UA",
    Image: "1POLICY7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=73"
  },
  {
    ID: 7,
    BudgetSection: 1,
    Entity: "OSRSG-SVC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia Sexual en los Conflictos",
    Title: "Mayor cumplimiento de las normas internacionales sobre prevención y tratamiento de la violencia sexual relacionada con los conflictos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=73"
  },
  {
    ID: 8,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Title: "Mayor compromiso del sector privado con la protección de los niños frente a la violencia en el contexto de los viajes y el turismo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=83"
  },
  {
    ID: 9,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Title: "Revitalización de la iniciativa de los países pioneros (Alianza Mundial Pionera para la Erradicación de la Violencia contra los Niños) destinada a poner fin a la violencia contra los niños para 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=84"
  },
  {
    ID: 10,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Title: "Los Estados Miembros aprueban hojas de ruta estratégicas para acelerar la acción encaminada a poner fin a la violencia contra los niños de aquí a 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=84"
  },
  {
    ID: 11,
    BudgetSection: 1,
    Entity: "OSRSG-VAC",
    EntityFullName: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Representante Especial del Secretario General sobre la Violencia contra los Niños",
    Title: "El aprendizaje entre pares de los Estados Miembros acelera la acción encaminada a poner fin a la violencia contra los niños",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=85"
  },
  {
    ID: 12,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Title: "Mayor integración de las medidas de protección en los marcos para la cooperación con los países",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=98"
  },
  {
    ID: 13,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Title: "Un enfoque coordinado de las Naciones Unidas para abordar más eficazmente la explotación y los abusos sexuales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=98"
  },
  {
    ID: 14,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Title: "Esfuerzos eficaces de prevención y respuesta mediante la institucionalización de la protección contra la explotación y los abusos sexuales en todo el sistema de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=99"
  },
  {
    ID: 15,
    BudgetSection: 1,
    Entity: "OSC-SEA",
    EntityFullName: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina del Coordinador Especial para Mejorar la Respuesta de las Naciones Unidas a la Explotación y los Abusos Sexuales",
    Title: "Enfoque estratégico reforzado a nivel de todo el sistema para hacer frente a la explotación y los abusos sexuales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=100"
  },
  {
    ID: 16,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Title: "Gestionar mejor los conflictos en el lugar de trabajo mediante actividades de capacitación y desarrollo de competencias",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=109"
  },
  {
    ID: 17,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Title: "Acceso del personal de las Naciones Unidas que no es de plantilla a servicios oficiosos de solución de conflictos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=110"
  },
  {
    ID: 18,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Title: "Mayor acceso a los servicios para el personal sobre el terreno",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=110"
  },
  {
    ID: 19,
    BudgetSection: 1,
    Entity: "OMS",
    EntityFullName: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de la Ómbudsman y de Servicios de Mediación de las Naciones Unidas",
    Title: "Mayor conocimiento de los servicios de mediación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=111"
  },
  {
    ID: 20,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Oficina de Administración de Justicia",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Administración de Justicia",
    Title: "Capacidades mejoradas para el seguimiento de las causas presentadas ante el Tribunal Contencioso-Administrativo de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=119"
  },
  {
    ID: 21,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Oficina de Administración de Justicia",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Administración de Justicia",
    Title: "Mejora de la transparencia del sistema de administración de justicia mediante el uso de inteligencia institucional y la elaboración de informes sobre análisis de tendencias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=120"
  },
  {
    ID: 22,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Oficina de Administración de Justicia",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Administración de Justicia",
    Title: "Mayor utilización del asesoramiento jurídico de la Oficina de Asistencia Letrada al Personal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=121"
  },
  {
    ID: 23,
    BudgetSection: 1,
    Entity: "OAJ",
    EntityFullName: "Oficina de Administración de Justicia",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Administración de Justicia",
    Title: "Resolución más oportuna de las causas ante el Tribunal Contencioso-Administrativo de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=121"
  },
  {
    ID: 24,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Oficina de Ética",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Ética",
    Title: "Mayor confianza del personal a la hora de solicitar asesoramiento sobre la protección contra las represalias",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=130"
  },
  {
    ID: 25,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Oficina de Ética",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Ética",
    Title: "Mayor conciencia ética y acceso a los servicios de ética del personal sobre el terreno",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=131"
  },
  {
    ID: 26,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Oficina de Ética",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Ética",
    Title: "Mayor transparencia y rendición de cuentas gracias a un mejor asesoramiento y orientación a través del programa de declaración de la situación financiera",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=132"
  },
  {
    ID: 27,
    BudgetSection: 1,
    Entity: "EO",
    EntityFullName: "Oficina de Ética",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Ética",
    Title: "Mayor comprensión por parte del personal de los procesos de protección contra las represalias y mayor rapidez en su aplicación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=132"
  },
  {
    ID: 28,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Sistema de coordinadores residentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Sistema de coordinadores residentes",
    Title: "Los Gobiernos nacionales impulsaron enfoques de política integrada para acelerar la consecución de los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=142"
  },
  {
    ID: 29,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Sistema de coordinadores residentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Sistema de coordinadores residentes",
    Title: "Mayor transparencia y rendición de cuentas respecto a los resultados de las Naciones Unidas y la contribución a los Objetivos de Desarrollo Sostenible a través de indicadores normalizados del Marco de Cooperación de las Naciones Unidas para el Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=143"
  },
  {
    ID: 30,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Sistema de coordinadores residentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Sistema de coordinadores residentes",
    Title: "Mayor eficacia del apoyo de las Naciones Unidas a la consecución de los Objetivos de Desarrollo Sostenible mediante soluciones basadas en datos e innovación digital",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=144"
  },
  {
    ID: 31,
    BudgetSection: 1,
    Entity: "RCS",
    EntityFullName: "Sistema de coordinadores residentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Sistema de coordinadores residentes",
    Title: "Proteger vidas y medios de subsistencia ante las repercusiones socioeconómicas a largo plazo de las crisis",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Administración pública ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=145"
  },
  {
    ID: 32,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Oficina de las Naciones Unidas para la Juventud",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de las Naciones Unidas para la Juventud",
    Title: "Avances en la promoción de las prioridades de los jóvenes y en su participación significativa",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=162"
  },
  {
    ID: 33,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Oficina de las Naciones Unidas para la Juventud",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de las Naciones Unidas para la Juventud",
    Title: "Participación de la juventud a todos los niveles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=162"
  },
  {
    ID: 34,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Oficina de las Naciones Unidas para la Juventud",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de las Naciones Unidas para la Juventud",
    Title: "Hacia una plataforma mundial de inversión en la juventud para ampliar la programación relacionada con los jóvenes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=163"
  },
  {
    ID: 35,
    BudgetSection: 1,
    Entity: "UNYO",
    EntityFullName: "Oficina de las Naciones Unidas para la Juventud",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de las Naciones Unidas para la Juventud",
    Title: "Mayor participación de los jóvenes en los procesos de paz y seguridad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=164"
  },
  {
    ID: 36,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Oficina de Protección y Privacidad de los Datos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Protección y Privacidad de los Datos",
    Title: "Mayor disponibilidad operacional en materia de gestión de la protección y la privacidad de los datos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=172"
  },
  {
    ID: 37,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Oficina de Protección y Privacidad de los Datos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Protección y Privacidad de los Datos",
    Title: "Mayor protección y privacidad de los datos en toda la Secretaría",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=173"
  },
  {
    ID: 38,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Oficina de Protección y Privacidad de los Datos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Protección y Privacidad de los Datos",
    Title: "Procesos empresariales optimizados para integrar y garantizar el cumplimiento de la política de protección de datos y privacidad en toda la Organización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=174"
  },
  {
    ID: 39,
    BudgetSection: 1,
    Entity: "ODPP",
    EntityFullName: "Oficina de Protección y Privacidad de los Datos",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Protección y Privacidad de los Datos",
    Title: "Mayor resiliencia institucional y mayor madurez en el diseño de medidas de protección y privacidad de los datos en la era de la inteligencia artificial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=174"
  },
  {
    ID: 40,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Oficina de Tecnologías Digitales y Emergentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Tecnologías Digitales y Emergentes",
    Title: "Los avances en el Pacto Digital Global se hacen evidentes para todas las partes interesadas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=182"
  },
  {
    ID: 41,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Oficina de Tecnologías Digitales y Emergentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Tecnologías Digitales y Emergentes",
    Title: "Fortalecimiento del compromiso multipartito con el Pacto Digital Global",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=182"
  },
  {
    ID: 42,
    BudgetSection: 1,
    Entity: "ODET",
    EntityFullName: "Oficina de Tecnologías Digitales y Emergentes",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Tecnologías Digitales y Emergentes",
    Title: "Cooperación avanzada en materia de gobernanza internacional de la inteligencia artificial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=183"
  },
  {
    ID: 43,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Alianza de Civilizaciones de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Alianza de Civilizaciones de las Naciones Unidas",
    Title: "Mayor implicación de los Estados Miembros en la promoción de una cultura de paz, el diálogo interreligioso e intercultural para el entendimiento mutuo y la respuesta a todas las formas de intolerancia religiosa",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=194"
  },
  {
    ID: 44,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Alianza de Civilizaciones de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Alianza de Civilizaciones de las Naciones Unidas",
    Title: "Mayor conciencia sobre las tendencias contemporáneas de la islamofobia entre los agentes estatales y no estatales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=195"
  },
  {
    ID: 45,
    BudgetSection: 1,
    Entity: "UNAOC",
    EntityFullName: "Alianza de Civilizaciones de las Naciones Unidas",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Alianza de Civilizaciones de las Naciones Unidas",
    Title: "Mejor coordinación en todo el sistema de las Naciones Unidas y participación de las partes interesadas para hacer frente al antisemitismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=196"
  },
  {
    ID: 46,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Oficina de Evaluación a Nivel de Todo el Sistema del Grupo de las Naciones Unidas para el Desarrollo Sostenible",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Evaluación a Nivel de Todo el Sistema del Grupo de las Naciones Unidas para el Desarrollo Sostenible",
    Title: "Los datos procedentes de evaluaciones a nivel de todo el sistema sirven de base para la toma de decisiones de la Iniciativa ONU80",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=205"
  },
  {
    ID: 47,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Oficina de Evaluación a Nivel de Todo el Sistema del Grupo de las Naciones Unidas para el Desarrollo Sostenible",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Evaluación a Nivel de Todo el Sistema del Grupo de las Naciones Unidas para el Desarrollo Sostenible",
    Title: "Mayor disponibilidad y uso de los resultados de las evaluaciones a nivel de todo el sistema",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=206"
  },
  {
    ID: 48,
    BudgetSection: 1,
    Entity: "UNSWE",
    EntityFullName: "Oficina de Evaluación a Nivel de Todo el Sistema del Grupo de las Naciones Unidas para el Desarrollo Sostenible",
    Programme: "Determinación de políticas, dirección y coordinación generales",
    Subprogramme: "Oficina de Evaluación a Nivel de Todo el Sistema del Grupo de las Naciones Unidas para el Desarrollo Sostenible",
    Title: "Mejor uso de los datos procedentes de evaluaciones del sistema de las Naciones Unidas por parte de los Estados Miembros y los órganos intergubernamentales en la adopción de decisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "1POLICY49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.1)&l=es#page=206"
  },
  {
    ID: 49,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Asuntos de la Asamblea General y del Consejo Económico y Social",
    Title: "Aumento del número de procesos oficiosos celebrados por los cofacilitadores nombrados por la Presidencia de la Asamblea General",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=9"
  },
  {
    ID: 50,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Asuntos de la Asamblea General y del Consejo Económico y Social",
    Title: "Las delegaciones disponen de información estandarizada sobre los trabajos de varios órganos intergubernamentales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=10"
  },
  {
    ID: 51,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Asuntos de la Asamblea General y del Consejo Económico y Social",
    Title: "Interacción más sencilla e intuitiva entre las delegaciones y la Secretaría a través de la plataforma e-deleGATE",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=10"
  },
  {
    ID: 52,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Asuntos de la Asamblea General y del Consejo Económico y Social",
    Title: "Mayor disponibilidad de los módulos de e-deleGATE para los órganos subsidiarios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=11"
  },
  {
    ID: 53,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Planificación y coordinación de los servicios de conferencias",
    Title: "Prestación de servicios para un mayor número de reuniones celebradas fuera de la Sede",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CA,CR,ET,FR,DE,MA,PA,QA,SA,ES,EI,TH,TM,UY",
    Image: "2DGACM5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=13"
  },
  {
    ID: 54,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Planificación y coordinación de los servicios de conferencias",
    Title: "Pasarela mundial para prestar servicios a conferencias y reuniones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=14"
  },
  {
    ID: 55,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Planificación y coordinación de los servicios de conferencias",
    Title: "Más opiniones de los Estados Miembros recabadas a través de la encuesta mundial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=15"
  },
  {
    ID: 56,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Planificación y coordinación de los servicios de conferencias",
    Title: "Operaciones resilientes gracias a la capacitación cruzada en los servicios de conferencias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=15"
  },
  {
    ID: 57,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de documentación",
    Title: "Puntualidad en la publicación de la documentación pese a las limitaciones",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=20"
  },
  {
    ID: 58,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de documentación",
    Title: "Documentación multilingüe de gran calidad gracias al marco de gestión de la calidad de la traducción",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=21"
  },
  {
    ID: 59,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de documentación",
    Title: "Puntualidad de la documentación para reuniones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=21"
  },
  {
    ID: 60,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de documentación",
    Title: "Respeto de la igualdad de trato de los idiomas oficiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=22"
  },
  {
    ID: 61,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de reuniones y publicaciones",
    Title: "Se mantiene la calidad y los organizadores de reuniones reportan eficiencias gracias a una gestión global integrada de los recursos de interpretación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=26"
  },
  {
    ID: 62,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de reuniones y publicaciones",
    Title: "Mayor disponibilidad de servicios de interpretación para satisfacer la creciente demanda de reuniones con interpretación de los Estados Miembros",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=27"
  },
  {
    ID: 63,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de reuniones y publicaciones",
    Title: "Mejores productos de publicaciones para los Estados Miembros y el público en general",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=28"
  },
  {
    ID: 64,
    BudgetSection: "2",
    Entity: "DGACM",
    EntityFullName: "Departamento de la Asamblea General y de Gestión de Conferencias",
    Programme: "Asuntos de la Asamblea General y del Consejo Económico y Social y gestión de conferencias",
    Subprogramme: "Servicios de reuniones y publicaciones",
    Title: "Se mantiene la cobertura de las reuniones aprovechando la tecnología interna de planificación de la interpretación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "2DGACM16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.2)&l=es#page=28"
  },
  {
    ID: 65,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Prevención, gestión y solución de conflictos",
    Title: "Los Estados Miembros y demás partes interesadas contribuyen al examen sobre el futuro de todos los tipos de operaciones de paz de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=14"
  },
  {
    ID: 66,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Prevención, gestión y solución de conflictos",
    Title: "Reducción de las amenazas a la paz y la seguridad internacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,LY,MZ,SD,QQ",
    Image: "3DPPA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=15"
  },
  {
    ID: 67,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Prevención, gestión y solución de conflictos",
    Title: "Las organizaciones regionales y subregionales tienen acceso a apoyo en materia de mediación, diplomacia preventiva y buenos oficios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=16"
  },
  {
    ID: 68,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Prevención, gestión y solución de conflictos",
    Title: "Los Estados Miembros tienen mejor acceso a apoyo rápido en materia de mediación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=16"
  },
  {
    ID: 69,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asistencia electoral",
    Title: "Mayor liderazgo y participación de las mujeres en los procesos electorales y políticos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=19"
  },
  {
    ID: 70,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asistencia electoral",
    Title: "Mayor representación de las mujeres en los procesos electorales y políticos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=20"
  },
  {
    ID: 71,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asistencia electoral",
    Title: "Fortalecimiento de la capacidad de los Estados Miembros que reciben asistencia electoral de las Naciones Unidas mediante iniciativas conjuntas con organizaciones regionales y subregionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=21"
  },
  {
    ID: 72,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asistencia electoral",
    Title: "Los Estados Miembros reciben respuestas oportunas y eficaces a las solicitudes de asistencia electoral de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=21"
  },
  {
    ID: 73,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asuntos del Consejo de Seguridad",
    Title: "Métodos de trabajo del Consejo de Seguridad mejorados mediante un examen más oportuno de las aportaciones de sus miembros",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=24"
  },
  {
    ID: 74,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asuntos del Consejo de Seguridad",
    Title: "Mejora de la participación de los Estados Miembros en la labor del Consejo de Seguridad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=25"
  },
  {
    ID: 75,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asuntos del Consejo de Seguridad",
    Title: "Mejor acceso de los Estados Miembros y el público a información analítica actualizada sobre la práctica y la labor presentes del Consejo de Seguridad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=25"
  },
  {
    ID: 76,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Asuntos del Consejo de Seguridad",
    Title: "Los miembros del Consejo de Seguridad reciben información oportuna sobre la aplicación de las sanciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=26"
  },
  {
    ID: 77,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Descolonización",
    Title: "Mayor conciencia pública sobre la descolonización",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=29"
  },
  {
    ID: 78,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Descolonización",
    Title: "El Comité Especial tiene acceso a una lista actualizada de expertos en descolonización calificados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=30"
  },
  {
    ID: 79,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Descolonización",
    Title: "Mayor difusión de información sobre la descolonización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=30"
  },
  {
    ID: 80,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Descolonización",
    Title: "El Comité Especial tiene acceso a información mejorada sobre la asistencia prestada a los territorios no autónomos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=31"
  },
  {
    ID: 81,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cuestión de Palestina",
    Title: "Mayor implicación y apoyo al Comité por parte de los Estados Miembros",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=34"
  },
  {
    ID: 82,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cuestión de Palestina",
    Title: "Mejora de las actividades de divulgación pública del Comité sobre la cuestión de Palestina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=34"
  },
  {
    ID: 83,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cuestión de Palestina",
    Title: "Mejora de las exposiciones informativas del Comité y de la interacción con el Consejo de Seguridad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=35"
  },
  {
    ID: 84,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cuestión de Palestina",
    Title: "Mayor promoción y actividad pública del Comité sobre la cuestión de Palestina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=36"
  },
  {
    ID: 85,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Consolidación de la Paz y Apoyo a la Paz",
    Title: "Los Estados Miembros reforzaron sus estrategias y enfoques nacionales de prevención y consolidación de la paz",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "TD,MR,PG",
    Image: "3DPPA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=39"
  },
  {
    ID: 86,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Consolidación de la Paz y Apoyo a la Paz",
    Title: "Mayor hincapié en las transiciones de las misiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=39"
  },
  {
    ID: 87,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Consolidación de la Paz y Apoyo a la Paz",
    Title: "Fortalecimiento de la alianza con las instituciones financieras internacionales para las estrategias de consolidación de la paz y prevención de titularidad y liderazgo nacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=40"
  },
  {
    ID: 88,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Consolidación de la Paz y Apoyo a la Paz",
    Title: "Mayor inversión en iniciativas del Fondo para la Consolidación de la Paz que hayan demostrado tener efectos catalizadores",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=41"
  },
  {
    ID: 89,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cooperación entre las Naciones Unidas y la Liga de los Estados Árabes",
    Title: "Mayor cooperación entre la Liga de los Estados Árabes y las Naciones Unidas en materia de derechos de las mujeres y protección de los niños en los conflictos armados",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=44"
  },
  {
    ID: 90,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cooperación entre las Naciones Unidas y la Liga de los Estados Árabes",
    Title: "Avances de la Liga de los Estados Árabes en diplomacia preventiva, mediación y análisis",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=44"
  },
  {
    ID: 91,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cooperación entre las Naciones Unidas y la Liga de los Estados Árabes",
    Title: "Refuerzo de la interacción con la Secretaría General de la Liga de los Estados Árabes y sus Estados miembros",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=45"
  },
  {
    ID: 92,
    BudgetSection: "3",
    Entity: "DPPA",
    EntityFullName: "Departamento de Asuntos Políticos y de Consolidación de la Paz",
    Programme: "Asuntos políticos",
    Subprogramme: "Cooperación entre las Naciones Unidas y la Liga de los Estados Árabes",
    Title: "Fortalecimiento de la alianza entre las Naciones Unidas y la Liga de los Estados Árabes para promover la prevención de conflictos y el sostenimiento de la paz en la región árabe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,LB,IQ,JO,SA,LY,TN,MA,KW,DZ,BH,OM,QA,AE,MR,SO,PS,DJ,KM,YE,SD,QQ,SY",
    Image: "3DPPA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=46"
  },
  {
    ID: 93,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Title: "Planificación de la reconstrucción de Gaza con base empírica",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=70"
  },
  {
    ID: 94,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Title: "Avances en el logro de un Gobierno palestino único que administre todo el Territorio Palestino Ocupado en el contexto de una solución biestatal negociada",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=71"
  },
  {
    ID: 95,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Title: "Hacia un marco político para resolver el conflicto israelo-palestino",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "PS",
    Image: "3DPPA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=72"
  },
  {
    ID: 96,
    BudgetSection: "3",
    Entity: "UNSCO",
    EntityFullName: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de la Coordinadora Especial de las Naciones Unidas para el Proceso de Paz de Oriente Medio",
    Title: "Avances en la ejecución del Plan Integral para Poner Fin al Conflicto de Gaza, que hizo suyo el Consejo de Seguridad en la resolución 2803 (2025)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=72"
  },
  {
    ID: 97,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Programme: "Asuntos políticos",
    Subprogramme: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Title: "Optimización del examen de las reclamaciones por daños y perjuicios para agilizar el servicio prestado a los reclamantes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=80"
  },
  {
    ID: 98,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Programme: "Asuntos políticos",
    Subprogramme: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Title: "Reducción del número de reclamaciones no tramitadas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "PS",
    Image: "3DPPA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=81"
  },
  {
    ID: 99,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Programme: "Asuntos políticos",
    Subprogramme: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Title: "Mejora del proceso de rectificación para completar las reclamaciones deficientes recogidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "PS",
    Image: "3DPPA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=82"
  },
  {
    ID: 100,
    BudgetSection: "3",
    Entity: "UNRoD",
    EntityFullName: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Programme: "Asuntos políticos",
    Subprogramme: "Registro de las Naciones Unidas de los Daños y Perjuicios Causados por la Construcción del Muro en el Territorio Palestino Ocupado",
    Title: "Fortalecimiento de la adopción de decisiones de la Junta mediante un proceso de presentación armonizado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PS",
    Image: "3DPPA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=82"
  },
  {
    ID: 101,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Oficina de las Naciones Unidas ante la Unión Africana",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de las Naciones Unidas ante la Unión Africana",
    Title: "Se llevó a cabo la transición en materia de seguridad en Somalia y se fortalecieron las capacidades de apoyo a la paz de la Unión Africana",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "3DPPA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=92"
  },
  {
    ID: 102,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Oficina de las Naciones Unidas ante la Unión Africana",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de las Naciones Unidas ante la Unión Africana",
    Title: "Incremento de la participación de la juventud en las iniciativas de paz y seguridad en África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=93"
  },
  {
    ID: 103,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Oficina de las Naciones Unidas ante la Unión Africana",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de las Naciones Unidas ante la Unión Africana",
    Title: "Intensificación de los esfuerzos conjuntos de las Naciones Unidas y la Unión Africana en la prevención y mediación de conflictos, el sostenimiento de la paz y el tratamiento de las causas profundas de los conflictos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=94"
  },
  {
    ID: 104,
    BudgetSection: "3",
    Entity: "UNOAU",
    EntityFullName: "Oficina de las Naciones Unidas ante la Unión Africana",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de las Naciones Unidas ante la Unión Africana",
    Title: "Mayor participación significativa, liderazgo e influencia de las mujeres en los procesos de paz y seguridad en África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "3DPPA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=94"
  },
  {
    ID: 105,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Oficina de Lucha contra el Terrorismo",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Lucha contra el Terrorismo",
    Title: "Una red mundial para que las víctimas del terrorismo defiendan sus derechos, influyan en las políticas y accedan a servicios de apoyo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=109"
  },
  {
    ID: 106,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Oficina de Lucha contra el Terrorismo",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Lucha contra el Terrorismo",
    Title: "Los Estados Miembros impulsan sus iniciativas para combatir el uso de armas por terroristas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=110"
  },
  {
    ID: 107,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Oficina de Lucha contra el Terrorismo",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Lucha contra el Terrorismo",
    Title: "Mejora de las capacidades nacionales de lucha contra el terrorismo mediante el refuerzo de la coordinación interinstitucional y de las competencias de los analistas de inteligencia para prevenir y contrarrestar el terrorismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=111"
  },
  {
    ID: 108,
    BudgetSection: "3",
    Entity: "OCT",
    EntityFullName: "Oficina de Lucha contra el Terrorismo",
    Programme: "Asuntos políticos",
    Subprogramme: "Oficina de Lucha contra el Terrorismo",
    Title: "Mayor capacidad nacional para contrarrestar la utilización de sistemas de aeronaves no tripuladas con fines terroristas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "3DPPA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.3)&l=es#page=111"
  },
  {
    ID: 109,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Negociaciones y deliberaciones multilaterales sobre desarme y limitación de armamentos",
    Title: "Mayor número de informes de las Altas Partes Contratantes de la Convención sobre Prohibiciones o Restricciones del Empleo de Ciertas Armas Convencionales que Puedan Considerarse Excesivamente Nocivas o de Efectos Indiscriminados",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=9"
  },
  {
    ID: 110,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Negociaciones y deliberaciones multilaterales sobre desarme y limitación de armamentos",
    Title: "Intensificación de las deliberaciones y posibles negociaciones en la Conferencia de Desarme",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=10"
  },
  {
    ID: 111,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Negociaciones y deliberaciones multilaterales sobre desarme y limitación de armamentos",
    Title: "Prevención de la carrera armamentista en el espacio ultraterrestre",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=11"
  },
  {
    ID: 112,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Negociaciones y deliberaciones multilaterales sobre desarme y limitación de armamentos",
    Title: "Abordar las tecnologías emergentes en el ámbito de los sistemas de armas autónomos letales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=11"
  },
  {
    ID: 113,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme",
    Title: "Los Estados Miembros de la región de Asia y el Pacífico identifican posibles sinergias para colaborar con los instrumentos destinados a hacer frente a la amenaza que suponen la proliferación o el empleo de las armas biológicas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Estados Miembros de América Latina y el Caribe ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "4ODA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=15"
  },
  {
    ID: 114,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme",
    Title: "Proceso destinado a crear en Oriente Medio de una zona libre de armas nucleares y otras armas de destrucción masiva",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,DJ,EG,QG,IR,IQ,JO,KW,LB,LY,MA,OM,QA,SA,SY,TN,AE,PS,YE",
    Image: "4ODA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=16"
  },
  {
    ID: 115,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme",
    Title: "Mejor preparación del Mecanismo del Secretario General para la Investigación del Presunto Empleo de Armas Químicas y Biológicas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=17"
  },
  {
    ID: 116,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme",
    Title: "El Grupo de Expertos Científicos y Técnicos sobre la Verificación del Desarme Nuclear contribuye a la mejor comprensión de las dificultades técnicas y los posibles enfoques de la verificación del desarme nuclear",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=18"
  },
  {
    ID: 117,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Armas convencionales",
    Title: "Mejor comprensión de las consecuencias del aumento global del gasto militar en la consecución de los Objetivos de Desarrollo Sostenible y propuestas para mitigarlas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=23"
  },
  {
    ID: 118,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Armas convencionales",
    Title: "Mayor utilización del mecanismo de asistencia global para la gestión de las municiones durante todo el ciclo de vida",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=24"
  },
  {
    ID: 119,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Armas convencionales",
    Title: "Abordar los avances en la fabricación, la tecnología y el diseño de armas pequeñas y armas ligeras a fin de prevenir, combatir y eliminar su tráfico ilícito y su uso indebido",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=25"
  },
  {
    ID: 120,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Armas convencionales",
    Title: "Mayor capacidad técnica para impulsar la aplicación del Programa de Acción sobre las Armas Pequeñas y Ligeras y su Instrumento Internacional de Localización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=25"
  },
  {
    ID: 121,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme regional, creación de capacidad y extensión",
    Title: "Experiencia nacional en materia de desarme fortalecida para impulsar las iniciativas de desarme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SR,ZM",
    Image: "4ODA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=29"
  },
  {
    ID: 122,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme regional, creación de capacidad y extensión",
    Title: "Mecanismo Mundial sobre los avances en la esfera de las tecnologías de la información y las comunicaciones en el contexto de la seguridad internacional y el fomento de un comportamiento responsable de los Estados en el uso de las tecnologías de la información y las comunicaciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=30"
  },
  {
    ID: 123,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Negociaciones y deliberaciones multilaterales sobre desarme y limitación de armamentos",
    Title: "Conocimientos especializados en materia de desarme fortalecidos mediante el Programa de las Naciones Unidas de Becas, Capacitación y Servicios de Asesoramiento sobre Desarme",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=34"
  },
  {
    ID: 124,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Información y divulgación",
    Title: "Empoderamiento de los jóvenes en la esfera del desarme y la no proliferación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=34"
  },
  {
    ID: 125,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Información y divulgación",
    Title: "Mayor concienciación sobre las cuestiones de desarme y no proliferación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=35"
  },
  {
    ID: 126,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme regional",
    Title: "Sensibilización y apoyo a nivel regional, subregional y nacional para la aplicación del Marco Global para la Gestión de las Municiones Convencionales durante Todo el Ciclo de Vida",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=36"
  },
  {
    ID: 127,
    BudgetSection: "4",
    Entity: "ODA",
    EntityFullName: "Oficina de Asuntos de Desarme",
    Programme: "Desarme",
    Subprogramme: "Desarme regional",
    Title: "Mayor integración del desarme en los marcos nacionales de desarrollo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarme",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avance de los esfuerzos y las iniciativas de desarme, no proliferación y control de armamentos",
    SpecificResultOrder: 4,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "4ODA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.4)&l=es#page=36"
  },
  {
    ID: 128,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Operaciones",
    Title: "Avances en la implementación del Acuerdo Político de 2019 para la Paz y la Reconciliación en la República Centroafricana",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF",
    Image: "5DPO1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=9"
  },
  {
    ID: 129,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Operaciones",
    Title: "Avances en la aplicación del Acuerdo Revitalizado para la Solución del Conflicto en la República de Sudán del Sur, de 2018",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SS,II",
    Image: "5DPO2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=9"
  },
  {
    ID: 130,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Operaciones",
    Title: "Fortalecimiento de la consolidación de la paz en Abyei a través del Programa Conjunto de las Coordinadoras Residentes en el Sudán y Sudán del Sur en Abyei",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SS,II,SD,QQ",
    Image: "5DPO3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=10"
  },
  {
    ID: 131,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Operaciones",
    Title: "Mejora del desarme, la desmovilización, la repatriación, el reasentamiento y la reintegración de los combatientes extranjeros en la República Democrática del Congo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD",
    Image: "5DPO4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=11"
  },
  {
    ID: 132,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Asuntos militares",
    Title: "Mayor preparación para la transición y la retirada de las misiones de mantenimiento de la paz de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CY,LB,SS,II,SD,QQ",
    Image: "5DPO5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=14"
  },
  {
    ID: 133,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Asuntos militares",
    Title: "Las misiones establecen capacidades de eliminación de municiones explosivas para afrontar las amenazas que plantean los artefactos explosivos improvisados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LB",
    Image: "5DPO6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=14"
  },
  {
    ID: 134,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Asuntos militares",
    Title: "Las operaciones de paz responden a las amenazas de los sistemas de aeronaves no tripuladas hostiles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CD,ML",
    Image: "5DPO7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=15"
  },
  {
    ID: 135,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Asuntos militares",
    Title: "Las operaciones de paz refuerzan la vigilancia, el análisis y la respuesta ante la información errónea, la desinformación y el discurso de odio",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CD,LB,ML,SS,II",
    Image: "5DPO8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=16"
  },
  {
    ID: 136,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Estado de derecho e instituciones de seguridad",
    Title: "Capacidades nacionales y regionales reforzadas para mitigar las amenazas que plantean los artefactos explosivos improvisados",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=19"
  },
  {
    ID: 137,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Estado de derecho e instituciones de seguridad",
    Title: "Mejor desempeño de la policía de las Naciones Unidas para reforzar el cumplimiento del mandato",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=20"
  },
  {
    ID: 138,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Estado de derecho e instituciones de seguridad",
    Title: "Los Estados anfitriones están capacitados para continuar y mantener los avances en el estado de derecho y en la reforma de las instituciones de seguridad durante y después de la transición de las misiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CF,CD,ML,SO",
    Image: "5DPO11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=21"
  },
  {
    ID: 139,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Estado de derecho e instituciones de seguridad",
    Title: "Mayor rendición de cuentas por los delitos cometidos contra el personal de las Naciones Unidas destinado en operaciones de mantenimiento de la paz",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CF,CD,LB,ML",
    Image: "5DPO12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=22"
  },
  {
    ID: 140,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Políticas, evaluación y capacitación",
    Title: "Refuerzo de las políticas y las directrices para la protección de los civiles en las operaciones de apoyo a la paz dirigidas por la Unión Africana",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "5DPO13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=26"
  },
  {
    ID: 141,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Políticas, evaluación y capacitación",
    Title: "Una plataforma en línea para fomentar la colaboración directa entre los Estados Miembros sobre la preparación del personal de mantenimiento de la paz",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=27"
  },
  {
    ID: 142,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Políticas, evaluación y capacitación",
    Title: "Mejora del análisis y la planificación en las oficinas sobre el terreno para abordar la dinámica de los conflictos locales y promover soluciones políticas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=28"
  },
  {
    ID: 143,
    BudgetSection: "5",
    Entity: "DPO",
    EntityFullName: "Departamento de Operaciones de Paz",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Políticas, evaluación y capacitación",
    Title: "Refuerzo de la prevención y la respuesta a la violencia sexual relacionada con los conflictos en las operaciones de mantenimiento de la paz",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Disminución de la violencia sexual, también como táctica de guerra o terror, y de la violencia contra los niños, incluidas las violaciones graves que se cometen contra ellos en situaciones de conflicto armado",
    SpecificResultOrder: 19,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "5DPO16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=29"
  },
  {
    ID: 144,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Title: "Mayor vigilancia a lo largo de la línea de alto el fuego y en la zona de separación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=48"
  },
  {
    ID: 145,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Title: "Mayor colaboración en lo que respecta al mandato y la labor del Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=49"
  },
  {
    ID: 146,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Title: "Refuerzo de la capacidad organizativa para adaptarse a entornos operacionales cambiantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=50"
  },
  {
    ID: 147,
    BudgetSection: "5",
    Entity: "UNTSO",
    EntityFullName: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Organismo de las Naciones Unidas para la Vigilancia de la Tregua",
    Title: "Refuerzo de los mecanismos de planificación y coordinación en el sur del Líbano",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,IL,JO,LB,SY",
    Image: "5DPO20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=50"
  },
  {
    ID: 148,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Title: "Escaso número de denuncias por presuntas violaciones del alto el fuego",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=58"
  },
  {
    ID: 149,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Title: "Mejora de la conciencia situacional gracias a los sistemas de información geoespacial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=59"
  },
  {
    ID: 150,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Title: "Continuidad de la presencia en la línea de control",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "IN,AP,PK",
    Image: "5DPO23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=60"
  },
  {
    ID: 151,
    BudgetSection: "5",
    Entity: "UNMOGIP",
    EntityFullName: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Programme: "Operaciones de mantenimiento de la paz",
    Subprogramme: "Grupo de Observadores Militares de las Naciones Unidas en la India y el Pakistán",
    Title: "Mejor entendimiento mutuo gracias al refuerzo de las actividades de enlace y la colaboración",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "IN,AP,PK",
    Image: "5DPO24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.5)&l=es#page=60"
  },
  {
    ID: 152,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "La Oficina de Asuntos del Espacio Ultraterrestre",
    Programme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Subprogramme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Title: "Mejora de la planificación y la preparación ante objetos cercanos a la Tierra potencialmente peligrosos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "6COPUOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=es#page=6"
  },
  {
    ID: 153,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "La Oficina de Asuntos del Espacio Ultraterrestre",
    Programme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Subprogramme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Title: "Aumentar el acceso al espacio",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=es#page=7"
  },
  {
    ID: 154,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "La Oficina de Asuntos del Espacio Ultraterrestre",
    Programme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Subprogramme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Title: "Mayor acceso a soluciones espaciales, alianzas, creación de capacidad e implicación en la gobernanza de las actividades del espacio ultraterrestre",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "PMA, PDSL, PEID y otros países en desarrollo ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=es#page=7"
  },
  {
    ID: 155,
    BudgetSection: "6",
    Entity: "OOSA",
    EntityFullName: "La Oficina de Asuntos del Espacio Ultraterrestre",
    Programme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Subprogramme: "Utilización del espacio ultraterrestre con fines pacíficos",
    Title: "Mayor uso de la tecnología y los datos espaciales para la gestión de desastres y la respuesta de emergencia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Mantenimiento de la paz y la seguridad internacionales ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "6COPUOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.6)&l=es#page=8"
  },
  {
    ID: 156,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Corte Internacional de Justicia",
    Programme: "Corte Internacional de Justicia",
    Subprogramme: "Secretaría de la Corte",
    Title: "Mayor comprensión de las actividades de la Corte entre el público en general",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=es#page=4"
  },
  {
    ID: 157,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Corte Internacional de Justicia",
    Programme: "Corte Internacional de Justicia",
    Subprogramme: "Secretaría de la Corte",
    Title: "Proceso mejorado de transmisión y recepción de los documentos relativos a los procedimientos judiciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=es#page=4"
  },
  {
    ID: 158,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Corte Internacional de Justicia",
    Programme: "Corte Internacional de Justicia",
    Subprogramme: "Secretaría de la Corte",
    Title: "Mayor disponibilidad de información sobre la Corte en las plataformas de medios sociales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=es#page=5"
  },
  {
    ID: 159,
    BudgetSection: "7",
    Entity: "ICJ",
    EntityFullName: "Corte Internacional de Justicia",
    Programme: "Corte Internacional de Justicia",
    Subprogramme: "Secretaría de la Corte",
    Title: "Mayor visibilidad y comprensión de las actividades de la Corte entre los jóvenes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "7ICJ4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.7)&l=es#page=6"
  },
  {
    ID: 160,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos al sistema de las Naciones Unidas en su conjunto",
    Title: "Marcos jurídicos para el establecimiento de una nueva operación de las Naciones Unidas sobre el terreno en Haití y apoyo a la Fuerza de Represión de las Bandas en Haití",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "8OLA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=10"
  },
  {
    ID: 161,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos al sistema de las Naciones Unidas en su conjunto",
    Title: "Celebración de un acuerdo relativo a la continuación de las funciones residuales de las Salas Especiales de los Tribunales de Camboya",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KH",
    Image: "8OLA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=11"
  },
  {
    ID: 162,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos al sistema de las Naciones Unidas en su conjunto",
    Title: "Marco jurídico y procedimental para las conferencias de las Naciones Unidas, incluida la Conferencia de las Naciones Unidas sobre el Agua de 2026 para Acelerar la Consecución del Objetivo de Desarrollo Sostenible 6",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SN,AE",
    Image: "8OLA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=11"
  },
  {
    ID: 163,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos al sistema de las Naciones Unidas en su conjunto",
    Title: "Avance en las reformas y las transiciones institucionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=12"
  },
  {
    ID: 164,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos generales a los órganos y programas de las Naciones Unidas",
    Title: "Acceso de las oficinas clientes a las plantillas de contrato estándar",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=15"
  },
  {
    ID: 165,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos generales a los órganos y programas de las Naciones Unidas",
    Title: "Acceso de las oficinas clientes al asesoramiento jurídico facilitado por el sistema actualizado de gestión de casos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=16"
  },
  {
    ID: 166,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos generales a los órganos y programas de las Naciones Unidas",
    Title: "Acceso de las oficinas clientes a la versión actualizada de las Condiciones Generales de los Contratos de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=16"
  },
  {
    ID: 167,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Prestación de servicios jurídicos generales a los órganos y programas de las Naciones Unidas",
    Title: "Acceso de las oficinas clientes a un contrato modelo actualizado para la prestación de servicios de transporte aéreo de mercancías",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=17"
  },
  {
    ID: 168,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Desarrollo progresivo y codificación del derecho internacional",
    Title: "El Comité Especial de la Carta de las Naciones Unidas y del Fortalecimiento del Papel de la Organización aprobó un informe sustantivo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=18"
  },
  {
    ID: 169,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Desarrollo progresivo y codificación del derecho internacional",
    Title: "Solicitudes de un mayor número de Estados para participar en los programas de capacitación en derecho internacional en el marco del Programa de Asistencia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=19"
  },
  {
    ID: 170,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Desarrollo progresivo y codificación del derecho internacional",
    Title: "Mayor acceso de la comunidad jurídica internacional al material documental de carácter jurídico relativo a las Naciones Unidas y las organizaciones intergubernamentales conexas que se recoge en el Anuario Jurídico de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=20"
  },
  {
    ID: 171,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Desarrollo progresivo y codificación del derecho internacional",
    Title: "Mejor comprensión de las cuestiones jurídicas relativas al arreglo de controversias en las que son parte organizaciones internacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=20"
  },
  {
    ID: 172,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Derecho del mar y asuntos oceánicos",
    Title: "Se cumplen las condiciones necesarias para la entrada en vigor del Acuerdo relativo a la Diversidad Biológica Marina de las Zonas Situadas Fuera de la Jurisdicción Nacional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=23"
  },
  {
    ID: 173,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Derecho del mar y asuntos oceánicos",
    Title: "Mayor compromiso de los Estados Miembros con la conservación y el uso sostenible de los océanos y sus recursos mediante la aplicación del derecho internacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=24"
  },
  {
    ID: 174,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Derecho del mar y asuntos oceánicos",
    Title: "Refuerzo de la interfaz ciencia-política para la protección del medio marino y la conservación y el uso sostenible de los recursos marinos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=25"
  },
  {
    ID: 175,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Derecho del mar y asuntos oceánicos",
    Title: "Papel destacado de la Comisión de Límites de la Plataforma Continental y de sus subcomisiones de conformidad con la Convención de las Naciones Unidas sobre el Derecho del Mar",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=25"
  },
  {
    ID: 176,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Armonización, modernización y unificación progresivas del derecho mercantil internacional",
    Title: "Mejora de la capacidad judicial para aplicar las orientaciones recogidas en los textos sobre el régimen de la insolvencia de la Comisión de las Naciones Unidas para el Derecho Mercantil Internacional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=30"
  },
  {
    ID: 177,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Armonización, modernización y unificación progresivas del derecho mercantil internacional",
    Title: "Mayor seguridad jurídica para las operaciones comerciales de datos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=31"
  },
  {
    ID: 178,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Armonización, modernización y unificación progresivas del derecho mercantil internacional",
    Title: "La Comisión de las Naciones Unidas para el Derecho Mercantil Internacional examina la pertinencia de sus instrumentos sobre el régimen de contratación pública",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=31"
  },
  {
    ID: 179,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Armonización, modernización y unificación progresivas del derecho mercantil internacional",
    Title: "Aplicación de las reformas en el sistema de solución de controversias entre inversionistas y Estados mediante un mecanismo multilateral de convención marco",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=32"
  },
  {
    ID: 180,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Custodia, registro y publicación de tratados",
    Title: "Apertura a la firma de la Convención de las Naciones Unidas contra la Ciberdelincuencia; Fortalecimiento de la Cooperación Internacional para la Lucha contra Determinados Delitos Cometidos mediante Sistemas de Tecnología de la Información y las Comunicaciones y para la Transmisión de Pruebas en Forma Electrónica de Delitos Graves",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=35"
  },
  {
    ID: 181,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Custodia, registro y publicación de tratados",
    Title: "Los Estados Miembros avanzan en el debate sobre la práctica en materia de tratados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=36"
  },
  {
    ID: 182,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Custodia, registro y publicación de tratados",
    Title: "Los tratados y los actos conexos se ponen a disposición del público en la United Nations Treaty Series",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=37"
  },
  {
    ID: 183,
    BudgetSection: "8",
    Entity: "OLA",
    EntityFullName: "Oficina de Asuntos Jurídicos",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Custodia, registro y publicación de tratados",
    Title: "Los Estados Miembros abordan el papel de la cooperación internacional, en particular en lo que respecta a la utilización de la tecnología y la creación de capacidad, en el fortalecimiento del marco de tratados internacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "8OLA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=37"
  },
  {
    ID: 184,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mecanismo Independiente de Investigación para Myanmar",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Independiente de Investigación para Myanmar",
    Title: "Las autoridades competentes tienen acceso al análisis forense de la información de fuentes de código abierto",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=63"
  },
  {
    ID: 185,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mecanismo Independiente de Investigación para Myanmar",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Independiente de Investigación para Myanmar",
    Title: "Víctimas, supervivientes, la sociedad civil y proveedores de información participan en procesos de rendición de cuentas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=64"
  },
  {
    ID: 186,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mecanismo Independiente de Investigación para Myanmar",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Independiente de Investigación para Myanmar",
    Title: "Mejor acceso a pruebas cuya admisibilidad esté lo más garantizada posible en los tribunales nacionales, regionales e internacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "MM",
    Image: "8OLA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=64"
  },
  {
    ID: 187,
    BudgetSection: "8",
    Entity: "IIMM",
    EntityFullName: "Mecanismo Independiente de Investigación para Myanmar",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Independiente de Investigación para Myanmar",
    Title: "Los testigos y las fuentes contribuyen a las iniciativas de rendición de cuentas de forma segura y con el apoyo psicosocial necesario",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "MM",
    Image: "8OLA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=65"
  },
  {
    ID: 188,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Title: "Medidas para una justicia de transición dirigida por Siria",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=75"
  },
  {
    ID: 189,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Title: "Mayor protección y apoyo a las víctimas, testigos u otras fuentes que cooperen con el Mecanismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SY",
    Image: "8OLA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=76"
  },
  {
    ID: 190,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Title: "Un enfoque integrado para una justicia inclusiva",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SY",
    Image: "8OLA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=76"
  },
  {
    ID: 191,
    BudgetSection: "8",
    Entity: "IIIM",
    EntityFullName: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Programme: "Asuntos jurídicos",
    Subprogramme: "Mecanismo Internacional, Imparcial e Independiente para Ayudar en la Investigación y el Enjuiciamiento de los Responsables de los Delitos de Derecho Internacional Más Graves Cometidos en la República Árabe Siria desde Marzo de 2011",
    Title: "Verdad, justicia y rendición de cuentas, asumidas como propias por los sirios y bajo su dirección, en relación con los delitos de derecho internacional más graves cometidos en la República Árabe Siria desde Marzo de 2011",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de la justicia y el derecho internacional ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SY",
    Image: "8OLA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.8)&l=es#page=77"
  },
  {
    ID: 192,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Apoyo intergubernamental y coordinación para el desarrollo sostenible",
    Title: "Compromiso político reafirmado con la Agenda 2030 para el Desarrollo Sostenible en su décimo aniversario",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=18"
  },
  {
    ID: 193,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Apoyo intergubernamental y coordinación para el desarrollo sostenible",
    Title: "Papel reforzado del Consejo Económico y Social para ayudar a los Estados Miembros a transformar los compromisos de la Cumbre sobre los Objetivos de Desarrollo Sostenible en acciones y políticas nacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=19"
  },
  {
    ID: 194,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Apoyo intergubernamental y coordinación para el desarrollo sostenible",
    Title: "Consecución acelerada de los Objetivos de Desarrollo Sostenible mediante un proceso preparatorio eficaz de los exámenes nacionales voluntarios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=19"
  },
  {
    ID: 195,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Apoyo intergubernamental y coordinación para el desarrollo sostenible",
    Title: "Orientación reforzada del Consejo Económico y Social al sistema de las Naciones Unidas para el desarrollo con el fin de mejorar la ejecución de las actividades operacionales para el desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=20"
  },
  {
    ID: 196,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo social inclusivo",
    Title: "El informe World Social Report 2025 sirvió de base para el diálogo sobre políticas sociales en los organismos intergubernamentales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=24"
  },
  {
    ID: 197,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo social inclusivo",
    Title: "Mayor coherencia de los esfuerzos del sistema de las Naciones Unidas para atender las necesidades de los Pueblos Indígenas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=24"
  },
  {
    ID: 198,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo social inclusivo",
    Title: "Desarrollo social acelerado a través de la Segunda Cumbre Mundial sobre Desarrollo Social",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=25"
  },
  {
    ID: 199,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo social inclusivo",
    Title: "Calidad de vida de las personas mayores mejorada a través del quinto examen y evaluación de la aplicación del Plan de Acción Internacional de Madrid sobre el Envejecimiento",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=25"
  },
  {
    ID: 200,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo sostenible",
    Title: "Plan de implementación del Decenio de las Naciones Unidas para el Transporte Sostenible (2026-2035) puesto en marcha",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=28"
  },
  {
    ID: 201,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo sostenible",
    Title: "Progresos acelerados en la consecución del Objetivo de Desarrollo Sostenible 14 mediante la Tercera Conferencia de las Naciones Unidas sobre el Océano",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=29"
  },
  {
    ID: 202,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo sostenible",
    Title: "Aceleración de la consecución del Objetivo de Desarrollo Sostenible 6 mediante la Conferencia de las Naciones Unidas sobre el Agua de 2026",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=30"
  },
  {
    ID: 203,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Desarrollo sostenible",
    Title: "El Informe mundial sobre el desarrollo sostenible 2027 orienta la implementación de la Agenda 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=30"
  },
  {
    ID: 204,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Estadística",
    Title: "Los usuarios comprenden mejor las estadísticas sobre migración",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=34"
  },
  {
    ID: 205,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Estadística",
    Title: "Modernización de UNdata",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=34"
  },
  {
    ID: 206,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Estadística",
    Title: "Capacidad mundial mejorada para el seguimiento con base empírica de los avances en la consecución de los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=35"
  },
  {
    ID: 207,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Estadística",
    Title: "Los Estados Miembros aplican el Sistema de Cuentas Nacionales de 2025",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=35"
  },
  {
    ID: 208,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Población",
    Title: "Proyecciones demográficas a nivel nacional y de distrito elaboradas mediante métodos probabilísticos reconocidos internacionalmente",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UG",
    Image: "9DESA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=40"
  },
  {
    ID: 209,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Población",
    Title: "Mejor comparabilidad de las estimaciones y proyecciones de urbanización y distribución espacial para los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=40"
  },
  {
    ID: 210,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Población",
    Title: "Herramientas en línea mejoradas para el análisis, la proyección y la visualización de datos demográficos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=41"
  },
  {
    ID: 211,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Población",
    Title: "Fortalecimiento de la base de pruebas de la migración internacional para respaldar la formulación de políticas y promover un debate público bien fundamentado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=42"
  },
  {
    ID: 212,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Políticas y análisis económicos",
    Title: "Herramientas digitales mejoradas para reforzar los conocimientos de los funcionarios públicos en materia de macroeconomía y comercio",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=45"
  },
  {
    ID: 213,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Políticas y análisis económicos",
    Title: "Uso de herramientas avanzadas de simulación de políticas para la elaboración de políticas basadas en datos y con base empírica",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=46"
  },
  {
    ID: 214,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Políticas y análisis económicos",
    Title: "Mayor colaboración y uso de productos analíticos para la formulación de políticas con base empírica",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=47"
  },
  {
    ID: 215,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Políticas y análisis económicos",
    Title: "Los países menos adelantados están preparados para afrontar el proceso de graduación y la situación posterior",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "9DESA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=47"
  },
  {
    ID: 216,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Instituciones y transformación digital",
    Title: "Las entidades fiscalizadoras superiores evaluaron la implementación del Objetivo de Desarrollo Sostenible 13, relativo a la acción climática",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=51"
  },
  {
    ID: 217,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Instituciones y transformación digital",
    Title: "Aplicación nacional de los principios de gobernanza eficaz para el desarrollo sostenible a fin de aumentar la confianza en las instituciones públicas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=52"
  },
  {
    ID: 218,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Instituciones y transformación digital",
    Title: "Respuesta eficaz y resiliente a desafíos y oportunidades futuros para acelerar el desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=53"
  },
  {
    ID: 219,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Instituciones y transformación digital",
    Title: "Los funcionarios públicos aplican los conocimientos conductuales y adoptan buenas prácticas para impulsar la innovación y la transformación digital",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=53"
  },
  {
    ID: 220,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Gestión forestal sostenible",
    Title: "Los Estados Miembros comienzan a aplicar el nuevo programa de trabajo cuatrienal (20252028) para acelerar la ejecución del Plan Estratégico de las Naciones Unidas para los Bosques",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=57"
  },
  {
    ID: 221,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Gestión forestal sostenible",
    Title: "Mayor alcance del Foro de las Naciones Unidas sobre los Bosques y contribución de los bosques a la Agenda 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=58"
  },
  {
    ID: 222,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Gestión forestal sostenible",
    Title: "Avance de los Objetivos de Desarrollo Sostenible a través del Plan Estratégico de las Naciones Unidas para los Bosques 2017-2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=58"
  },
  {
    ID: 223,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Gestión forestal sostenible",
    Title: "Fortalecimiento del compromiso y la acción del Acuerdo Internacional sobre los Bosques para alcanzar los Objetivos Forestales Mundiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=59"
  },
  {
    ID: 224,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Financiación para el desarrollo sostenible",
    Title: "Un nuevo marco de financiación, el Compromiso de Sevilla, adoptado como continuación de la Agenda de Acción de Addis Abeba",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=63"
  },
  {
    ID: 225,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Financiación para el desarrollo sostenible",
    Title: "Mayor participación de los Estados Miembros en el proceso de seguimiento de la financiación para el desarrollo a fin de mejorar la coherencia y la aplicación de los resultados acordados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=63"
  },
  {
    ID: 226,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Financiación para el desarrollo sostenible",
    Title: "Mayor participación de los países en desarrollo en la elaboración de normas fiscales internacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=64"
  },
  {
    ID: 227,
    BudgetSection: "9",
    Entity: "DESA",
    EntityFullName: "Departamento de Asuntos Económicos y Sociales",
    Programme: "Asuntos económicos y sociales",
    Subprogramme: "Financiación para el desarrollo sostenible",
    Title: "Se pone en marcha la arquitectura de la deuda internacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "9DESA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.9)&l=es#page=65"
  },
  {
    ID: 228,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países menos adelantados",
    Title: "Ejecución acelerada y mejor seguimiento del Programa de Acción de Doha en favor de los Países Menos Adelantados",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=9"
  },
  {
    ID: 229,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países menos adelantados",
    Title: "Un nuevo mecanismo de constitución de reservas de alimentos para reducir la inseguridad alimentaria en los países menos adelantados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=9"
  },
  {
    ID: 230,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países menos adelantados",
    Title: "Mayor resiliencia frente a las perturbaciones externas en los países menos adelantados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=10"
  },
  {
    ID: 231,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países menos adelantados",
    Title: "Los países menos adelantados refuerzan las vías para una graduación sostenible e irreversible de la categoría de país menos adelantado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,SD,QQ,BJ,BF,BI,KH,CF,TD,KM,CD,DJ,ER,ET,GM,GN,GW,HT,KI,LA,LS,LR,MG,MW,ML,MR,MZ,MM,NP,NE,RW,SN,SL,SB,SO,SS,II,SD,QQ,TL,TG,TV,UG,TZ,YE,ZM",
    Image: "10UNOHRLLS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=11"
  },
  {
    ID: 232,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países en desarrollo sin litoral",
    Title: "Aprobación de la Declaración Política de Avaza durante la Tercera Conferencia de las Naciones Unidas sobre los Países en Desarrollo Sin Litoral",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=14"
  },
  {
    ID: 233,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países en desarrollo sin litoral",
    Title: "Iniciativas estratégicas de financiación del desarrollo para aumentar la resiliencia económica de los países en desarrollo sin litoral",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=15"
  },
  {
    ID: 234,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países en desarrollo sin litoral",
    Title: "Avance de las cuestiones en materia de libertad de tránsito para los países en desarrollo sin litoral",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=15"
  },
  {
    ID: 235,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Países en desarrollo sin litoral",
    Title: "Transversalización del Programa de Acción de Avaza en favor de los Países en Desarrollo Sin Litoral en las estrategias nacionales y sectoriales de desarrollo, los marcos de cooperación para el desarrollo y los planes estratégicos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AZ,BT,BO,BW,BF,BI,CF,TD,SZ,ET,KZ,KG,LA,LS,MK,MW,ML,MN,NP,NE,PY,MD,RW,SS,II,TJ,TM,UG,UZ,ZM,ZW",
    Image: "10UNOHRLLS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=16"
  },
  {
    ID: 236,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Pequeños Estados insulares en desarrollo",
    Title: "Promover la sostenibilidad de la deuda de los pequeños Estados insulares en desarrollo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=19"
  },
  {
    ID: 237,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Pequeños Estados insulares en desarrollo",
    Title: "Decisiones basadas en datos para subsanar las vulnerabilidades estructurales y abordar la resiliencia de los pequeños Estados insulares en desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=20"
  },
  {
    ID: 238,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Pequeños Estados insulares en desarrollo",
    Title: "Los pequeños Estados insulares en desarrollo utilizan el marco de seguimiento y presentación de informes de la Agenda de Antigua y Barbuda para los Pequeños Estados Insulares en Desarrollo para fundamentar las estrategias nacionales de planificación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=21"
  },
  {
    ID: 239,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Pequeños Estados insulares en desarrollo",
    Title: "Facilitar alianzas estratégicas que aceleren la aplicación de la Agenda de Antigua y Barbuda para los Pequeños Estados Insulares en Desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM,CK,MV,MU,SC,AG,BS,BD,BZ,CU,DM,DO,GD,HT,JM,KN,LC,VC,SR,TT,FJ,KI,MH,FM,NR,NU,PW,PG,WS,SB,TL,TO,TV,VU",
    Image: "10UNOHRLLS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=21"
  },
  {
    ID: 240,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Promoción, divulgación y análisis",
    Title: "Mayor integración de los tres programas de acción en los procesos intergubernamentales pertinentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=24"
  },
  {
    ID: 241,
    BudgetSection: "10",
    Entity: "UN-OHRLLS",
    EntityFullName: "La Oficina del Alto Representante para los Países Menos Adelantados, los Países en Desarrollo sin Litoral y los Pequeños Estados Insulares en Desarrollo",
    Programme: "Países menos adelantados, países en desarrollo sin litoral y pequeños Estados insulares en desarrollo",
    Subprogramme: "Promoción, divulgación y análisis",
    Title: "Análisis y seguimiento en tiempo real de los tres programas de acción para fundamentar la formulación de políticas, la planificación y la toma de decisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "10UNOHRLLS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.10)&l=es#page=25"
  },
  {
    ID: 242,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Gestión de datos y del conocimiento para formular políticas y actividades de promoción con base empírica en apoyo de la Agenda 2063",
    Title: "Los encargados de formular políticas en África aplicaron enfoques analíticos integrados para obtener resultados a largo plazo en materia de paz y desarrollo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=9"
  },
  {
    ID: 243,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Gestión de datos y del conocimiento para formular políticas y actividades de promoción con base empírica en apoyo de la Agenda 2063",
    Title: "Soluciones digitales para transformar los sistemas financieros y gestionar la deuda en África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=10"
  },
  {
    ID: 244,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Gestión de datos y del conocimiento para formular políticas y actividades de promoción con base empírica en apoyo de la Agenda 2063",
    Title: "Ecosistemas políticos para equipar a la fuerza de trabajo de África en una economía digital global",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=10"
  },
  {
    ID: 245,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Gestión de datos y del conocimiento para formular políticas y actividades de promoción con base empírica en apoyo de la Agenda 2063",
    Title: "Fortalecimiento de las políticas sobre educación y desarrollo de las aptitudes de los jóvenes para hacer frente a la inseguridad alimentaria y promover la resiliencia ante el clima en África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=11"
  },
  {
    ID: 246,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Coordinación regional del apoyo de las Naciones Unidas a la implementación integrada de la Agenda 2030 para el Desarrollo Sostenible y la Agenda 2063",
    Title: "Estrategia de movilización de recursos internos adoptada para financiar el segundo plan decenal de implementación de la Agenda 2063",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=14"
  },
  {
    ID: 247,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Coordinación regional del apoyo de las Naciones Unidas a la implementación integrada de la Agenda 2030 para el Desarrollo Sostenible y la Agenda 2063",
    Title: "Estrategias a largo plazo para la gestión de la deuda en África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=15"
  },
  {
    ID: 248,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Coordinación regional del apoyo de las Naciones Unidas a la implementación integrada de la Agenda 2030 para el Desarrollo Sostenible y la Agenda 2063",
    Title: "Mayor rendición de cuentas y capacidad de respuesta de las instituciones públicas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Administración pública ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=15"
  },
  {
    ID: 249,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Coordinación regional del apoyo de las Naciones Unidas a la implementación integrada de la Agenda 2030 para el Desarrollo Sostenible y la Agenda 2063",
    Title: "Los Estados Miembros africanos formulan políticas para hacer frente a los efectos del cambio climático",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=16"
  },
  {
    ID: 250,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Actividades de información y sensibilización pública en apoyo de la Agenda 2063",
    Title: "Las alianzas con los medios, con un alcance de 130 millones de personas, destacan las perspectivas africanas sobre la inteligencia artificial y el empleo digital",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=19"
  },
  {
    ID: 251,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Actividades de información y sensibilización pública en apoyo de la Agenda 2063",
    Title: "Participación del público en general en el tema de la carga de la deuda en África y las posibles soluciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=20"
  },
  {
    ID: 252,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Actividades de información y sensibilización pública en apoyo de la Agenda 2063",
    Title: "Refuerzo de la divulgación sobre educación, empleo digno y protección social en África por parte de los medios de comunicación asociados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=20"
  },
  {
    ID: 253,
    BudgetSection: "11",
    Entity: "OSAA",
    EntityFullName: "La Oficina del Asesor Especial para África",
    Programme: "Apoyo del sistema de las Naciones Unidas a la Agenda 2063 de la Unión Africana: el África que Queremos",
    Subprogramme: "Actividades de información y sensibilización pública en apoyo de la Agenda 2063",
    Title: "Mayor visibilidad de las soluciones impulsadas por la juventud para la resiliencia ante el clima",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Estados Miembros de África ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "11NEPAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.11)&l=es#page=21"
  },
  {
    ID: 254,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Globalización, interdependencia y desarrollo",
    Title: "El informe Trade and Development Foresights sirve de base para los debates y las respuestas en materia de políticas a nivel mundial",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "PMA, PDSL, PEID y otros países en desarrollo ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=13"
  },
  {
    ID: 255,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Globalización, interdependencia y desarrollo",
    Title: "Mayor transparencia de los datos sobre la deuda de los países en desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EC,EG,QG,JO",
    Image: "12UNCTAD2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=14"
  },
  {
    ID: 256,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Globalización, interdependencia y desarrollo",
    Title: "Las economías en desarrollo diseñan políticas industriales y de transformación estructural sostenibles a través de la cooperación Sur-Sur y triangular",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KZ,MY,PK,TR",
    Image: "12UNCTAD3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=15"
  },
  {
    ID: 257,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Globalización, interdependencia y desarrollo",
    Title: "Los países prestatarios gestionan la deuda de una manera más eficiente y sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=15"
  },
  {
    ID: 258,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Inversión y empresa",
    Title: "Refuerzo de los ecosistemas de emprendimiento para un desarrollo empresarial inclusivo e innovador",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: " ",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=20"
  },
  {
    ID: 259,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Inversión y empresa",
    Title: "Inversión acelerada en los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=20"
  },
  {
    ID: 260,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Inversión y empresa",
    Title: "Los Estados miembros fomentan un clima propicio empresarial y de inversión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: " ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=21"
  },
  {
    ID: 261,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Inversión y empresa",
    Title: "Mayor adopción de prácticas de inversión sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=22"
  },
  {
    ID: 262,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Comercio internacional y productos básicos",
    Title: "Mayor seguridad de los productos de consumo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=27"
  },
  {
    ID: 263,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Comercio internacional y productos básicos",
    Title: "Aplicación reforzada por los países en desarrollo de las contribuciones determinadas a nivel nacional mediante políticas comerciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GM",
    Image: "12UNCTAD10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=28"
  },
  {
    ID: 264,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Comercio internacional y productos básicos",
    Title: "Los Estados miembros aprovechan los minerales esenciales de la transición energética para el desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NA,ZM",
    Image: "12UNCTAD11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=29"
  },
  {
    ID: 265,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Comercio internacional y productos básicos",
    Title: "Datos actualizados sobre medidas no arancelarias para mejorar las prácticas reguladoras y el desarrollo económico",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=30"
  },
  {
    ID: 266,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Tecnología y logística",
    Title: "Los países en desarrollo impulsan la conceptualización y el desarrollo de parques científicos, tecnológicos y de innovación para el desarrollo sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "PMA, PDSL, PEID y otros países en desarrollo ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,MN,MZ,UZ",
    Image: "12UNCTAD13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=36"
  },
  {
    ID: 267,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Tecnología y logística",
    Title: "Mayor disponibilidad de estadísticas de economía digital en los países en desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=36"
  },
  {
    ID: 268,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Tecnología y logística",
    Title: "Mayor eficacia y sostenibilidad de los procedimientos comerciales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "PMA, PDSL, PEID y otros países en desarrollo ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JM,VC,TJ,TL,VU,ZW",
    Image: "12UNCTAD15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=37"
  },
  {
    ID: 269,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "Tecnología y logística",
    Title: "Reforzar la inclusión en la facilitación del comercio",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "12UNCTAD16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=38"
  },
  {
    ID: 270,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "África, países menos adelantados y programas especiales",
    Title: "Los países menos adelantados definen una postura común sobre las normas de origen y el programa de la 14ª Conferencia Ministerial de la Organización Mundial del Comercio",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AO,AG,AM,AZ,BS,SD,QQ,BD,BZ,BJ,BT,BO,BW,BF,BI,CV,KH,CF,TD,KM,CK,CU,CD,DJ,DM,DO,ER,SZ,ET,FJ,GM,GD,GN,GW,HT,JM,KZ,KG,KI,LA,LS,LR,MK,MG,MW,MV,ML,MH,MR,MU,FM,MN,MZ,MM,NR,NP,NE,NU,PW,PG,PY,MD,RW,KN,LC,VC,WS,SN,SC,SL,SB,SO,SS,II,SD,QQ,SR,TJ,TL,TG,TO,TT,TM,TV,UG,TZ,UZ,VU,YE,ZM,ZW",
    Image: "12UNCTAD17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=43"
  },
  {
    ID: 271,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "África, países menos adelantados y programas especiales",
    Title: "Mayor capacidad estadística de los países menos adelantados y otros países en desarrollo, para contribuir a un cambio de paradigma en la formulación de políticas holísticas de diversificación económica",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,ET,KE,NG",
    Image: "12UNCTAD18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=44"
  },
  {
    ID: 272,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "África, países menos adelantados y programas especiales",
    Title: "Mejora de la capacidad de los pequeños Estados insulares en desarrollo para crear capacidades productivas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,KM,DO,MV,JM,VC,TT",
    Image: "12UNCTAD19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=45"
  },
  {
    ID: 273,
    BudgetSection: "12",
    Entity: "UNCTAD",
    EntityFullName: "Conferencia de las Naciones Unidas sobre Comercio y Desarrollo",
    Programme: "Comercio y desarrollo",
    Subprogramme: "África, países menos adelantados y programas especiales",
    Title: "Los países menos adelantados están en condiciones de formular y aplicar políticas comerciales inclusivas y coherentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BF,TD,TZ",
    Image: "12UNCTAD20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.12)&l=es#page=46"
  },
  {
    ID: 274,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centro de Comercio Internacional",
    Programme: "Centro de Comercio Internacional",
    Subprogramme: "Aspectos operacionales de la promoción del comercio y el desarrollo de las exportaciones",
    Title: "Mejores oportunidades de innovación, negocio y empleo en África y América Latina para las jóvenes empresas innovadoras y los emprendedores jóvenes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,UG",
    Image: "13ITC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=es#page=5"
  },
  {
    ID: 275,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centro de Comercio Internacional",
    Programme: "Centro de Comercio Internacional",
    Subprogramme: "Aspectos operacionales de la promoción del comercio y el desarrollo de las exportaciones",
    Title: "Mejores servicios prestados por las organizaciones locales de apoyo empresarial para que las pequeñas empresas saquen partido de la Zona de Libre Comercio Continental Africana",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "PMA, PDSL, PEID y otros países en desarrollo ",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "13ITC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=es#page=6"
  },
  {
    ID: 276,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centro de Comercio Internacional",
    Programme: "Centro de Comercio Internacional",
    Subprogramme: "Aspectos operacionales de la promoción del comercio y el desarrollo de las exportaciones",
    Title: "Transición de las pequeñas y medianas empresas del sector del textil y la confección de África y la región de Asia y el Pacífico hacia operaciones sostenibles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "PMA, PDSL, PEID y otros países en desarrollo ",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW,AF,BH,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,IN,AP,ID,IR,IQ,JP,JO,KZ,KW,KG,LA,LB,MY,MV,MH,FM,MN,MM,NR,NP,OM,PK,PW,PG,PH,QA,KR,WS,SA,SG,SB,LK,SY,TJ,TH,TL,TO,TR,TM,TV,AE,UZ,VU,VN,YE",
    Image: "13ITC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=es#page=7"
  },
  {
    ID: 277,
    BudgetSection: "13",
    Entity: "ITC",
    EntityFullName: "Centro de Comercio Internacional",
    Programme: "Centro de Comercio Internacional",
    Subprogramme: "Aspectos operacionales de la promoción del comercio y el desarrollo de las exportaciones",
    Title: "Mayor competitividad de las exportaciones de las pequeñas y medianas empresas de Europa Oriental y Asia Central",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: " ",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,KZ,KG,TJ,UZ",
    Image: "13ITC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.13)&l=es#page=8"
  },
  {
    ID: 278,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción climática",
    Title: "Las ciudades se comprometen a cumplir objetivos de refrigeración sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=11"
  },
  {
    ID: 279,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción climática",
    Title: "Los Estados Miembros elaboran su hoja de ruta y plan de acción nacionales sobre el metano",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=12"
  },
  {
    ID: 280,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción climática",
    Title: "Los Estados Miembros adoptan tecnologías ecológicamente racionales para mitigar el cambio climático y adaptarse a él",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=13"
  },
  {
    ID: 281,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción climática",
    Title: "Los gobiernos nacionales y subnacionales adoptan estrategias y políticas de adaptación climática, incluidos planes nacionales de adaptación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=13"
  },
  {
    ID: 282,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Transformaciones digitales en apoyo de la acción ambiental",
    Title: "Gobiernos e instancias normativas obtuvieron acceso a un portal ambiental basado en inteligencia artificial",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=16"
  },
  {
    ID: 283,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Transformaciones digitales en apoyo de la acción ambiental",
    Title: "Mayor interoperabilidad de los datos ambientales mundiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=17"
  },
  {
    ID: 284,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Transformaciones digitales en apoyo de la acción ambiental",
    Title: "Capacidades digitales reforzadas para potenciar la sostenibilidad ambiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=17"
  },
  {
    ID: 285,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Transformaciones digitales en apoyo de la acción ambiental",
    Title: "La plataforma “World Environment Situation Room” sirve de base para la toma de decisiones en materia de políticas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=18"
  },
  {
    ID: 286,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción por la naturaleza",
    Title: "Los Estados Miembros se comprometen a proteger la diversidad biológica marina más allá de las fronteras nacionales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=21"
  },
  {
    ID: 287,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción por la naturaleza",
    Title: "Las instituciones del sector público tienen en cuenta la contribución económica de la diversidad biológica y los servicios ecosistémicos en los procesos decisorios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=22"
  },
  {
    ID: 288,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción por la naturaleza",
    Title: "Refuerzo de la resiliencia de los ecosistemas de arrecife costeros y las comunidades locales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=22"
  },
  {
    ID: 289,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción por la naturaleza",
    Title: "Expansión de los ecosistemas gestionados de forma sostenible y restaurados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=23"
  },
  {
    ID: 290,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Derecho y gobernanza ambientales",
    Title: "Los Estados Miembros promueven marcos jurídicos y estrategias nacionales para hacer frente al tráfico ilegal de residuos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=26"
  },
  {
    ID: 291,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Derecho y gobernanza ambientales",
    Title: "Menor producción y consumo de hidrofluorocarburos aplicando la Enmienda de Kigali al Protocolo de Montreal relativo a las Sustancias que Agotan la Capa de Ozono",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=27"
  },
  {
    ID: 292,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Derecho y gobernanza ambientales",
    Title: "Los interesados del ámbito jurídico mejoran la aplicación y el cumplimiento del derecho ambiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Promoción del derecho internacional y mejora de los mecanismos internacionales de solución de controversias",
    SpecificResultOrder: 17,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=28"
  },
  {
    ID: 293,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Derecho y gobernanza ambientales",
    Title: "Se integran objetivos ambientales en los marcos normativos y jurídicos nacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=28"
  },
  {
    ID: 294,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción relacionada con los productos químicos y la contaminación",
    Title: "Se redujeron el uso de productos químicos de preocupación mundial y sus desechos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=31"
  },
  {
    ID: 295,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción relacionada con los productos químicos y la contaminación",
    Title: "Adopción de políticas y prácticas que respalden enfoques de economía circular en sectores de alto impacto para reducir la contaminación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=31"
  },
  {
    ID: 296,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción relacionada con los productos químicos y la contaminación",
    Title: "Adopción de políticas y estrategias para abordar las dimensiones ambientales de la resistencia a los antimicrobianos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=32"
  },
  {
    ID: 297,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Acción relacionada con los productos químicos y la contaminación",
    Title: "Los Estados Miembros aprueban políticas, leyes o reglamentos relativos a la gestión de los productos químicos y los desechos en sectores clave",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=33"
  },
  {
    ID: 298,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Finanzas y transformaciones económicas",
    Title: "Las compañías de seguros se comprometen a adoptar enfoques sostenibles en sus prácticas comerciales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=36"
  },
  {
    ID: 299,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Finanzas y transformaciones económicas",
    Title: "Mayor disponibilidad de herramientas y medidas para transformar las opciones y el comportamiento de los gobiernos, las empresas y los consumidores en pro de la sostenibilidad ambiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=37"
  },
  {
    ID: 300,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Finanzas y transformaciones económicas",
    Title: "Aceleración del progreso hacia modalidades de consumo y producción sostenibles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=37"
  },
  {
    ID: 301,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Finanzas y transformaciones económicas",
    Title: "Los Estados Miembros adoptan políticas para impulsar las finanzas sostenibles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=38"
  },
  {
    ID: 302,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Ámbito científico-normativo",
    Title: "Los países implementan el Sistema de Contabilidad Ambiental y Económica",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=41"
  },
  {
    ID: 303,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Ámbito científico-normativo",
    Title: "Mejores control y recogida de desechos de equipo eléctricos y electrónicos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=41"
  },
  {
    ID: 304,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Ámbito científico-normativo",
    Title: "Fortalecimiento de la interfaz ciencia-política en América Latina y el Caribe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CL,CO,CR,CU,DM,DO,EC,SV,GD,GT,GY,HT,HN,JM,MX,NI,PA,PY,PE,KN,LC,VC,SR,TT,UY,VE",
    Image: "14UNEP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=42"
  },
  {
    ID: 305,
    BudgetSection: "14",
    Entity: "UNEP",
    EntityFullName: "Programa de las Naciones Unidas para el Medio Ambiente",
    Programme: "Medio Ambiente",
    Subprogramme: "Ámbito científico-normativo",
    Title: "Los Gobiernos y las instituciones utilizan conocimientos, datos, estadísticas y evaluaciones del Programa de las Naciones Unidas para el Medio Ambiente como base para la formulación de políticas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "14UNEP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.14)&l=es#page=43"
  },
  {
    ID: 306,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Vivienda, tierra, servicios básicos y medio ambiente urbano",
    Title: "Integración de la movilidad sostenible y una vivienda que facilite el uso del transporte público para ampliar el acceso equitativo a un transporte público seguro en las ciudades, especialmente en sus periferias",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "GH,KE,NG,UG",
    Image: "15UN-Habitat1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=14"
  },
  {
    ID: 307,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Vivienda, tierra, servicios básicos y medio ambiente urbano",
    Title: "Las ciudades y los países se comprometen a proporcionar una vivienda adecuada para todos y a afrontar la falta de hogar y la exclusión en materia de vivienda",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,KM,CU,MX",
    Image: "15UN-Habitat2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=14"
  },
  {
    ID: 308,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Vivienda, tierra, servicios básicos y medio ambiente urbano",
    Title: "Aumento de la seguridad de los derechos de tenencia de la tierra",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "NP",
    Image: "15UN-Habitat3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=15"
  },
  {
    ID: 309,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Vivienda, tierra, servicios básicos y medio ambiente urbano",
    Title: "Mayor acceso a una vivienda adecuada, a la tierra y a los servicios básicos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=16"
  },
  {
    ID: 310,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Planificación, política financiera, localización y gobernanza",
    Title: "Las reformas de las leyes que regulan la planificación refuerzan la gobernanza a varios niveles en pro de unas ciudades resilientes y sostenibles",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BW,SL,ZW",
    Image: "15UN-Habitat5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=20"
  },
  {
    ID: 311,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Planificación, política financiera, localización y gobernanza",
    Title: "Sistemas de ingresos propios reforzados para mejorar el rendimiento de los gobiernos locales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=21"
  },
  {
    ID: 312,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Planificación, política financiera, localización y gobernanza",
    Title: "La localización de los Objetivos de Desarrollo Sostenible fomenta el cambio sistémico y la transformación territorial al promover una gobernanza inclusiva a varios niveles, la participación de las partes interesadas, las capacidades institucionales y la financiación para soluciones locales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=21"
  },
  {
    ID: 313,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Conocimiento, datos, digitalización y desarrollo de capacidades",
    Title: "Los profesionales que trabajan en temas urbanos pueden acceder libremente a conocimientos prácticos y directrices en varios idiomas para contribuir a acelerar la ejecución de la Nueva Agenda Urbana y los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=25"
  },
  {
    ID: 314,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Conocimiento, datos, digitalización y desarrollo de capacidades",
    Title: "Transformación digital para el desarrollo urbano sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=26"
  },
  {
    ID: 315,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Conocimiento, datos, digitalización y desarrollo de capacidades",
    Title: "Las autoridades nacionales y locales producen más y mejores datos desglosados pertinentes para las políticas relacionadas con la vivienda, la tierra y los servicios básicos (acumulativo)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=27"
  },
  {
    ID: 316,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Alianzas, coaliciones, promoción y comunicación",
    Title: "El Foro Mundial de Partes Interesadas promueve un desarrollo urbano inclusivo y sujeto a rendición de cuentas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=30"
  },
  {
    ID: 317,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Alianzas, coaliciones, promoción y comunicación",
    Title: "Se aprovecha el Foro Urbano Mundial para impulsar los compromisos mundiales destinados a garantizar el acceso a una vivienda adecuada, a la tierra y a los servicios básicos para todas las personas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=31"
  },
  {
    ID: 318,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Fortalecimiento de la acción climática y mejora del medio ambiente urbano ",
    Title: "Las contribuciones determinadas a nivel nacional tienen cada vez más contenido urbano",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=34"
  },
  {
    ID: 319,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "El Foro Mundial de Partes Interesadas promueve un desarrollo urbano inclusivo y sujeto a rendición de cuentas",
    Title: "Planes de acción climática urbana para reforzar la resiliencia de los más vulnerables",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "15UN-Habitat14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=35"
  },
  {
    ID: 320,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Prevención y respuesta eficaces en relación con las crisis urbanas",
    Title: "Integración sostenible de las comunidades desplazadas en las zonas urbanas de Somalia",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SO",
    Image: "15UN-Habitat15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=37"
  },
  {
    ID: 321,
    BudgetSection: "15",
    Entity: "UN-Habitat",
    EntityFullName: "Programa de las Naciones Unidas para los Asentamientos Humanos",
    Programme: "Asentamientos humanos",
    Subprogramme: "Prevención y respuesta eficaces en relación con las crisis urbanas",
    Title: "Planificación urbana y desarrollo inclusivo integrados y participativos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SO",
    Image: "15UN-Habitat16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.15)&l=es#page=38"
  },
  {
    ID: 322,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la delincuencia organizada transnacional",
    Title: "Refuerzo de la cooperación internacional en la lucha contra la ciberdelincuencia y el intercambio de pruebas electrónicas en relación con delitos graves",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=23"
  },
  {
    ID: 323,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la delincuencia organizada transnacional",
    Title: "Aumento del registro y la trazabilidad de las armas de fuego, las piezas y componentes y las municiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "HN,SN",
    Image: "16UNODC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=24"
  },
  {
    ID: 324,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la delincuencia organizada transnacional",
    Title: "Mejor detección del tráfico por aire, mar y tierra",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=24"
  },
  {
    ID: 325,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la delincuencia organizada transnacional",
    Title: "Refuerzo de las respuestas normativas, institucionales y de políticas contra la delincuencia organizada a escala mundial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=25"
  },
  {
    ID: 326,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Un enfoque amplio y equilibrado de la lucha contra el problema mundial de las drogas",
    Title: "Mejor capacidad de los Estados Miembros para desarticular las redes delictivas dedicadas al tráfico de drogas mediante una cooperación internacional más estrecha basada en casos concretos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,BR,CV,CL,CI,DE,PE",
    Image: "16UNODC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=28"
  },
  {
    ID: 327,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Un enfoque amplio y equilibrado de la lucha contra el problema mundial de las drogas",
    Title: "Los Estados Miembros de África Subsahariana llevan a cabo intervenciones de salud y de desarrollo más enérgicas en el contexto de la lucha contra el problema mundial de las drogas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "16UNODC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=29"
  },
  {
    ID: 328,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Un enfoque amplio y equilibrado de la lucha contra el problema mundial de las drogas",
    Title: "Se colman las lagunas mundiales en la prestación de servicios mediante nuevas iniciativas de salud y de desarrollo llevadas a cabo a escala nacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=30"
  },
  {
    ID: 329,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Un enfoque amplio y equilibrado de la lucha contra el problema mundial de las drogas",
    Title: "Personal de los laboratorios forenses capacitado en el análisis y la detección de drogas sintéticas y de los precursores utilizados en su fabricación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=31"
  },
  {
    ID: 330,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la corrupción",
    Title: "Los Estados Miembros investigan, enjuician y resuelven casos complejos de corrupción internacional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DO,KE,MY,PA,TZ,VN",
    Image: "16UNODC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=34"
  },
  {
    ID: 331,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la corrupción",
    Title: "Refuerzo del uso por parte de los Estados de la información sobre beneficiarios finales en la lucha contra la corrupción",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GT,HN,PY,PH,VN,ZM",
    Image: "16UNODC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=35"
  },
  {
    ID: 332,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la corrupción",
    Title: "Refuerzo de la cooperación entre los Estados a escala regional para luchar contra la corrupción",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=35"
  },
  {
    ID: 333,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Lucha contra la corrupción",
    Title: "Marcos jurídicos y de políticas eficaces de los Estados para combatir la corrupción, de conformidad con la Convención de las Naciones Unidas contra la Corrupción",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=36"
  },
  {
    ID: 334,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prevención del terrorismo",
    Title: "Respuestas reforzadas en materia de justicia penal para combatir la financiación del terrorismo en Côte d’Ivoire",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI",
    Image: "16UNODC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=39"
  },
  {
    ID: 335,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prevención del terrorismo",
    Title: "Cambio institucional en África Meridional para crear sistemas de justicia penal sólidos y responsables y luchar contra el terrorismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MZ",
    Image: "16UNODC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=40"
  },
  {
    ID: 336,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prevención del terrorismo",
    Title: "Mayor contribución de las funcionarias al fortalecimiento de los sistemas de justicia penal contra el terrorismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=41"
  },
  {
    ID: 337,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prevención del terrorismo",
    Title: "Los Estados están mejor preparados para hacer frente al terrorismo radiológico y nuclear gracias al Convenio Internacional para la Represión de los Actos de Terrorismo Nuclear",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=42"
  },
  {
    ID: 338,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Justicia",
    Title: "Mejor cumplimiento de las normas internacionales de promoción de la rehabilitación por parte de los sistemas penitenciarios nacionales",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=44"
  },
  {
    ID: 339,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Justicia",
    Title: "Actividades de prevención del delito y reforma de la justicia penal con pleno respeto de los derechos humanos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=45"
  },
  {
    ID: 340,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Justicia",
    Title: "Niños y jóvenes empoderados para prevenir la implicación de los niños en la delincuencia y la violencia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=46"
  },
  {
    ID: 341,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Justicia",
    Title: "Mayor implicación nacional en las iniciativas de prevención del delito y justicia penal mediante alianzas institucionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=47"
  },
  {
    ID: 342,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Investigación, análisis de tendencias y técnicas forenses",
    Title: "Mejores capacidades y conocimientos especializados de los funcionarios encargados de hacer cumplir la ley y el personal forense de América en materia de investigación de la escena del delito y análisis de documentos de seguridad falsificados y fraudulentos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AR,BO,CL,CR,DO,EC,SV,GT,GY,HN,JM,PA,PY,PE,TT,UY",
    Image: "16UNODC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=49"
  },
  {
    ID: 343,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Investigación, análisis de tendencias y técnicas forenses",
    Title: "Los laboratorios de análisis de drogas y toxicología de los Estados Miembros supervisan su desempeño en el marco de las prácticas de aseguramiento de la calidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=50"
  },
  {
    ID: 344,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Investigación, análisis de tendencias y técnicas forenses",
    Title: "Mayor acceso a las pruebas que necesitan los Estados Miembros para comprender y combatir la trata de personas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=51"
  },
  {
    ID: 345,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Investigación, análisis de tendencias y técnicas forenses",
    Title: "Los Estados Miembros utilizan cada vez más las investigaciones de la UNODC para la formulación de políticas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=52"
  },
  {
    ID: 346,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Apoyo normativo",
    Title: "Las víctimas de trata reciben un apoyo integral y centrado en las víctimas mediante el fondo fiduciario de contribuciones voluntarias de las Naciones Unidas para las víctimas de la trata de personas, especialmente mujeres y niños",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=54"
  },
  {
    ID: 347,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Apoyo normativo",
    Title: "Participación significativa de la juventud en los procesos de toma de decisiones en materia de drogas, delincuencia y corrupción",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=55"
  },
  {
    ID: 348,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Apoyo normativo",
    Title: "Se ponen en marcha iniciativas de alianza público-privada en el contexto de la Convención de las Naciones Unidas contra la Ciberdelincuencia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DO,NG",
    Image: "16UNODC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=56"
  },
  {
    ID: 349,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Apoyo normativo",
    Title: "Mayor sensibilización pública sobre las amenazas que plantean las drogas, la delincuencia, la corrupción y el terrorismo mediante contenidos específicos en los medios sociales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=56"
  },
  {
    ID: 350,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Cooperación técnica y apoyo sobre el terreno",
    Title: "Mejor rendición de cuentas y mayor eficacia del sistema judicial en Haití",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "16UNODC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=59"
  },
  {
    ID: 351,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Cooperación técnica y apoyo sobre el terreno",
    Title: "Superar las barreras a la seguridad en el mar fortaleciendo los sistemas de gestión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AO,KM,KE,MG,MU,MZ,NA,SC,TZ",
    Image: "16UNODC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=60"
  },
  {
    ID: 352,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Cooperación técnica y apoyo sobre el terreno",
    Title: "Mayor transparencia y eficiencia en la gestión de activos para mejorar la prevención del delito y la confianza pública",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "MZ",
    Image: "16UNODC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=61"
  },
  {
    ID: 353,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Cooperación técnica y apoyo sobre el terreno",
    Title: "La actividad delictiva organizada se previene y combate en las tierras y territorios tradicionalmente habitados por los Pueblos Indígenas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la adhesión al estado de derecho; fortalecimiento de la prevención del delito y la justicia penal; disminución de la corrupción; prevención del terrorismo y lucha contra él",
    SpecificResultOrder: 16,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR",
    Image: "16UNODC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=62"
  },
  {
    ID: 354,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Comisión de Estupefacientes, la Comisión de Prevención del Delito y Justicia Penal y el Congreso de las Naciones Unidas sobre Prevención del Delito y Justicia Penal",
    Title: "Avance de los preparativos del 15º Congreso de las Naciones Unidas sobre Prevención del Delito y Justicia Penal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT,CR,ET,MA,TH",
    Image: "16UNODC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=64"
  },
  {
    ID: 355,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Comisión de Estupefacientes, la Comisión de Prevención del Delito y Justicia Penal y el Congreso de las Naciones Unidas sobre Prevención del Delito y Justicia Penal",
    Title: "Refuerzo del cumplimiento de los compromisos internacionales de política en materia de prevención del delito y justicia penal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=65"
  },
  {
    ID: 356,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Comisión de Estupefacientes, la Comisión de Prevención del Delito y Justicia Penal y el Congreso de las Naciones Unidas sobre Prevención del Delito y Justicia Penal",
    Title: "Aceleración de la prevención del delito, la justicia penal y el estado de derecho mediante la adopción y aplicación de la Declaración de Abu Dabi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=65"
  },
  {
    ID: 357,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Comisión de Estupefacientes, la Comisión de Prevención del Delito y Justicia Penal y el Congreso de las Naciones Unidas sobre Prevención del Delito y Justicia Penal",
    Title: "Aplicación acelerada de los compromisos internacionales sobre políticas en materia de drogas para abordar y combatir eficazmente el problema mundial de las drogas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento del multilateralismo",
    SpecificResultOrder: 2,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=66"
  },
  {
    ID: 358,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Junta Internacional de Fiscalización de Estupefacientes",
    Title: "Funcionamiento eficaz del sistema internacional de estimaciones y evaluaciones del comercio lícito de estupefacientes y sustancias psicotrópicas con fines médicos y científicos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=70"
  },
  {
    ID: 359,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Junta Internacional de Fiscalización de Estupefacientes",
    Title: "Reducción del tráfico de nuevas sustancias psicoactivas altamente potentes y de opioides sintéticos no médicos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=71"
  },
  {
    ID: 360,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Junta Internacional de Fiscalización de Estupefacientes",
    Title: "Mayor capacidad de los Estados Miembros para garantizar una disponibilidad adecuada de sustancias sometidas a fiscalización internacional para fines médicos y científicos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=71"
  },
  {
    ID: 361,
    BudgetSection: "16",
    Entity: "UNODC",
    EntityFullName: "Oficina de las Naciones Unidas contra la Droga y el Delito",
    Programme: "Fiscalización internacional de drogas, prevención del delito y el terrorismo y justicia penal",
    Subprogramme: "Prestación de servicios de secretaría y apoyo sustantivo a la Junta Internacional de Fiscalización de Estupefacientes",
    Title: "Menor disponibilidad de precursores y sustancias químicas no catalogadas para la fabricación ilícita de drogas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Fiscalización de drogas, prevención del delito y lucha contra la delincuencia organizada y el terrorismo internacional en todas sus formas y manifestaciones ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del control de estupefacientes, bienes ilícitos y trata de personas; disminución de los flujos financieros ilícitos",
    SpecificResultOrder: 15,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "16UNODC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.16)&l=es#page=72"
  },
  {
    ID: 362,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Apoyo intergubernamental, coordinación y alianzas estratégicas",
    Title: "Medidas prioritarias identificadas y adelantadas para acelerar la aplicación de la Plataforma de Acción de Beijing",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=9"
  },
  {
    ID: 363,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Apoyo intergubernamental, coordinación y alianzas estratégicas",
    Title: "Fortalecimiento de las normas y estándares mundiales sobre igualdad de género y empoderamiento de las mujeres y las niñas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=10"
  },
  {
    ID: 364,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Apoyo intergubernamental, coordinación y alianzas estratégicas",
    Title: "Transversalización de la perspectiva de género en los Marcos de Cooperación de las Naciones Unidas para el Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=10"
  },
  {
    ID: 365,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Apoyo intergubernamental, coordinación y alianzas estratégicas",
    Title: "Mejora de la incorporación de la perspectiva de género por medio del Plan de Acción para Todo el Sistema de las Naciones Unidas sobre la Igualdad de Género y el Empoderamiento de las Mujeres 3.0",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=11"
  },
  {
    ID: 366,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Actividades programáticas y en materia de políticas",
    Title: "Los Estados Miembros utilizan datos sobre el uso del tiempo para fundamentar políticas con base empírica destinadas a reconocer, reducir y redistribuir el trabajo de cuidados no remunerado",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=14"
  },
  {
    ID: 367,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Actividades programáticas y en materia de políticas",
    Title: "Los Gobiernos aplican políticas fiscales y confeccionan presupuestos que responden a las cuestiones de género para promover la igualdad de género",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=15"
  },
  {
    ID: 368,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Actividades programáticas y en materia de políticas",
    Title: "Los Gobiernos adoptan planes nacionales de acción para prevenir la violencia contra las mujeres y las niñas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=16"
  },
  {
    ID: 369,
    BudgetSection: "17",
    Entity: "UN-Women",
    EntityFullName: "Entidad de las Naciones Unidas para la Igualdad de Género y el Empoderamiento de las Mujeres",
    Programme: "ONU-Mujeres",
    Subprogramme: "Actividades programáticas y en materia de políticas",
    Title: "Los Gobiernos avanzan en la reforma de las leyes discriminatorias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "17UN-Women8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.17)&l=es#page=16"
  },
  {
    ID: 370,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Política macroeconómica, finanzas y gobernanza",
    Title: "Mejores estrategias de gestión de la deuda y financiación sostenible en los pequeños Estados insulares en desarrollo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CV,KM",
    Image: "18ECA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=13"
  },
  {
    ID: 371,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Política macroeconómica, finanzas y gobernanza",
    Title: "Los miembros de la CEPA aplican enfoques innovadores para movilizar recursos internos y capital privado externo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BW,ET,GN,MR,UG,TZ",
    Image: "18ECA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=14"
  },
  {
    ID: 372,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Política macroeconómica, finanzas y gobernanza",
    Title: "Mejora de las previsiones macroeconómicas y de la planificación del desarrollo para un crecimiento inclusivo y sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BW",
    Image: "18ECA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=15"
  },
  {
    ID: 373,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Política macroeconómica, finanzas y gobernanza",
    Title: "Mejor gobernanza económica y financiera para mejorar la transformación estructural y el desarrollo inclusivo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,ET,GN,UG,ZM",
    Image: "18ECA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=15"
  },
  {
    ID: 374,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Integración regional y comercio",
    Title: "Mayor disposición de Etiopía para comerciar en el marzo de la Zona de Libre Comercio Continental Africana",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ET",
    Image: "18ECA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=19"
  },
  {
    ID: 375,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Integración regional y comercio",
    Title: "Estrategias comerciales sostenibles para mitigar el impacto del cambio climático",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=20"
  },
  {
    ID: 376,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Integración regional y comercio",
    Title: "Los miembros de la CEPA adoptan medidas para reducir el riesgo de las inversiones en cadenas de valor regionales y zonas económicas especiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=21"
  },
  {
    ID: 377,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Integración regional y comercio",
    Title: "Mejor entorno normativo e institucional nacional para que el sector privado pueda participar en el comercio intraafricano en el marco de la Zona de Libre Comercio Continental Africana",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=21"
  },
  {
    ID: 378,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Tecnología, innovación, conectividad y desarrollo de las infraestructuras",
    Title: "Los Estados miembros disponen de una herramienta de simulación de políticas fiscales para respaldar la formulación de políticas con base empírica con el fin de lograr una conectividad asequible, un crecimiento económico inclusivo y la creación de empleo en África",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=25"
  },
  {
    ID: 379,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Tecnología, innovación, conectividad y desarrollo de las infraestructuras",
    Title: "Mayor utilización de las nuevas tecnologías por los miembros de la CEPA, reforzada por marcos regulatorios sólidos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=26"
  },
  {
    ID: 380,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Tecnología, innovación, conectividad y desarrollo de las infraestructuras",
    Title: "Los miembros de la CEPA aprovechan la tecnología y la innovación para gestionar sus infraestructuras de transporte y energía",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "EG,QG,GH,KE,MG",
    Image: "18ECA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=27"
  },
  {
    ID: 381,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Tecnología, innovación, conectividad y desarrollo de las infraestructuras",
    Title: "Estrategias y políticas reforzadas para el desarrollo de infraestructuras",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SZ,GM",
    Image: "18ECA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=27"
  },
  {
    ID: 382,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Datos y estadísticas",
    Title: "Los miembros de la CEPA producen y utilizan estadísticas económicas mejoradas para las políticas de integración regional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=31"
  },
  {
    ID: 383,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Datos y estadísticas",
    Title: "Progresos hacia unos marcos de información estadística y geoespacial integrados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ER,GH,NA",
    Image: "18ECA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=32"
  },
  {
    ID: 384,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Datos y estadísticas",
    Title: "Mejora de los sistemas de registro civil y estadísticas vitales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,KE,NA,TZ",
    Image: "18ECA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=33"
  },
  {
    ID: 385,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Datos y estadísticas",
    Title: "Sistemas estadísticos nacionales reforzados que permitan la elaboración periódica de productos estadísticos innovadores para la adopción de decisiones con base empírica y su uso en las políticas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=33"
  },
  {
    ID: 386,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Cambio climático, seguridad alimentaria y recursos naturales",
    Title: "Los miembros de la CEPA refuerzan los marcos normativos e institucionales para unas cadenas de valor agrícolas resilientes al cambio climático",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CI,GH,ZM,ZW",
    Image: "18ECA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=39"
  },
  {
    ID: 387,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Cambio climático, seguridad alimentaria y recursos naturales",
    Title: "Los miembros de la CEPA elaboran y aplican marcos nacionales y regionales de políticas y cooperación para la utilización sostenible de los recursos naturales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=40"
  },
  {
    ID: 388,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Cambio climático, seguridad alimentaria y recursos naturales",
    Title: "Sistemas agroalimentarios resilientes e inclusivos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=40"
  },
  {
    ID: 389,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Cambio climático, seguridad alimentaria y recursos naturales",
    Title: "Mayor ambición climática y mayor acción climática en África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=41"
  },
  {
    ID: 390,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Empoderamiento económico de las mujeres y los jóvenes",
    Title: "Mejora de la recopilación de datos, el seguimiento y la presentación de informes sobre la igualdad de género y el empoderamiento de las mujeres",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,SS,II",
    Image: "18ECA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=46"
  },
  {
    ID: 391,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Empoderamiento económico de las mujeres y los jóvenes",
    Title: "Los miembros de la CEPA integran una perspectiva de género en la política fiscal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "ET,KE,RW,UG,TZ",
    Image: "18ECA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=47"
  },
  {
    ID: 392,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Empoderamiento económico de las mujeres y los jóvenes",
    Title: "Los miembros de la CEPA toman medidas para mejorar la inclusión financiera de las mujeres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "GM,SL",
    Image: "18ECA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=48"
  },
  {
    ID: 393,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Empoderamiento económico de las mujeres y los jóvenes",
    Title: "Los miembros de la CEPA aprovechan la digitalización para empoderar a los jóvenes emprendedores",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ZA",
    Image: "18ECA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=48"
  },
  {
    ID: 394,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en el Norte de África",
    Title: "Los miembros de la CEPA toman medidas para aumentar la financiación sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "EG,QG,SL",
    Image: "18ECA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=51"
  },
  {
    ID: 395,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en el Norte de África",
    Title: "Los miembros de la CEPA movilizan financiación para el desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "EG,QG,LY",
    Image: "18ECA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=52"
  },
  {
    ID: 396,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en el Norte de África",
    Title: "Los miembros de la CEPA aceleran el crecimiento inclusivo y sostenible mediante el aumento de la productividad, la diversificación y el valor añadido",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=53"
  },
  {
    ID: 397,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en el Norte de África",
    Title: "Los miembros de la CEPA adoptan medidas para maximizar la participación de la diáspora como fuente alternativa de financiación para el desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,EG,QG,LY,MR,SD,QQ,TN",
    Image: "18ECA28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=53"
  },
  {
    ID: 398,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Occidental",
    Title: "Los miembros de la CEPA en África Occidental incorporan el análisis de la cadena de valor agrícola en los marcos de planificación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=56"
  },
  {
    ID: 399,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Occidental",
    Title: "Los miembros de la CEPA evalúan la sostenibilidad de la deuda y elaboran estrategias fiscales a largo plazo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SL",
    Image: "18ECA30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=57"
  },
  {
    ID: 400,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Occidental",
    Title: "Mayor operatividad de las estrategias nacionales relativas a la Zona de Libre Comercio Continental Africana",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CV,GH,LR",
    Image: "18ECA31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=58"
  },
  {
    ID: 401,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Occidental",
    Title: "Mejora de los sistemas nacionales de presupuestación y seguimiento para aprovechar el dividendo demográfico",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BJ,BF,CV,CI,GM,GH,GN,GW,LR,ML,MR,NE,NG,SN,SL,TG",
    Image: "18ECA32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=59"
  },
  {
    ID: 402,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Central",
    Title: "Santo Tomé y Príncipe ha creado y validado sus primeras cuentas satélite de turismo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "ST",
    Image: "18ECA33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=62"
  },
  {
    ID: 403,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Central",
    Title: "Los miembros de la CEPA desarrollan zonas económicas especiales para una diversificación económica sostenible e inclusiva",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CM,CG,CD,GA",
    Image: "18ECA34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=62"
  },
  {
    ID: 404,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Central",
    Title: "Los miembros centroafricanos de la CEPA mejoran la valoración y la capitalización de los activos naturales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CG,ST",
    Image: "18ECA35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=63"
  },
  {
    ID: 405,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Central",
    Title: "Sistemas de facilitación del comercio y capacidad institucional reforzados para acelerar la integración económica regional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,CM,CF,TD,GQ,CD,GA,CG,RW,ST",
    Image: "18ECA36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=64"
  },
  {
    ID: 406,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Oriental",
    Title: "Somalia presenta la Visión 2060 del Centenario y ratifica el Acuerdo por el que se Establece la Zona de Libre Comercio Continental Africana",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "SO",
    Image: "18ECA37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=67"
  },
  {
    ID: 407,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Oriental",
    Title: "Los miembros de la CEPA y las organizaciones regionales elaboran estrategias de promoción de las inversiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=68"
  },
  {
    ID: 408,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Oriental",
    Title: "Los miembros de la CEPA implantan marcos regionales sobre turismo y economía azul",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=68"
  },
  {
    ID: 409,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Oriental",
    Title: "Mejora de la conectividad y las infraestructuras para una mayor integración regional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BI,DJ,ER,ET,KE,RW,SC,SO,SS,II,UG,TZ",
    Image: "18ECA40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=69"
  },
  {
    ID: 410,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Meridional",
    Title: "Aceleración del comercio intrarregional e inversión en la región de la Comunidad de África Meridional para el Desarrollo mediante tecnología digital",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,CD,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,TZ,ZM,ZW",
    Image: "18ECA41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=73"
  },
  {
    ID: 411,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Meridional",
    Title: "Aceleración de la transición hacia economías más sostenibles en África Meridional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=74"
  },
  {
    ID: 412,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Meridional",
    Title: "Industrialización inclusiva mediante el desarrollo de la cadena de valor en África Meridional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=74"
  },
  {
    ID: 413,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales en África Meridional",
    Title: "Aplicación acelerada del Acuerdo por el que se Establece la Zona de Libre Comercio Continental Africana y otros acuerdos comerciales en África Meridional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AO,BW,KM,SZ,LS,MG,MW,MU,MZ,NA,SC,ZA,ZM,ZW",
    Image: "18ECA44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=75"
  },
  {
    ID: 414,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Desarrollo y planificación económicos",
    Title: "Los Estados miembros de la CEPA pasan de enfoques fragmentados a enfoques integrados en materia de protección social mediante el desarrollo de estrategias nacionales de protección social",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CM,SN,ZW",
    Image: "18ECA45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=78"
  },
  {
    ID: 415,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Desarrollo y planificación económicos",
    Title: "Los miembros de la CEPA desarrollan una mano de obra preparada para el futuro",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=79"
  },
  {
    ID: 416,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Desarrollo y planificación económicos",
    Title: "Refuerzo de la planificación del desarrollo y la financiación del desarrollo adaptadas a las condiciones locales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=80"
  },
  {
    ID: 417,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Desarrollo y planificación económicos",
    Title: "Mejora de los sistemas de capacitación en la administración pública para potenciar la planificación del desarrollo nacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DJ",
    Image: "18ECA48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=80"
  },
  {
    ID: 418,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Pobreza y políticas socioeconómicas",
    Title: "Los miembros de la CEPA acordaron una posición común para África sobre las prioridades en materia de desarrollo social",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo de África",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=83"
  },
  {
    ID: 419,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Pobreza y políticas socioeconómicas",
    Title: "Mejora de los sistemas de protección social para los más vulnerables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "GH,NA,SN,TZ",
    Image: "18ECA50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=84"
  },
  {
    ID: 420,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Pobreza y políticas socioeconómicas",
    Title: "Fortalecimiento de los exámenes nacionales y regionales de los marcos relacionados con la población para promover el desarrollo sostenible y no dejar a nadie atrás",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=85"
  },
  {
    ID: 421,
    BudgetSection: "18",
    Entity: "ECA",
    EntityFullName: "Comisión Económica para África",
    Programme: "Desarrollo económico y social en África",
    Subprogramme: "Pobreza y políticas socioeconómicas",
    Title: "Políticas de empleo con base empírica reforzadas para aprovechar el dividendo demográfico de África",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo de África",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de África ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,GQ,ER,SZ,ET,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MA,MZ,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "18ECA52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.18)&l=es#page=85"
  },
  {
    ID: 422,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Política macroeconómica, reducción de la pobreza y financiación para el desarrollo",
    Title: "Las prioridades de los países de Asia y el Pacífico se reflejan en la agenda mundial de financiación para el desarrollo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Administración pública ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=19"
  },
  {
    ID: 423,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Política macroeconómica, reducción de la pobreza y financiación para el desarrollo",
    Title: "Mejora de la formulación de políticas en materia de cuestiones macroeconómicas y de financiación para el desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "SD,QQ,BT,KH,MV,MN,PK,LK",
    Image: "19ESCAP2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=20"
  },
  {
    ID: 424,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Política macroeconómica, reducción de la pobreza y financiación para el desarrollo",
    Title: "Los Estados miembros emprenden nuevas iniciativas y reformas de políticas para acelerar la financiación para el desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "SD,QQ,BT,KH,LK",
    Image: "19ESCAP3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=21"
  },
  {
    ID: 425,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Política macroeconómica, reducción de la pobreza y financiación para el desarrollo",
    Title: "Los Estados miembros elaboran, evalúan o aplican políticas macroeconómicas para acelerar los avances hacia un desarrollo resiliente al cambio climático",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=22"
  },
  {
    ID: 426,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Comercio, inversión e innovación",
    Title: "Los países refuerzan las negociaciones de acuerdos comerciales mediante análisis individualizados",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Administración pública ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=25"
  },
  {
    ID: 427,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Comercio, inversión e innovación",
    Title: "Procesos comerciales más sostenibles y eficientes gracias a la intensificación de las medidas de facilitación del comercio digital y sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=26"
  },
  {
    ID: 428,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Comercio, inversión e innovación",
    Title: "Los organismos de promoción de inversiones adquieren el compromiso de fomentar la igualdad de género a través de la inversión extranjera directa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=27"
  },
  {
    ID: 429,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Comercio, inversión e innovación",
    Title: "Mejora del acceso a oportunidades de transferencia de tecnología y a conocimientos sobre tecnologías emergentes e innovadoras",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=27"
  },
  {
    ID: 430,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Transporte",
    Title: "Los Estados miembros incorporan cada vez más los principios del transporte inclusivo en sus procesos de planificación y elaboración de políticas, con el fin de lograr sistemas de transporte más accesibles y socialmente inclusivos en las ciudades de la región de Asia y el Pacífico",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AZ,LA,MN,NP,FJ,KI,PG,SB,TL",
    Image: "19ESCAP9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=31"
  },
  {
    ID: 431,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Transporte",
    Title: "Mayor eficiencia y resiliencia de la conectividad del transporte y las redes logísticas en Asia y el Pacífico",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=32"
  },
  {
    ID: 432,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Transporte",
    Title: "Aceleración de la transición al transporte con bajo nivel de emisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=32"
  },
  {
    ID: 433,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Transporte",
    Title: "Intensificación de la cooperación regional para un desarrollo del transporte sostenible, resiliente e inclusivo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=33"
  },
  {
    ID: 434,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Medio ambiente y desarrollo, y reducción y gestión del riesgo de desastres",
    Title: "Aplicación acelerada de la acción climática",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BT,PG",
    Image: "19ESCAP13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=36"
  },
  {
    ID: 435,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Medio ambiente y desarrollo, y reducción y gestión del riesgo de desastres",
    Title: "Los Estados miembros de Asia y el Pacífico aumentan la cooperación para promover los enfoques participativos en materia ambiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=37"
  },
  {
    ID: 436,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Medio ambiente y desarrollo, y reducción y gestión del riesgo de desastres",
    Title: "Refuerzo de la cooperación regional en materia de acciones climáticas basadas en los océanos, entre otros mediante enfoques ecosistémicos y soluciones basadas en la naturaleza",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=38"
  },
  {
    ID: 437,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Medio ambiente y desarrollo, y reducción y gestión del riesgo de desastres",
    Title: "Se amplían y mejoran la cooperación regional, las alianzas y las iniciativas sobre desarrollo urbano sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=38"
  },
  {
    ID: 438,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Tecnología de la información y las comunicaciones y aplicaciones espaciales",
    Title: "Fortalecimiento de la aplicación del sistema de Alertas Tempranas para Todos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=42"
  },
  {
    ID: 439,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Tecnología de la información y las comunicaciones y aplicaciones espaciales",
    Title: "Mayor adopción de innovaciones impulsadas por la tecnología digital para permitir una adaptación transformadora al cambio climático",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,LA",
    Image: "19ESCAP18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=42"
  },
  {
    ID: 440,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Tecnología de la información y las comunicaciones y aplicaciones espaciales",
    Title: "Ampliación de las aplicaciones geoespaciales por parte de los países en situaciones especiales para la consecución de la Agenda 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=43"
  },
  {
    ID: 441,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Tecnología de la información y las comunicaciones y aplicaciones espaciales",
    Title: "Fortalecimiento de la cooperación regional para aprovechar la aplicación de tecnologías emergentes, especialmente la inteligencia artificial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=44"
  },
  {
    ID: 442,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Desarrollo social",
    Title: "Fortalecimiento del diálogo y la colaboración regionales, así como del examen conjunto de la migración segura, ordenada y regular en Asia y el Pacífico",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=48"
  },
  {
    ID: 443,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Desarrollo social",
    Title: "Los Estados miembros desarrollan medidas de políticas para valorar e invertir en la economía del cuidado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "LA,TL",
    Image: "19ESCAP22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=48"
  },
  {
    ID: 444,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Desarrollo social",
    Title: "Mayor capacidad nacional para formular políticas inclusivas en materia de envejecimiento de la población",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=49"
  },
  {
    ID: 445,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Desarrollo social",
    Title: "Los Estados miembros definen vías nacionales para las políticas de protección social que incorporen la resiliencia climática",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=50"
  },
  {
    ID: 446,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Estadísticas",
    Title: "Aprovechar los datos para impulsar el progreso en los registros civiles",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=53"
  },
  {
    ID: 447,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Estadísticas",
    Title: "Mejora de la gobernanza de los datos por parte de las oficinas nacionales de estadística de Asia y el Pacífico",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=54"
  },
  {
    ID: 448,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Estadísticas",
    Title: "Establecimiento de plataformas nacionales sobre los Objetivos de Desarrollo Sostenible con el fin de supervisar los avances hacia la Agenda 2030 para el Desarrollo Sostenible en Asia y el Pacífico",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=55"
  },
  {
    ID: 449,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Estadísticas",
    Title: "Fortalecimiento de los sistemas nacionales de estadística mediante un enfoque que involucre a toda la sociedad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Administración pública ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=55"
  },
  {
    ID: 450,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en el Pacífico",
    Title: "Mayor capacidad de los gobiernos del Pacífico para integrar la valoración económica de los bienes y servicios ecosistémicos en sus políticas y planes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=58"
  },
  {
    ID: 451,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en el Pacífico",
    Title: "Vías para incorporar la Agenda de Antigua y Barbuda para los Pequeños Estados Insulares en Desarrollo en las estrategias nacionales de desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=59"
  },
  {
    ID: 452,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en el Pacífico",
    Title: "Mayor eficacia en la producción y el uso de indicadores básicos para la elaboración de informes nacionales, regionales y mundiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=60"
  },
  {
    ID: 453,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en el Pacífico",
    Title: "Potenciar la voz del Pacífico para impulsar un índice de vulnerabilidad multidimensional de las Naciones Unidas más adaptado a sus necesidades",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CK,FM,FJ,KI,NR,NU,PW,PG,MH,WS,SB,TO,TV,VU",
    Image: "19ESCAP32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=60"
  },
  {
    ID: 454,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Oriental y Nororiental",
    Title: "Mejorar el intercambio de conocimientos para impulsar la acción climática local",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=63"
  },
  {
    ID: 455,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Oriental y Nororiental",
    Title: "Gestión eficiente del transporte y el tránsito ferroviario transfronterizo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "MN,KR,RU,KU",
    Image: "19ESCAP34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=64"
  },
  {
    ID: 456,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Oriental y Nororiental",
    Title: "Refuerzo de la colaboración transfronteriza en la lucha contra la desertificación y la degradación de las tierras en Asia Oriental y Nororiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=65"
  },
  {
    ID: 457,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Oriental y Nororiental",
    Title: "Mayor colaboración en materia de áreas marinas protegidas en Asia Nororiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CN,HK,TW,KX,MO,KP,JP,MN,KR,RU,KU",
    Image: "19ESCAP36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=65"
  },
  {
    ID: 458,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Septentrional y Central",
    Title: "Los Estados miembros de Asia Septentrional y Central elaboran recomendaciones para fortalecer el comercio",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Administración pública ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=68"
  },
  {
    ID: 459,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Septentrional y Central",
    Title: "Instrumentos para reforzar la cooperación del Programa Especial de las Naciones Unidas para las Economías de Asia Central",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Emprendimiento y aumento de la competitividad de las microempresas y las pequeñas y medianas empresas",
    SpecificResultOrder: 11,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=69"
  },
  {
    ID: 460,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Septentrional y Central",
    Title: "Los Estados miembros promueven sus políticas de transformación digital",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=70"
  },
  {
    ID: 461,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Septentrional y Central",
    Title: "Mayor cooperación subregional en materia de modernización de la red eléctrica e integración de las energías renovables en Asia Septentrional y Central",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AM,AZ,GE,KZ,KG,RU,KU,TJ,TM,UZ",
    Image: "19ESCAP40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=70"
  },
  {
    ID: 462,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Meridional y Sudoccidental",
    Title: "Fortalecimiento de la cooperación multipartita en torno al nexo entre el agua y el cambio climático en Asia Meridional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=73"
  },
  {
    ID: 463,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Meridional y Sudoccidental",
    Title: "Aceleración de la transición hacia una energía sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=74"
  },
  {
    ID: 464,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Meridional y Sudoccidental",
    Title: "Colmar la brecha digital para no dejar a nadie atrás en Asia Meridional y Sudoccidental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=74"
  },
  {
    ID: 465,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Meridional y Sudoccidental",
    Title: "Potenciar la conectividad comercial transfronteriza en Asia Meridional y Sudoccidental, prestando especial atención a las mujeres emprendedoras y a las empresas emergentes situadas en las zonas fronterizas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,SD,QQ,BT,IN,AP,IR,MV,NP,PK,LK,TR",
    Image: "19ESCAP44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=75"
  },
  {
    ID: 466,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Sudoriental",
    Title: "Participación integrada de múltiples partes interesadas para el desarrollo sostenible en Asia Sudoriental",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=78"
  },
  {
    ID: 467,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Sudoriental",
    Title: "Armonización de las políticas y normas de inversión para la consecución de los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=79"
  },
  {
    ID: 468,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Sudoriental",
    Title: "Implicación de la juventud para lograr los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "BN,KH,ID,LA,MY,MM,PH,SG,TH,TL,VN",
    Image: "19ESCAP47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=79"
  },
  {
    ID: 469,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Actividades subregionales para el desarrollo: Actividades subregionales para el desarrollo en Asia Sudoriental",
    Title: "Mejora del diálogo y la cooperación regionales en materia de transformación digital para el desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Estados Miembros de Asia y el Pacífico",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "19ESCAP48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=80"
  },
  {
    ID: 470,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Energía",
    Title: "Mejora de las políticas en materia de transición energética sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KH,FJ,FM,TO,VN",
    Image: "19ESCAP49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=83"
  },
  {
    ID: 471,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Energía",
    Title: "Los países adoptan planes de acción nacionales sobre refrigeración",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "VN",
    Image: "19ESCAP50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=84"
  },
  {
    ID: 472,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Energía",
    Title: "Mayor cooperación entre los Estados miembros de la región de Asia y el Pacífico en proyectos transfronterizos de conectividad eléctrica",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=85"
  },
  {
    ID: 473,
    BudgetSection: "19",
    Entity: "ESCAP",
    EntityFullName: "Comisión Económica y Social para Asia y el Pacífico",
    Programme: "Desarrollo económico y social en Asia y el Pacífico",
    Subprogramme: "Energía",
    Title: "Nuevos hitos acordados a nivel intergubernamental para impulsar la conectividad de los sistemas eléctricos regionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Asia y el Pacífico",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AM,AU,AZ,SD,QQ,BT,BN,KH,CN,HK,TW,KX,MO,KP,FJ,FR,GE,IN,AP,ID,IR,JP,KZ,KI,KG,LA,MY,MV,MH,FM,MN,MM,NR,NP,NL,NZ,PK,PW,PG,PH,KR,RU,KU,WS,SG,SB,LK,TJ,TH,TL,TO,TR,TM,TV,GB,US,UZ,VU,VN",
    Image: "19ESCAP52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.19)&l=es#page=85"
  },
  {
    ID: 474,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Medio ambiente",
    Title: "Los Estados miembros aplican enfoques prospectivos para formular recomendaciones sobre políticas ambientales con el fin de abordar las deficiencias y los problemas emergentes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=16"
  },
  {
    ID: 475,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Medio ambiente",
    Title: "Modernización de la base de datos sobre contaminantes que facilita la adopción de decisiones basadas en hechos y adecuadas a las circunstancias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=16"
  },
  {
    ID: 476,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Medio ambiente",
    Title: "Fortalecimiento de la base paneuropea de conocimientos ambientales para la formulación de políticas de manera informada",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=17"
  },
  {
    ID: 477,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Medio ambiente",
    Title: "Mejora de la presentación de datos sobre las emisiones atmosféricas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=18"
  },
  {
    ID: 478,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Transporte",
    Title: "Software de código abierto permite aplicar el anexo 11 del Convenio relativo al Transporte Internacional de Mercancías al Amparo de los Cuadernos TIR",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=22"
  },
  {
    ID: 479,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Transporte",
    Title: "Mayor número de adhesiones a los convenios básicos de seguridad vial como primer paso para contribuir a reducir el número de muertes y lesiones por accidentes de tráfico en todo el mundo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=23"
  },
  {
    ID: 480,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Transporte",
    Title: "Mejora del marco regulatorio para la sostenibilidad de los sistemas de transporte interior",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=24"
  },
  {
    ID: 481,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Transporte",
    Title: "Digitalización acelerada de los instrumentos jurídicos sobre transporte interior",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=24"
  },
  {
    ID: 482,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Estadística",
    Title: "Los Estados miembros hacen suyas normas estadísticas mundiales mejoradas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=28"
  },
  {
    ID: 483,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Estadística",
    Title: "Base de datos estadísticos de la Comisión Económica para Europa para una mejor investigación y adopción de decisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=29"
  },
  {
    ID: 484,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Estadística",
    Title: "Mejora de la presentación de informes para el seguimiento de los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=30"
  },
  {
    ID: 485,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Estadística",
    Title: "Mayor disponibilidad y accesibilidad de las estadísticas relativas al cambio climático",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=30"
  },
  {
    ID: 486,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Cooperación e integración económicas",
    Title: "Carta de Innovación Transformadora de la CEPE aprobada por los Estados miembros",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=33"
  },
  {
    ID: 487,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Cooperación e integración económicas",
    Title: "Más proyectos de alianzas público-privadas para infraestructuras evaluados que se consideran conformes con los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=33"
  },
  {
    ID: 488,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Cooperación e integración económicas",
    Title: "Mejora de las políticas e iniciativas de innovación para el desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=34"
  },
  {
    ID: 489,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Cooperación e integración económicas",
    Title: "Alianzas público-privadas conformes con las normas y directrices de la CEPE relativas a dichas alianzas en apoyo de los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=35"
  },
  {
    ID: 490,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Energía sostenible",
    Title: "Fortalecimiento de la cooperación transfronteriza en materia de conectividad energética",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=38"
  },
  {
    ID: 491,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Energía sostenible",
    Title: "Gestión de los recursos naturales más sostenible y resiliente sobre la base de la Clasificación Marco de las Naciones Unidas para los Recursos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=39"
  },
  {
    ID: 492,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Energía sostenible",
    Title: "Mayor adopción de la movilidad eléctrica para una transición energética sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=40"
  },
  {
    ID: 493,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Energía sostenible",
    Title: "Reducción de las emisiones de gases de efecto invernadero en sectores en que se produce una gran cantidad de emisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=40"
  },
  {
    ID: 494,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Comercio",
    Title: "Los planes de acción sobre el género adoptados promueven una infraestructura de la calidad inclusiva para el comercio",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=43"
  },
  {
    ID: 495,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Comercio",
    Title: "Mayor digitalización del comercio",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=44"
  },
  {
    ID: 496,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Comercio",
    Title: "Mejora de la transparencia y la trazabilidad de las cadenas de valor en sectores críticos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=45"
  },
  {
    ID: 497,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Comercio",
    Title: "Normas de calidad de los productos agrícolas revisadas con el objetivo de reducir la pérdida y el desperdicio de alimentos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=45"
  },
  {
    ID: 498,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Bosques e industria forestal",
    Title: "Mayor integración de las soluciones de silvicultura urbana sostenible en la planificación nacional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=48"
  },
  {
    ID: 499,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Bosques e industria forestal",
    Title: "Planificación y acción con base empírica para la producción y el consumo sostenibles de productos forestales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=49"
  },
  {
    ID: 500,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Bosques e industria forestal",
    Title: "Mayor acceso a los datos sobre los bosques y la industria forestal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=50"
  },
  {
    ID: 501,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Bosques e industria forestal",
    Title: "Planificación prospectiva para una industria forestal resiliente y sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=51"
  },
  {
    ID: 502,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Vivienda, ordenación de tierras y población",
    Title: "Los Estados miembros se comprometen a promover la asequibilidad y la sostenibilidad de la vivienda",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=54"
  },
  {
    ID: 503,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Vivienda, ordenación de tierras y población",
    Title: "Más políticas sensibles a las cuestiones de la edad e inclusivas para dar respuesta a las oportunidades y dificultades del envejecimiento individual y de la población",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=55"
  },
  {
    ID: 504,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Vivienda, ordenación de tierras y población",
    Title: "Aceleración de la localización de los Objetivos de Desarrollo Sostenible por parte de los gobiernos locales y regionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=55"
  },
  {
    ID: 505,
    BudgetSection: "20",
    Entity: "ECE",
    EntityFullName: "Comisión Económica para Europa",
    Programme: "Desarrollo económico en Europa",
    Subprogramme: "Vivienda, ordenación de tierras y población",
    Title: "Marco normativo regional anticipatorio sobre el envejecimiento",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AL,AD,AM,AT,AZ,BY,BE,BA,BG,CA,HR,CY,CZ,DK,EE,FI,FR,GE,DE,GR,HU,IS,IE,IL,IT,KZ,KG,LV,LI,LT,LU,MT,MC,ME,NL,NO,PL,PT,PI,MD,MK,RO,RU,KU,SM,RS,SK,SI,ES,EI,SE,CH,TJ,TR,TM,UA,GB,US,UZ",
    Image: "20ECE32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.20)&l=es#page=56"
  },
  {
    ID: 506,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Comercio internacional, integración e infraestructura",
    Title: "Una matriz de insumo-producto regional para orientar la formulación de políticas con base empírica en América Latina y el Caribe",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=17"
  },
  {
    ID: 507,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Comercio internacional, integración e infraestructura",
    Title: "Mejora de la coordinación de las políticas sobre un comercio de alimentos, unos sistemas de transporte y una logística sostenibles y resilientes para mejorar la seguridad alimentaria regional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=18"
  },
  {
    ID: 508,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Comercio internacional, integración e infraestructura",
    Title: "Políticas que mejoran la integración física, las infraestructuras, el transporte y la logística de forma integral y accesible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=19"
  },
  {
    ID: 509,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Comercio internacional, integración e infraestructura",
    Title: "Los Estados miembros diversifican su canasta exportadora mediante una mayor venta al extranjero de servicios prestados por vía digital",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=19"
  },
  {
    ID: 510,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Producción e innovación",
    Title: "Fortalecimiento de la integración de la perspectiva de género en las políticas de desarrollo productivo territorial",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "UY",
    Image: "21ECLAC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=23"
  },
  {
    ID: 511,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Producción e innovación",
    Title: "Aumento y mejora de las iniciativas de clústeres y otras iniciativas de articulación productiva territorial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=23"
  },
  {
    ID: 512,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Producción e innovación",
    Title: "Políticas mejoradas de desarrollo productivo para impulsar el crecimiento de la productividad en sectores clave",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=24"
  },
  {
    ID: 513,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Producción e innovación",
    Title: "Políticas de desarrollo productivo que fomenten la sofisticación productiva, la diversificación y el cambio estructural para la igualdad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=25"
  },
  {
    ID: 514,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Políticas macroeconómicas y crecimiento",
    Title: "Costa Rica impulsa la creación de bonos de impacto social para reforzar la movilización de recursos internos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR",
    Image: "21ECLAC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=28"
  },
  {
    ID: 515,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Políticas macroeconómicas y crecimiento",
    Title: "Políticas macroeconómicas y de financiación para el desarrollo orientadas al crecimiento económico, la inversión, la sostenibilidad fiscal y la resiliencia ante el clima",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=28"
  },
  {
    ID: 516,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Políticas macroeconómicas y crecimiento",
    Title: "Formulación de políticas de gasto fiscal fortalecida para apoyar los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=29"
  },
  {
    ID: 517,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Políticas macroeconómicas y crecimiento",
    Title: "Mayor movilización de recursos nacionales públicos en consonancia con el Compromiso de Sevilla",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=30"
  },
  {
    ID: 518,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo social e igualdad",
    Title: "El Paraguay establece el Registro Social de Hogares, lo que contribuye a fortalecer su sistema de protección social",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "PY",
    Image: "21ECLAC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=32"
  },
  {
    ID: 519,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo social e igualdad",
    Title: "Ampliación de los sistemas de protección social para incluir a los trabajadores informales e independientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=33"
  },
  {
    ID: 520,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo social e igualdad",
    Title: "Mejores políticas de inclusión laboral, incluidos los efectos del cambio climático",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=34"
  },
  {
    ID: 521,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo social e igualdad",
    Title: "Diseño de instrumentos de política intersectoriales para la inclusión y la transformación digitales destinados a reducir la desigualdad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=34"
  },
  {
    ID: 522,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Igualdad de género y autonomía de las mujeres",
    Title: "Una década de acción para el logro de la igualdad sustantiva de género y la sociedad del cuidado",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=37"
  },
  {
    ID: 523,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Igualdad de género y autonomía de las mujeres",
    Title: "Avances en la elaboración de estadísticas de género sobre el uso del tiempo y el trabajo de cuidados no remunerado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=37"
  },
  {
    ID: 524,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Igualdad de género y autonomía de las mujeres",
    Title: "Incorporación de la perspectiva de género en las políticas exteriores y la cooperación internacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=38"
  },
  {
    ID: 525,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Igualdad de género y autonomía de las mujeres",
    Title: "Los países miden el impacto de invertir en políticas de cuidado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=39"
  },
  {
    ID: 526,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Población y desarrollo",
    Title: "El Estado Plurinacional de Bolivia publica los resultados de su censo de población y vivienda",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BO",
    Image: "21ECLAC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=42"
  },
  {
    ID: 527,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Población y desarrollo",
    Title: "Fortalecimiento del análisis demográfico para las políticas públicas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=42"
  },
  {
    ID: 528,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Población y desarrollo",
    Title: "Plan de Acción Internacional de Madrid sobre el Envejecimiento aplicado a nivel nacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=43"
  },
  {
    ID: 529,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Población y desarrollo",
    Title: "Los países elaboran sus propias estimaciones y proyecciones demográficas y de la población activa actualizadas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=44"
  },
  {
    ID: 530,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo sostenible y asentamientos humanos",
    Title: "Sistemas reforzados de evaluación del impacto ambiental en América Latina",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=47"
  },
  {
    ID: 531,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo sostenible y asentamientos humanos",
    Title: "Desarrollo de estrategias sobre modalidades de consumo y producción sostenibles, en particular la economía circular, para mejorar el desempeño ambiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=47"
  },
  {
    ID: 532,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo sostenible y asentamientos humanos",
    Title: "Simulaciones mejoradas de los posibles efectos del cambio climático para fundamentar la formulación de políticas y las opciones de inversión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=48"
  },
  {
    ID: 533,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Desarrollo sostenible y asentamientos humanos",
    Title: "Establecimiento de prioridades nacionales basadas en un marco común para la implementación del Acuerdo de Escazú",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=49"
  },
  {
    ID: 534,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Recursos naturales",
    Title: "Fortalecimiento del diálogo político y la gobernanza regional en el sector de la minería",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=51"
  },
  {
    ID: 535,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Recursos naturales",
    Title: "Los países de la región suministran minerales críticos para la transición energética con una mayor sostenibilidad económica, social y ambiental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=52"
  },
  {
    ID: 536,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Recursos naturales",
    Title: "Nuevas iniciativas para promover la transición energética en América Latina y el Caribe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=52"
  },
  {
    ID: 537,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Recursos naturales",
    Title: "Mejora de las políticas y la gobernanza oceánicas para reforzar la utilización y la gestión sostenibles de los océanos en la región",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=53"
  },
  {
    ID: 538,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Planificación y gestión pública para el desarrollo",
    Title: "Aprobación de la Agenda Regional de Gobernanza de la Planificación y la Gestión Pública para el Desarrollo Sostenible en América Latina y el Caribe para orientar la planificación estratégica a largo plazo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=55"
  },
  {
    ID: 539,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Planificación y gestión pública para el desarrollo",
    Title: "Políticas de desarrollo integrales para crear territorios más resilientes y acelerar la implementación de la Agenda 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=56"
  },
  {
    ID: 540,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Planificación y gestión pública para el desarrollo",
    Title: "Capacidad técnica, operacional, política y prospectiva mejorada en las instituciones públicas para gestionar las transformaciones y abordar retos complejos en entornos cambiantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=57"
  },
  {
    ID: 541,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Planificación y gestión pública para el desarrollo",
    Title: "Los Estados miembros elaboran planes de desarrollo nacionales y subnacionales a largo plazo que integren los cuatro ejes estratégicos de la Agenda Regional de Gobernanza de la Planificación y la Gestión Pública para el Desarrollo Sostenible en América Latina y el Caribe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=58"
  },
  {
    ID: 542,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Estadística",
    Title: "Mayor precisión de los datos que fundamentan las políticas en materia de pobreza, desigualdad, empleo, educación y condiciones de vida",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=61"
  },
  {
    ID: 543,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Estadística",
    Title: "Mayor aplicación a nivel nacional del Marco Integrado de Información Geoespacial de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=61"
  },
  {
    ID: 544,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Estadística",
    Title: "Mayor uso de los registros administrativos para la elaboración de estadísticas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=62"
  },
  {
    ID: 545,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Estadística",
    Title: "Sistemas estadísticos nacionales modernizados para medir la actividad económica en los países de América Latina y el Caribe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=62"
  },
  {
    ID: 546,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en Centroamérica, Cuba, Haití, México y la República Dominicana",
    Title: "Los países refuerzan el desarrollo productivo basado en las cadenas de valor",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC41.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=65"
  },
  {
    ID: 547,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en Centroamérica, Cuba, Haití, México y la República Dominicana",
    Title: "Consecución acelerada de los Objetivos de Desarrollo Sostenible al subsanar las brechas estructurales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC42.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=66"
  },
  {
    ID: 548,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en Centroamérica, Cuba, Haití, México y la República Dominicana",
    Title: "Gobernanza anticipatoria mejorada para fundamentar la elaboración de políticas en la subregión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC43.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=66"
  },
  {
    ID: 549,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en Centroamérica, Cuba, Haití, México y la República Dominicana",
    Title: "Mejores estrategias públicas para fomentar el desarrollo productivo en zonas y sectores subnacionales específicos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CR,CU,DO,SV,GT,HT,HN,MX,NI,PA",
    Image: "21ECLAC44.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=67"
  },
  {
    ID: 550,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en el Caribe",
    Title: "Desarrollo de un enfoque integrador de la gestión de los recursos naturales para la gestión del sargazo en el Caribe",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC45.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=69"
  },
  {
    ID: 551,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en el Caribe",
    Title: "Inclusión digital en el Caribe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC46.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=70"
  },
  {
    ID: 552,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en el Caribe",
    Title: "Integración de la Agenda de Antigua y Barbuda para los Pequeños Estados Insulares en Desarrollo en los procesos y agendas nacionales de desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC47.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=71"
  },
  {
    ID: 553,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Actividades subregionales en el Caribe",
    Title: "Diversificación económica mediante una mayor cooperación Sur-Sur con las economías de América Latina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,BS,BD,BZ,CU,DM,DO,GD,GY,HT,JM,KN,LC,VC,SR,TT",
    Image: "21ECLAC48.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=71"
  },
  {
    ID: 554,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Apoyo a los procesos y organizaciones de integración y cooperación regionales y subregionales",
    Title: "Consenso regional sobre la medición del desarrollo sostenible más allá del producto interno bruto",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC49.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=74"
  },
  {
    ID: 555,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Apoyo a los procesos y organizaciones de integración y cooperación regionales y subregionales",
    Title: "Refuerzo de las iniciativas multiactor en la cooperación Sur-Sur y triangular",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC50.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=75"
  },
  {
    ID: 556,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Apoyo a los procesos y organizaciones de integración y cooperación regionales y subregionales",
    Title: "Los países de América Latina y el Caribe colaboran con actores extrarregionales en materia de cooperación Sur-Sur y triangular",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC51.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=76"
  },
  {
    ID: 557,
    BudgetSection: "21",
    Entity: "ECLAC",
    EntityFullName: "Comisión Económica para América Latina y el Caribe",
    Programme: "Desarrollo económico y social en América Latina y el Caribe",
    Subprogramme: "Apoyo a los procesos y organizaciones de integración y cooperación regionales y subregionales",
    Title: "Mayor cooperación Sur-Sur y triangular e integración regional en consonancia con el Compromiso de Sevilla",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de América Latina y el Caribe ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AG,AR,BS,BD,BZ,BO,BR,CA,CL,CO,CR,CU,DM,DO,EC,SV,FR,DE,GD,GT,GY,HT,HN,IT,JM,JP,MX,NL,NI,NO,PA,PY,PE,PT,PI,KR,KN,LC,VC,ES,EI,SR,TT,TR,GB,US,UY,VE,AI,AW,BM,VG,KY,CW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "21ECLAC52.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.21)&l=es#page=76"
  },
  {
    ID: 558,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Cambio climático y sostenibilidad de los recursos naturales",
    Title: "Los países árabes menos adelantados completan la transición hacia una energía asequible, fiable, sostenible y moderna con la ayuda de instrumentos financieros y modelos de negocio que mitiguen los riesgos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=12"
  },
  {
    ID: 559,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Cambio climático y sostenibilidad de los recursos naturales",
    Title: "Transición hacia sistemas alimentarios sostenibles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de los marcos regulatorios y la gobernanza ambiental; intensificación de la acción climática para el desarrollo sostenible",
    SpecificResultOrder: 13,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,AO,BJ,BW,BF,BI,CV,CM,CF,TD,KM,CG,CD,CI,DJ,EG,QG,ER,SZ,ET,GQ,GA,GM,GH,GN,GW,KE,LS,LR,LY,MG,MW,ML,MR,MU,MZ,MA,NA,NE,NG,RW,ST,SN,SC,SL,SO,ZA,SS,II,SD,QQ,TZ,TG,TN,UG,ZM,ZW",
    Image: "22ESCWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=13"
  },
  {
    ID: 560,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Cambio climático y sostenibilidad de los recursos naturales",
    Title: "Los Estados miembros determinan medidas prioritarias conjuntas para la lucha contra las tormentas de arena y polvo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=14"
  },
  {
    ID: 561,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Cambio climático y sostenibilidad de los recursos naturales",
    Title: "Mejora de la resiliencia de las cuencas de aguas de superficie y aguas subterráneas en la región árabe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Clima y medio ambiente ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=14"
  },
  {
    ID: 562,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Justicia de género, población y desarrollo inclusivo",
    Title: "Se conecta a los jóvenes de la región árabe con oportunidades de empleo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=17"
  },
  {
    ID: 563,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Justicia de género, población y desarrollo inclusivo",
    Title: "Los Estados miembros adoptan un enfoque multidimensional para la reducción de la pobreza",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento de la capacidad de informar sobre los avances realizados hacia la consecución de los ODS; Aumento del número y la calidad de los exámenes nacionales voluntarios",
    SpecificResultOrder: 6,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=18"
  },
  {
    ID: 564,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Justicia de género, población y desarrollo inclusivo",
    Title: "Los Estados miembros aprovechan el aprendizaje automático para la previsión de las necesidades presupuestarias de los programas de asistencia social",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=19"
  },
  {
    ID: 565,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Justicia de género, población y desarrollo inclusivo",
    Title: "Los Estados miembros buscan y ponen en marcha medidas prioritarias para el empoderamiento económico de las personas con discapacidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento del desarrollo inclusivo para no dejar a nadie atrás; erradicación de la pobreza y disminución de las desigualdades; reducción de la discriminación de las mujeres y las niñas y fortalecimiento de la igualdad de género",
    SpecificResultOrder: 7,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=19"
  },
  {
    ID: 566,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Prosperidad económica compartida",
    Title: "Jordania y Túnez formularon políticas macrofiscales para mejorar la financiación del sector social y la sostenibilidad fiscal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=23"
  },
  {
    ID: 567,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Prosperidad económica compartida",
    Title: "Aumento de la sostenibilidad de la deuda para una mayor inversión en prioridades de desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la información sobre población, migración, registros civiles y demografía, incluidas estadísticas desglosadas por sexo",
    SpecificResultOrder: 27,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=23"
  },
  {
    ID: 568,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Prosperidad económica compartida",
    Title: "Los Estados miembros alcanzan acuerdos comerciales bilaterales fuera de la región",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Sector privado, incluidas las microempresas y pequeñas y medianas empresas ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=24"
  },
  {
    ID: 569,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Prosperidad económica compartida",
    Title: "Los países árabes realizan evaluaciones del impacto macroeconómico en aras de la diversificación económica",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=24"
  },
  {
    ID: 570,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Estadística, sociedad de la información y tecnología",
    Title: "Fortalecimiento de las cuentas nacionales en la región árabe para la formulación de políticas con base empírica",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=28"
  },
  {
    ID: 571,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Estadística, sociedad de la información y tecnología",
    Title: "Los datos geoestadísticos mejoran la toma de decisiones y la planificación del desarrollo en la región árabe",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=28"
  },
  {
    ID: 572,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Estadística, sociedad de la información y tecnología",
    Title: "Los Estados miembros árabes, incluidos los que son países menos adelantados, elaboran estadísticas sobre comercio exterior",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la medición y las estadísticas como fundamento de políticas de base empírica para el desarrollo sostenible",
    SpecificResultOrder: 28,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=29"
  },
  {
    ID: 573,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Estadística, sociedad de la información y tecnología",
    Title: "Los encargados de formular políticas utilizan la plataforma regional de datos integrada para formular políticas con base empírica",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=29"
  },
  {
    ID: 574,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Coordinación de la Agenda 2030 y los Objetivos de Desarrollo Sostenible",
    Title: "Los Estados miembros acuerdan una posición común para negociar la declaración política de la Segunda Cumbre Mundial sobre Desarrollo Social",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=33"
  },
  {
    ID: 575,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Coordinación de la Agenda 2030 y los Objetivos de Desarrollo Sostenible",
    Title: "Mayor inversión del sector privado en las prioridades regionales y nacionales de desarrollo sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Mejora de la comprensión de las necesidades de financiación y de las opciones normativas para financiar inversiones de capital sostenibles, y aumento del compromiso y la implicación para financiar proyectos sostenibles",
    SpecificResultOrder: 9,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=34"
  },
  {
    ID: 576,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Coordinación de la Agenda 2030 y los Objetivos de Desarrollo Sostenible",
    Title: "Los Estados miembros detectan y subsanan las deficiencias de políticas vinculadas a la implementación de la Agenda 2030",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=34"
  },
  {
    ID: 577,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Coordinación de la Agenda 2030 y los Objetivos de Desarrollo Sostenible",
    Title: "Se adopta una perspectiva regional establecida para encontrar vías de desarrollo regional a mediano y largo plazo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=35"
  },
  {
    ID: 578,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Gobernanza y prevención de conflictos",
    Title: "Omán aplica una planificación con base empírica del desarrollo local",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "OM",
    Image: "22ESCWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=38"
  },
  {
    ID: 579,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Gobernanza y prevención de conflictos",
    Title: "Modernización de los sistemas de administración pública para una gobernanza pública eficaz y transparente y el desarrollo socioeconómico",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Fortalecimiento de las instituciones, el estado de derecho y la prevención de conflictos",
    SpecificResultOrder: 3,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=38"
  },
  {
    ID: 580,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Gobernanza y prevención de conflictos",
    Title: "Los Estados miembros elaboran y aplican políticas de desarrollo resilientes a la fragilidad y las conmociones repentinas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=39"
  },
  {
    ID: 581,
    BudgetSection: "22",
    Entity: "ESCWA",
    EntityFullName: "Comisión Económica y Social para Asia Occidental",
    Programme: "Desarrollo económico y social en Asia Occidental",
    Subprogramme: "Gobernanza y prevención de conflictos",
    Title: "Refuerzo de la gobernanza de la competencia en aras de unos mercados transparentes e inclusivos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: "Estados Miembros de Europa, Asia Central y Asia Occidental ",
    SpecificResult: "Desarrollo de las capacidades y disminución de los obstáculos, por medios como el comercio electrónico y la economía digital, para mejorar el comercio y aumentar la competitividad",
    SpecificResultOrder: 10,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "DZ,BH,EG,QG,IQ,JO,KW,LB,LY,MR,MA,OM,QA,SA,SO,PS,SD,QQ,SY,TN,AE,YE",
    Image: "22ESCWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.22)&l=es#page=40"
  },
  {
    ID: 582,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Transversalización de los derechos humanos",
    Title: "Integración de las normas y estándares de derechos humanos en los análisis comunes sobre los países y en los Marcos de Cooperación de las Naciones Unidas para el Desarrollo Sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=19"
  },
  {
    ID: 583,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Transversalización de los derechos humanos",
    Title: "Integración de las normas internacionales de derechos humanos relacionadas con los derechos económicos, sociales y culturales en la preparación de los presupuestos de los Estados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=20"
  },
  {
    ID: 584,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Transversalización de los derechos humanos",
    Title: "Mayor promoción y protección de los derechos humanos en las políticas y prácticas nacionales a través del centro de conocimientos de derechos económicos, sociales y culturales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=21"
  },
  {
    ID: 585,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Transversalización de los derechos humanos",
    Title: "Los Estados miembros adoptan leyes antiterroristas y aplican medidas que sean conformes con los derechos consagrados en la Declaración Universal de Derechos Humanos y las obligaciones de los Estados en virtud del derecho internacional de los derechos humanos y se apliquen de una manera que los respete plenamente",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=21"
  },
  {
    ID: 586,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Derecho al desarrollo",
    Title: "Los Estados Miembros y otras partes interesadas están preparados para hacer efectivo el derecho al desarrollo en el logro de los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=24"
  },
  {
    ID: 587,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Derecho al desarrollo",
    Title: "Políticas y prácticas de lucha contra la corrupción para abordar las consecuencias negativas de la corrupción en el disfrute de los derechos humanos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=25"
  },
  {
    ID: 588,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Derecho al desarrollo",
    Title: "Fortalecimiento de la promoción y protección del derecho al desarrollo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=25"
  },
  {
    ID: 589,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Derecho al desarrollo",
    Title: "Avance de la promoción del derecho al desarrollo a escala regional y nacional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "PMA, PDSL, PEID y otros países en desarrollo ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=26"
  },
  {
    ID: 590,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Investigación y análisis",
    Title: "Los Estados Miembros promueven leyes, políticas y prácticas relativas a la droga que sean conformes con el derecho internacional de los derechos humanos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "BR,CO,PK",
    Image: "24UHCHR9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=29"
  },
  {
    ID: 591,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Investigación y análisis",
    Title: "Mayor conocimiento de los derechos humanos por parte de los jóvenes defensores de los derechos humanos de las comunidades indígenas, minoritarias y afrodescendientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=30"
  },
  {
    ID: 592,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Investigación y análisis",
    Title: "Mejor comprensión por parte de los Estados Miembros y otras partes interesadas de las implicaciones de las tecnologías digitales para los derechos humanos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=30"
  },
  {
    ID: 593,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Transversalización de los derechos humanos, derecho al desarrollo e investigación y análisis: Investigación y análisis",
    Title: "Los Estados Miembros adoptan y aplican políticas y medidas con base empírica contra el racismo que refuercen la igualdad, la no discriminación, la tolerancia y el disfrute de todos los derechos humanos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=31"
  },
  {
    ID: 594,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo a los órganos creados en virtud de tratados de derechos humanos",
    Title: "Mayor uso por los órganos de tratados de listas de cuestiones y listas de cuestiones previas a la presentación de informes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=34"
  },
  {
    ID: 595,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo a los órganos creados en virtud de tratados de derechos humanos",
    Title: "Aumento de la cooperación internacional en apoyo de los mecanismos nacionales para la aplicación, la presentación de informes y el seguimiento",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=35"
  },
  {
    ID: 596,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo a los órganos creados en virtud de tratados de derechos humanos",
    Title: "Mejora del acceso de los Estados Partes y las partes interesadas a las recomendaciones de los órganos creados en virtud de tratados a fin de facilitar su aplicación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=35"
  },
  {
    ID: 597,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo a los órganos creados en virtud de tratados de derechos humanos",
    Title: "Un acceso de ventanilla única a información sobre la labor de los órganos de tratados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=36"
  },
  {
    ID: 598,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Servicios de asesoramiento, cooperación técnica y actividades sobre el terreno",
    Title: "Las investigaciones encomendadas por el Consejo de Derechos Humanos contribuyen a los procesos de rendición de cuentas, al ofrecer análisis exhaustivos, independientes y con base empírica de las violaciones y abusos del derecho internacional humanitario y del derecho internacional de los derechos humanos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=40"
  },
  {
    ID: 599,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Servicios de asesoramiento, cooperación técnica y actividades sobre el terreno",
    Title: "Fortalecimiento de la eficacia de las instituciones nacionales de derechos humanos en consonancia con los Principios de París",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=41"
  },
  {
    ID: 600,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Servicios de asesoramiento, cooperación técnica y actividades sobre el terreno",
    Title: "Aumento de la cooperación técnica para apoyar a los Estados Miembros en la Comunidad del Caribe en sus esfuerzos por promover, proteger y hacer efectivos los derechos humanos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Estados Miembros de América Latina y el Caribe ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AG,BS,BD,BZ,DM,GD,GY,HT,JM,MS,LC,KN,VC,SR,TT,AI,BM,VG,KY,TC",
    Image: "24UHCHR19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=42"
  },
  {
    ID: 601,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Servicios de asesoramiento, cooperación técnica y actividades sobre el terreno",
    Title: "Los Estados Miembros y otras partes interesadas adoptan medidas para hacer frente a la situación de los derechos humanos a nivel nacional y regional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=43"
  },
  {
    ID: 602,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo al Consejo de Derechos Humanos y sus órganos y mecanismos subsidiarios",
    Title: "Mayor repercusión de los procedimientos especiales a escala mundial, regional y nacional",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=47"
  },
  {
    ID: 603,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo al Consejo de Derechos Humanos y sus órganos y mecanismos subsidiarios",
    Title: "Mayor contribución de las instituciones nacionales de derechos humanos al mecanismo del examen periódico universal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=48"
  },
  {
    ID: 604,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo al Consejo de Derechos Humanos y sus órganos y mecanismos subsidiarios",
    Title: "Mayor colaboración de los equipos de las Naciones Unidas en los países con el mecanismo del examen periódico universal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en la protección y el disfrute de los derechos humanos, reducción de las desigualdades y la discriminación; y aumento de la integración del derecho al desarrollo",
    SpecificResultOrder: 18,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=48"
  },
  {
    ID: 605,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Apoyo al Consejo de Derechos Humanos y sus órganos y mecanismos subsidiarios",
    Title: "Mejor acceso de las personas con discapacidad a la labor del Consejo de Derechos Humanos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=49"
  },
  {
    ID: 606,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Defensoría de los Derechos de las Víctimas",
    Title: "Mejor aplicación en todo el sistema de la estrategia del Secretario General de situar los derechos y la dignidad de las víctimas en el centro de la labor de prevención de la explotación y los abusos sexuales y de respuesta a ellos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "24UHCHR25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=119"
  },
  {
    ID: 607,
    BudgetSection: "24",
    Entity: "OHCHR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Derechos Humanos",
    Programme: "Derechos humanos",
    Subprogramme: "Defensoría de los Derechos de las Víctimas",
    Title: "Mayor apoyo a las víctimas mediante el aprovechamiento de las diversas experiencias y conocimientos de los Oficiales de Derechos de las Víctimas en contextos de mantenimiento de la paz, humanitarios y de desarrollo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Promoción de los derechos humanos ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "ET,HT,ML,UA",
    Image: "24UHCHR26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.24)&l=es#page=119"
  },
  {
    ID: 608,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Refugiados",
    Programme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Subprogramme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Title: "Las promesas hechas en el Foro Mundial sobre los Refugiados promueven el reparto de la responsabilidad y el apoyo a los refugiados y las comunidades de acogida",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=es#page=6"
  },
  {
    ID: 609,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Refugiados",
    Programme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Subprogramme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Title: "Aumento de la prevalencia de los asociados nacionales o locales en los planes de respuesta para los refugiados en todo el mundo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=es#page=7"
  },
  {
    ID: 610,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Refugiados",
    Programme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Subprogramme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Title: "Mayor protección y acceso a los servicios para los refugiados y los solicitantes de asilo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=es#page=8"
  },
  {
    ID: 611,
    BudgetSection: "25",
    Entity: "UNHCR",
    EntityFullName: "Oficina del Alto Comisionado de las Naciones Unidas para los Refugiados",
    Programme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Subprogramme: "Protección internacional, soluciones duraderas y asistencia a los refugiados",
    Title: "Mayor cumplimiento de las convenciones internacionales sobre la apatridia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "25UNHCR4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.25)&l=es#page=8"
  },
  {
    ID: 612,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Se protege a los refugiados de Palestina haciendo efectivos sus derechos en virtud del derecho internacional",
    Title: "Mayor acceso a los servicios de rehabilitación para los refugiados de Palestina con discapacidad",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=8"
  },
  {
    ID: 613,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Se protege a los refugiados de Palestina haciendo efectivos sus derechos en virtud del derecho internacional",
    Title: "Aumento de la seguridad y la dignidad de los refugiados de Palestina que acceden a los servicios del Organismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=9"
  },
  {
    ID: 614,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Se protege a los refugiados de Palestina haciendo efectivos sus derechos en virtud del derecho internacional",
    Title: "Mejora de la protección de los refugiados de Palestina frente a la violencia de género",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=9"
  },
  {
    ID: 615,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Se protege a los refugiados de Palestina haciendo efectivos sus derechos en virtud del derecho internacional",
    Title: "Mayor eficacia de las intervenciones de trabajo social dirigidas a los refugiados de Palestina en situación de vulnerabilidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=10"
  },
  {
    ID: 616,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso universal a una atención primaria de calidad y acceso específico a la atención secundaria y terciaria, lo que redunda en mejores resultados de salud",
    Title: "Mejor control de las enfermedades no transmisibles entre los refugiados de Palestina",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=12"
  },
  {
    ID: 617,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso universal a una atención primaria de calidad y acceso específico a la atención secundaria y terciaria, lo que redunda en mejores resultados de salud",
    Title: "Mejora del acceso de los refugiados de Palestina a los servicios de atención pregestacional y planificación reproductiva",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=13"
  },
  {
    ID: 618,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso universal a una atención primaria de calidad y acceso específico a la atención secundaria y terciaria, lo que redunda en mejores resultados de salud",
    Title: "Control de las enfermedades infecciosas en las comunidades de refugiados de Palestina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=13"
  },
  {
    ID: 619,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso universal a una atención primaria de calidad y acceso específico a la atención secundaria y terciaria, lo que redunda en mejores resultados de salud",
    Title: "Acceso continuado a servicios de salud mental y apoyo psicosocial para los refugiados de Palestina con necesidades detectadas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=14"
  },
  {
    ID: 620,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a una educación de calidad, inclusiva y equitativa",
    Title: "Participación continuada de los niños refugiados de Palestina en la educación primaria",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=16"
  },
  {
    ID: 621,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a una educación de calidad, inclusiva y equitativa",
    Title: "Aumento de la seguridad y la inclusividad del entorno de aprendizaje de los alumnos matriculados en los centros escolares del Organismo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=17"
  },
  {
    ID: 622,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a una educación de calidad, inclusiva y equitativa",
    Title: "Protección del desarrollo social y emocional de los niños refugiados de Palestina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=18"
  },
  {
    ID: 623,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a una educación de calidad, inclusiva y equitativa",
    Title: "Ampliación de la oferta de aprendizaje combinado y adaptado en todas las zonas de operaciones del UNRWA",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=19"
  },
  {
    ID: 624,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina disponen de oportunidades sostenidas y, cuando es posible, mejoradas de lograr un trabajo decente y generar ingresos mediante la capacitación, el apoyo institucional y el acceso equitativo a los mercados de trabajo",
    Title: "Ampliación de las oportunidades de empleo mediante obras de mejora de las infraestructuras y los campamentos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=21"
  },
  {
    ID: 625,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina disponen de oportunidades sostenidas y, cuando es posible, mejoradas de lograr un trabajo decente y generar ingresos mediante la capacitación, el apoyo institucional y el acceso equitativo a los mercados de trabajo",
    Title: "Creación de oportunidades de empleo en el sector privado",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=22"
  },
  {
    ID: 626,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina disponen de oportunidades sostenidas y, cuando es posible, mejoradas de lograr un trabajo decente y generar ingresos mediante la capacitación, el apoyo institucional y el acceso equitativo a los mercados de trabajo",
    Title: "Fomento de las oportunidades de empleo juvenil mediante la formación profesional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=22"
  },
  {
    ID: 627,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina disponen de oportunidades sostenidas y, cuando es posible, mejoradas de lograr un trabajo decente y generar ingresos mediante la capacitación, el apoyo institucional y el acceso equitativo a los mercados de trabajo",
    Title: "Mayor acceso a servicios financieros inclusivos para las mujeres refugiadas de Palestina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Mujeres y niñas",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=23"
  },
  {
    ID: 628,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a infraestructuras básicas e infraestructuras de servicios públicos en campamentos seguros y sostenibles que protegen su salud y su dignidad",
    Title: "Se han reducido los riesgos para la salud relacionados con el agua y el saneamiento entre los refugiados de Palestina que viven en campamentos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=25"
  },
  {
    ID: 629,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a infraestructuras básicas e infraestructuras de servicios públicos en campamentos seguros y sostenibles que protegen su salud y su dignidad",
    Title: "Aumento de la seguridad y la dignidad de los refugiados de Palestina que viven en campamentos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=26"
  },
  {
    ID: 630,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a infraestructuras básicas e infraestructuras de servicios públicos en campamentos seguros y sostenibles que protegen su salud y su dignidad",
    Title: "Mejor calidad del agua para los refugiados de Palestina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=26"
  },
  {
    ID: 631,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina tienen acceso a infraestructuras básicas e infraestructuras de servicios públicos en campamentos seguros y sostenibles que protegen su salud y su dignidad",
    Title: "Mejora de las condiciones de vida de los refugiados de Palestina en los campamentos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=27"
  },
  {
    ID: 632,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina más vulnerables reciben una asistencia social de mayor repercusión y mejor orientada",
    Title: "Mejora del acceso al empleo de los jóvenes refugiados de Palestina en situación de vulnerabilidad",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=29"
  },
  {
    ID: 633,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina más vulnerables reciben una asistencia social de mayor repercusión y mejor orientada",
    Title: "Acceso garantizado a una atención hospitalaria asequible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=29"
  },
  {
    ID: 634,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina más vulnerables reciben una asistencia social de mayor repercusión y mejor orientada",
    Title: "Salvaguardia de las transferencias sociales para los refugiados de Palestina más vulnerables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=30"
  },
  {
    ID: 635,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina más vulnerables reciben una asistencia social de mayor repercusión y mejor orientada",
    Title: "Mayor resiliencia de los hogares que reciben transferencias sociales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=31"
  },
  {
    ID: 636,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina están debidamente registrados y su estatus se mantiene de forma segura",
    Title: "Los registros de los antecedentes familiares se conservan y protegen mediante una digitalización a gran escala",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,LU,PS,SY",
    Image: "26UNRWA25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=32"
  },
  {
    ID: 637,
    BudgetSection: "26",
    Entity: "UNRWA",
    EntityFullName: "Organismo de Obras Públicas y Socorro de las Naciones Unidas para los Refugiados de Palestina en el Cercano Oriente",
    Programme: "Refugiados de Palestina",
    Subprogramme: "Los refugiados de Palestina están debidamente registrados y su estatus se mantiene de forma segura",
    Title: "Los refugiados de Palestina están debidamente registrados y su estatus se mantiene de forma segura",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de la protección de los derechos de los refugiados, mejora de las condiciones de vida, incluidas la salud y la educación, mejora de la capacidad de respuesta y reparto de la carga",
    SpecificResultOrder: 21,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "JO,LB,PS,SY",
    Image: "26UNRWA26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.26)&l=es#page=33"
  },
  {
    ID: 638,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Políticas y análisis",
    Title: "Las consultas impulsadas a nivel local sirvieron de base para establecer las prioridades de la respuesta humanitaria, la financiación y las medidas de preparación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CO,PH,SO",
    Image: "27OCHA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=9"
  },
  {
    ID: 639,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Políticas y análisis",
    Title: "Aumento de la participación de las comunidades en la respuesta humanitaria a fin de atender eficazmente sus necesidades",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CO,NE,PH,SS,II,SO",
    Image: "27OCHA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=9"
  },
  {
    ID: 640,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Políticas y análisis",
    Title: "Mejora del aprendizaje colectivo mediante la integración de perspectivas locales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=10"
  },
  {
    ID: 641,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Políticas y análisis",
    Title: "Respuestas humanitarias más eficientes y estructuradas para las comunidades afectadas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=11"
  },
  {
    ID: 642,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Coordinación de la acción humanitaria y la respuesta de emergencia",
    Title: "Llegar a las personas necesitadas en un contexto de graves déficits de financiación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=13"
  },
  {
    ID: 643,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Coordinación de la acción humanitaria y la respuesta de emergencia",
    Title: "Mayor participación de los agentes locales y nacionales en los mecanismos de coordinación humanitaria",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=14"
  },
  {
    ID: 644,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Coordinación de la acción humanitaria y la respuesta de emergencia",
    Title: "Ampliación de los procedimientos de anticipación y los sistemas de alerta temprana y acción temprana",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=15"
  },
  {
    ID: 645,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Coordinación de la acción humanitaria y la respuesta de emergencia",
    Title: "Una diplomacia fortalecida a nivel de todo el sistema para defender los principios humanitarios, asegurar el acceso y proteger a la población civil",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=16"
  },
  {
    ID: 646,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Servicios de apoyo en caso de emergencia",
    Title: "Mejor respuesta internacional en casos de emergencia por medio de directrices actualizadas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=19"
  },
  {
    ID: 647,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Servicios de apoyo en caso de emergencia",
    Title: "Mayor colaboración con el sector privado en la acción humanitaria colectiva",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "SD,QQ,SB",
    Image: "27OCHA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=19"
  },
  {
    ID: 648,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Servicios de apoyo en caso de emergencia",
    Title: "Los afectados reciben ayuda humanitaria de emergencia en cuanto se produce un desastre",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=20"
  },
  {
    ID: 649,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Servicios de apoyo en caso de emergencia",
    Title: "Mejor estado de disposición global de los equipos de búsqueda y salvamento en zonas urbanas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=21"
  },
  {
    ID: 650,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Información y promoción relativas a las situaciones de emergencia humanitaria",
    Title: "Las personas afectadas por la crisis recibieron apoyo basado en datos de los agentes humanitarios",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=23"
  },
  {
    ID: 651,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Información y promoción relativas a las situaciones de emergencia humanitaria",
    Title: "Servicios de red y conectividad fiables para los agentes humanitarios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=24"
  },
  {
    ID: 652,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Información y promoción relativas a las situaciones de emergencia humanitaria",
    Title: "Mejor acceso a datos e información críticos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la coherencia, la puntualidad, la eficacia y el alcance de la respuesta humanitaria; disminución sustancial del riesgo de desastres",
    SpecificResultOrder: 20,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=25"
  },
  {
    ID: 653,
    BudgetSection: "27",
    Entity: "OCHA",
    EntityFullName: "Oficina de Coordinación de Asuntos Humanitarios",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Información y promoción relativas a las situaciones de emergencia humanitaria",
    Title: "Mayor concienciación pública sobre las crisis humanitarias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=25"
  },
  {
    ID: 654,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Title: "Los Estados Miembros y las partes interesadas examinan los avances en la aplicación del Marco de Sendái y formulan recomendaciones para mejorar la reducción del riesgo de desastres",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=46"
  },
  {
    ID: 655,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Title: "Fortalecimiento de los sistemas inclusivos de alerta temprana de peligros múltiples que llegan a los más vulnerables",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=47"
  },
  {
    ID: 656,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Title: "Establecimiento de estrategias nacionales para financiar la reducción del riesgo de desastres",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=48"
  },
  {
    ID: 657,
    BudgetSection: "27",
    Entity: "UNDRR",
    EntityFullName: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Programme: "Asistencia humanitaria",
    Subprogramme: "Oficina de las Naciones Unidas para la Reducción del Riesgo de Desastres",
    Title: "Los gobiernos evalúan, refuerzan e institucionalizan su preparación para una recuperación resiliente con el fin de reconstruir para mejorar",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Coordinación efectiva de las actividades de asistencia humanitaria y apoyo a los refugiados",
    Beneficiary: "Administración pública ",
    BeneficiaryTwo: " ",
    SpecificResult: "Recuperación inclusiva y sostenible después de los desastres; fomento de la resiliencia para hacer frente a futuros desastres",
    SpecificResultOrder: 12,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "27OCHA20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.27)&l=es#page=49"
  },
  {
    ID: 658,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de campañas y operaciones en los países",
    Title: "Mayor implicación pública en las cuestiones prioritarias de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=7"
  },
  {
    ID: 659,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de campañas y operaciones en los países",
    Title: "Mayor actividad en torno a la Agenda 2030 para el Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=7"
  },
  {
    ID: 660,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de campañas y operaciones en los países",
    Title: "Mayor conocimiento e implicación públicos respecto a aspectos fundamentales ligados a los Objetivos de Desarrollo Sostenible",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la cooperación y la compartición de información y mejores prácticas para avanzar hacia la consecución de los ODS",
    SpecificResultOrder: 8,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=8"
  },
  {
    ID: 661,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de campañas y operaciones en los países",
    Title: "Mayor acceso a material de promoción y mensajes sobre cuestiones prioritarias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=9"
  },
  {
    ID: 662,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de noticias",
    Title: "Mayor alcance público de la cobertura informativa de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=11"
  },
  {
    ID: 663,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de noticias",
    Title: "Mayor implicación del público al utilizar herramientas y formatos de blog en directo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=12"
  },
  {
    ID: 664,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de noticias",
    Title: "Mayor participación y apoyo del público con respecto a las efemérides internacionales de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=12"
  },
  {
    ID: 665,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de noticias",
    Title: "Acceso mejorado y puntual a Noticias ONU en todo el mundo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=13"
  },
  {
    ID: 666,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de divulgación y difusión de conocimientos",
    Title: "Fortalecimiento del apoyo a la labor de las Naciones Unidas en todo el mundo y de la acción en favor de esa labor",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=15"
  },
  {
    ID: 667,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de divulgación y difusión de conocimientos",
    Title: "Jóvenes periodistas obtienen información y adquieren conocimientos sobre la labor de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=16"
  },
  {
    ID: 668,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de divulgación y difusión de conocimientos",
    Title: "Impulso del cumplimiento de los Objetivos de Desarrollo Sostenible a través de instituciones de educación superior",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Desarrollo sostenible ",
    Beneficiary: "Jóvenes",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la cooperación y las alianzas, y aumento de la coherencia, sinergias y disminución de los solapamientos gracias a una comunicación coherente",
    SpecificResultOrder: 29,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=17"
  },
  {
    ID: 669,
    BudgetSection: "28",
    Entity: "DGC",
    EntityFullName: "Departamento de Comunicación Global",
    Programme: "Comunicación global",
    Subprogramme: "Servicios de divulgación y difusión de conocimientos",
    Title: "Aumento del número de visitantes que realizaron visitas guiadas temáticas en la Sede de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Comunidad internacional ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "28DGC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.28)&l=es#page=18"
  },
  {
    ID: 670,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales",
    Title: "Transformación digital utilizando Umoja para tomar decisiones de forma más eficiente y eficaz",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=9"
  },
  {
    ID: 671,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales",
    Title: "Información práctica basada en datos a través de NextGen de Umoja Analytics",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=10"
  },
  {
    ID: 672,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales",
    Title: "Adopción de decisiones facilitada mediante mejoras a los portales de los Estados Miembros",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=10"
  },
  {
    ID: 673,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales",
    Title: "Actualización de la planificación de los recursos institucionales de próxima generación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=11"
  },
  {
    ID: 674,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación",
    Title: "Apoyo a los procesos de la Quinta Comisión mediante la difusión de más información y la presentación eficiente de informes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=12"
  },
  {
    ID: 675,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación",
    Title: "Mejor acceso a la información, incluida la información previa a los períodos de sesiones, para los miembros de la Quinta Comisión y del Comité del Programa y de la Coordinación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=13"
  },
  {
    ID: 676,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación",
    Title: "Procesos simplificados y racionalizados y mejores servicios para los participantes en las reuniones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=14"
  },
  {
    ID: 677,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación",
    Title: "Mayor apoyo a los procesos relacionados con las elecciones y los nombramientos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=15"
  },
  {
    ID: 678,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios de asesoramiento en gestión",
    Title: "Respuestas oportunas a las solicitudes de evaluación interna",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=17"
  },
  {
    ID: 679,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios de asesoramiento en gestión",
    Title: "El sistema de gestión de la resiliencia institucional está institucionalizado en las organizaciones del sistema de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=17"
  },
  {
    ID: 680,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios de asesoramiento en gestión",
    Title: "Recomendaciones del Comité de Contratos de la Sede aceptadas por los funcionarios delegados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=18"
  },
  {
    ID: 681,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Solución de planificación de los recursos institucionales, servicios prestados a la Quinta Comisión de la Asamblea General y al Comité del Programa y de la Coordinación y servicios de asesoramiento en gestión: Solución de planificación de los recursos institucionales: Servicios de asesoramiento en gestión",
    Title: "Mayor conocimiento por parte del personal del sistema oficial de justicia de la Organización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=18"
  },
  {
    ID: 682,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas",
    Title: "Mejor acceso a información consolidada sobre la recuperación de costos para la toma de decisiones por parte de las entidades de la Secretaría",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=21"
  },
  {
    ID: 683,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas",
    Title: "Mejor experiencia de los clientes con los sistemas de pago mundiales de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=22"
  },
  {
    ID: 684,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas",
    Title: "Aplicación de las actualizaciones aprobadas de las Normas Internacionales de Contabilidad del Sector Público y análisis del impacto de los próximos cambios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=22"
  },
  {
    ID: 685,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas",
    Title: "Marco regulatorio de gestión financiera reforzado mediante instrumentos de política de nueva creación y actualizados",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=23"
  },
  {
    ID: 686,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas de las operaciones sobre el terreno",
    Title: "Mayor supervisión y rendición de cuentas en la administración de bienes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=26"
  },
  {
    ID: 687,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas de las operaciones sobre el terreno",
    Title: "Coordinación e intercambios para la sinergia y la estandarización en la gestión de instalaciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=27"
  },
  {
    ID: 688,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas de las operaciones sobre el terreno",
    Title: "Proyectos de construcción de infraestructura de la Organización de calidad y eficaces en función de los costos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=27"
  },
  {
    ID: 689,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Finanzas de las operaciones sobre el terreno",
    Title: "Mayor transparencia y eficiencia en la formulación de las necesidades presupuestarias para las misiones políticas especiales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=28"
  },
  {
    ID: 690,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Planificación de programas y presupuestación",
    Title: "Conclusión satisfactoria de las deliberaciones presupuestarias sobre la Iniciativa ONU80 en un plazo reducido",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=31"
  },
  {
    ID: 691,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Planificación de programas y presupuestación",
    Title: "Mayor transparencia en el proceso de las consecuencias para el presupuesto por programas para los Estados Miembros",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=32"
  },
  {
    ID: 692,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Planificación de programas y presupuestación",
    Title: "Mejor información presupuestaria disponible en el piloto de información presupuestaria para apoyar la toma de decisiones de los Estados Miembros",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=32"
  },
  {
    ID: 693,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Planificación de programas, finanzas y presupuesto: Planificación de programas y presupuestación",
    Title: "Mayor eficiencia reflejada en las necesidades presupuestarias de las entidades de la Secretaría",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=33"
  },
  {
    ID: 694,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Estrategias y políticas globales",
    Title: "Gestión del cambio organizativo por parte del personal, los responsables y el personal directivo superior",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=37"
  },
  {
    ID: 695,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Estrategias y políticas globales",
    Title: "Menor número de Estados Miembros no representados e infrarrepresentados en el sistema de intervalos convenientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=37"
  },
  {
    ID: 696,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Estrategias y políticas globales",
    Title: "Sistema de selección de personal imparcial, eficaz, eficiente y ágil",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=38"
  },
  {
    ID: 697,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Estrategias y políticas globales",
    Title: "Enfoque integral con respecto al talento joven, que refuerza la capacidad de la Organización para atraer, formar y retener a los profesionales que se encuentran en las primeras etapas de su carrera",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=38"
  },
  {
    ID: 698,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Derecho administrativo",
    Title: "Mayor uso de herramientas de examen en cuestiones de conducta y disciplina",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC29.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=41"
  },
  {
    ID: 699,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Derecho administrativo",
    Title: "Ajustes del marco de políticas y las prácticas de gestión de la Secretaría facilitados por las sentencias del Tribunal Contencioso-Administrativo de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Marcos jurídicos y regulatorios propicios; disminución de la exposición a responsabilidades jurídicas",
    SpecificResultOrder: 39,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC30.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=41"
  },
  {
    ID: 700,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Derecho administrativo",
    Title: "Mejor capacidad de toma de decisiones del personal directivo superior en el tratamiento de los asuntos de conducta y disciplina",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC31.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=42"
  },
  {
    ID: 701,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Recursos humanos: Derecho administrativo",
    Title: "Mayor rendición de cuentas gracias a la eficiencia y la coherencia en el examen y la resolución de los casos disciplinarios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC32.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=43"
  },
  {
    ID: 702,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Rendición de cuentas y transformación institucionales",
    Title: "Resolución de problemas utilizando la inteligencia artificial generativa para aumentar la eficiencia",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC33.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=45"
  },
  {
    ID: 703,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Rendición de cuentas y transformación institucionales",
    Title: "Mayor uso de la evaluación interna por parte de las entidades más pequeñas para fundamentar la toma de decisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC34.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=46"
  },
  {
    ID: 704,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Rendición de cuentas y transformación institucionales",
    Title: "Mejor adopción de decisiones basada en datos gracias a la mejora continua del tablero de gestión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC35.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=46"
  },
  {
    ID: 705,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Rendición de cuentas y transformación institucionales",
    Title: "Aplicación oportuna de las recomendaciones de los órganos de supervisión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC36.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=47"
  },
  {
    ID: 706,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Abordar el racismo en el lugar de trabajo",
    Title: "Lucha contra las formas interpersonales, institucionales y sistémicas de racismo en la Organización",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC37.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=49"
  },
  {
    ID: 707,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Abordar el racismo en el lugar de trabajo",
    Title: "Sistemas de rendición de cuentas reforzados para hacer frente a las denuncias de racismo en el lugar de trabajo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC38.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=50"
  },
  {
    ID: 708,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Abordar el racismo en el lugar de trabajo",
    Title: "Mejor transparencia institucional en materia de diversidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC39.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=51"
  },
  {
    ID: 709,
    BudgetSection: "29A",
    Entity: "DMSPC",
    EntityFullName: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Programme: "Departamento de Estrategias, Políticas y Conformidad de la Gestión",
    Subprogramme: "Abordar el racismo en el lugar de trabajo",
    Title: "Mayores conocimientos sobre cómo hacer frente al racismo y la discriminación racial en el lugar de trabajo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29ADMSPC40.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29A)&l=es#page=52"
  },
  {
    ID: 710,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Apoyo sobre recursos humanos",
    Title: "Las entidades de la Secretaría reciben un apoyo operacional integral en materia de recursos humanos, así como orientación para la reestructuración y la reducción de personal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=7"
  },
  {
    ID: 711,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Apoyo sobre recursos humanos",
    Title: "Mejor gestión del desempeño en toda la Secretaría",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=8"
  },
  {
    ID: 712,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Apoyo sobre recursos humanos",
    Title: "Mejora de la creación y gestión de listas de preselección para la Secretaría global",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=9"
  },
  {
    ID: 713,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Apoyo sobre recursos humanos",
    Title: "Mejoras en la contratación de personal proporcionado gratuitamente",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=9"
  },
  {
    ID: 714,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Desarrollo de capacidades y capacitación operacional",
    Title: "El personal de las Naciones Unidas, los Estados Miembros, los candidatos y los directivos contratantes tienen acceso a una plataforma centralizada dedicada a las competencias lingüísticas y comunicativas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=11"
  },
  {
    ID: 715,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Desarrollo de capacidades y capacitación operacional",
    Title: "UNTold: aprendizaje colectivo e innovación en el sistema de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=12"
  },
  {
    ID: 716,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Desarrollo de capacidades y capacitación operacional",
    Title: "Capacidades institucionales reforzadas en materia de innovación, análisis de datos, transformación digital, prospectiva estratégica y ciencias del comportamiento",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=13"
  },
  {
    ID: 717,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Desarrollo de capacidades y capacitación operacional",
    Title: "Mejora de la disponibilidad y la accesibilidad de las orientaciones administrativas y operacionales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=13"
  },
  {
    ID: 718,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Gestión de la atención sanitaria y seguridad y salud ocupacionales",
    Title: "Mejora de la preparación para prevenir y mitigar los riesgos de enfermedades transmisibles que afectan al personal de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=15"
  },
  {
    ID: 719,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Gestión de la atención sanitaria y seguridad y salud ocupacionales",
    Title: "El personal de las Naciones Unidas usa servicios de medicina preventiva para mejorar su salud y bienestar",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=16"
  },
  {
    ID: 720,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Gestión de la atención sanitaria y seguridad y salud ocupacionales",
    Title: "Mejora de la calidad de la atención al paciente",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=17"
  },
  {
    ID: 721,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Operaciones de apoyo: Gestión de la atención sanitaria y seguridad y salud ocupacionales",
    Title: "Mejora del acceso del personal de mantenimiento de la paz a recursos digitales de apoyo a la salud mental",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=17"
  },
  {
    ID: 722,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Gestión integrada de la cadena de suministro",
    Title: "Repatriación segura y oportuna del personal uniformado, de conformidad con los planes de contingencia de la misión",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=19"
  },
  {
    ID: 723,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Gestión integrada de la cadena de suministro",
    Title: "Participación diversificada en oportunidades comerciales de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Mujeres y niñas",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "",
    Image: "29BDOS14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=20"
  },
  {
    ID: 724,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Gestión integrada de la cadena de suministro",
    Title: "Mayor disponibilidad de soluciones logísticas de guardia",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=20"
  },
  {
    ID: 725,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Gestión integrada de la cadena de suministro",
    Title: "Soluciones integradas para la cadena de suministro en entornos humanitarios y complejos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=21"
  },
  {
    ID: 726,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Apoyo al personal uniformado",
    Title: "Las misiones de mantenimiento de la paz aplican planes de contingencia que han permitido reducir los costos",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=24"
  },
  {
    ID: 727,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Apoyo al personal uniformado",
    Title: "Un portal único seguro en el que los Estados Miembros puedan presentar solicitudes y acceder a información sobre sus despliegues en operaciones de paz",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=24"
  },
  {
    ID: 728,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Apoyo al personal uniformado",
    Title: "Políticas, procedimientos, normas y definiciones actualizados para el personal uniformado y el equipo de propiedad de los contingentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=25"
  },
  {
    ID: 729,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Gestión de la cadena de suministro: Apoyo al personal uniformado",
    Title: "Mejora de la gestión de las municiones propiedad de los contingentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=26"
  },
  {
    ID: 730,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Actividades especiales",
    Title: "Creación de la Oficina de Apoyo de las Naciones Unidas en Haití",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "HT",
    Image: "29BDOS21.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=29"
  },
  {
    ID: 731,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Actividades especiales",
    Title: "Gestión mejorada durante todo el ciclo de vida de las funciones de apoyo operacional por parte de las entidades en proceso de transición",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora del desempeño y la seguridad en las misiones de mantenimiento de la paz, incluidas transiciones sin trabas con arreglo a las resoluciones del Consejo de Seguridad",
    SpecificResultOrder: 37,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS22.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=30"
  },
  {
    ID: 732,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Actividades especiales",
    Title: "Prestación de servicios eficiente y mejorada mediante el perfeccionamiento de los servicios de apoyo y asesoramiento",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "CO,PK,ZW",
    Image: "29BDOS23.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=31"
  },
  {
    ID: 733,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Actividades especiales",
    Title: "Fortalecimiento de las alianzas de apoyo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS24.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=31"
  },
  {
    ID: 734,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Administración, Nueva York",
    Title: "Recuperación de los costos de arrendamiento automatizada a través de la nómina",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS25.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=7"
  },
  {
    ID: 735,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Administración, Nueva York",
    Title: "Registros históricos preservados en formato digital",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "",
    Image: "29BDOS26.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=8"
  },
  {
    ID: 736,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Administración, Nueva York",
    Title: "Espacio de oficinas acorde con las necesidades de la Organización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "",
    Image: "29BDOS27.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=9"
  },
  {
    ID: 737,
    BudgetSection: "29B",
    Entity: "DOS",
    EntityFullName: "Departamento de Apoyo Operacional",
    Programme: "Departamento de Apoyo Operacional",
    Subprogramme: "Administración, Nueva York",
    Title: "Mayor accesibilidad de los locales e instalaciones de la Sede de las Naciones Unidas para las personas con discapacidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    BeneficiaryTwo: "Que posibilita/n ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29BDOS28.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29B)&l=es#page=9"
  },
  {
    ID: 738,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Estrategia e innovación tecnológica",
    Title: "Mayor concienciación sobre la seguridad de las tecnologías de la información y la seguridad para proteger la Secretaría",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=7"
  },
  {
    ID: 739,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Estrategia e innovación tecnológica",
    Title: "Mayor eficacia en la ejecución de mandatos mediante la inteligencia artificial generativa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=8"
  },
  {
    ID: 740,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Estrategia e innovación tecnológica",
    Title: "Uso ético y responsable de la inteligencia artificial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=9"
  },
  {
    ID: 741,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Estrategia e innovación tecnológica",
    Title: "Permitir que las entidades de la Secretaría ejecuten eficazmente la estrategia de tecnología de la información y las comunicaciones para mejorar el cumplimiento de sus mandatos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=10"
  },
  {
    ID: 742,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Apoyo a las operaciones",
    Title: "Una conectividad más fiable y estable para los delegados y el personal gracias a la mejora de la red wifi en la Sede",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=13"
  },
  {
    ID: 743,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Apoyo a las operaciones",
    Title: "Fortalecimiento de la gobernanza de las tecnologías de apoyo a las reuniones intergubernamentales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=14"
  },
  {
    ID: 744,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Apoyo a las operaciones",
    Title: "Reducción de riesgos gracias al uso de la autenticación basada en la nube para garantizar un acceso seguro",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=15"
  },
  {
    ID: 745,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Apoyo a las operaciones",
    Title: "Menor fragmentación y mayor resiliencia, seguridad y normalización de la infraestructura de los centros de datos de las tecnologías de la información y las comunicaciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=15"
  },
  {
    ID: 746,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Soluciones institucionales",
    Title: "Mayor disponibilidad de sitios web y aplicaciones gracias a la migración desde el centro tecnológico principal de Nueva York",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=18"
  },
  {
    ID: 747,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Soluciones institucionales",
    Title: "Soluciones informáticas adaptadas y oportunas para la ejecución de los mandatos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances en ciencia, tecnología e innovación, incluida la inteligencia artificial, para el desarrollo sostenible",
    SpecificResultOrder: 26,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=18"
  },
  {
    ID: 748,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Soluciones institucionales",
    Title: "Integración de la inteligencia artificial en soluciones de tecnología de la información y las comunicaciones para asistir en la toma de decisiones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "29COICT11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=19"
  },
  {
    ID: 749,
    BudgetSection: "29C",
    Entity: "OICT",
    EntityFullName: "Oficina de Tecnología de la Información y las Comunicaciones",
    Programme: "Oficina de Tecnología de la Información y las Comunicaciones",
    Subprogramme: "Soluciones institucionales",
    Title: "Mejora de las normas, la seguridad, el multilingüismo y la accesibilidad de los sitios web de información pública de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "",
    Image: "29COICT12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29C)&l=es#page=20"
  },
  {
    ID: 750,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mayor rapidez en el procesamiento de los registros contables de los clientes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=7"
  },
  {
    ID: 751,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mejor contabilidad de los activos de los edificios, las instalaciones y la infraestructura de la Oficina de las Naciones Unidas en Nairobi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=8"
  },
  {
    ID: 752,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mayor puntualidad en la resolución de los casos de pagos rechazados y devueltos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "KE",
    Image: "29DUNON3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=9"
  },
  {
    ID: 753,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mayor puntualidad en la presentación de información financiera a los donantes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=9"
  },
  {
    ID: 754,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "El personal cuenta con un mayor apoyo en lo que respecta al bienestar y la salud mental",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=11"
  },
  {
    ID: 755,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "El personal adquiere nuevos conocimientos y competencias para mejorar la eficacia institucional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=12"
  },
  {
    ID: 756,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Mayor puntualidad en los servicios de prestaciones y derechos del personal para todos los clientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=13"
  },
  {
    ID: 757,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Mayor puntualidad por parte de las oficinas clientes en los procesos de preselección para la contratación",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=14"
  },
  {
    ID: 758,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Servicios de apoyo",
    Title: "Las entidades de las Naciones Unidas en Kenya disponen de un centro para la celebración de eventos dentro del complejo de la Organización en Nairobi",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=16"
  },
  {
    ID: 759,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Servicios de apoyo",
    Title: "Nuevas zonas de reunión y colaboración para los delegados y el personal",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=17"
  },
  {
    ID: 760,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Servicios de apoyo",
    Title: "El personal de las Naciones Unidas en Kenya y en la región recibe servicios del país anfitrión de forma fluida y eficiente",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=17"
  },
  {
    ID: 761,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Servicios de apoyo",
    Title: "Mejora de las instalaciones de los servicios de conferencias, integradas en los locales de las Naciones Unidas en Nairobi",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=18"
  },
  {
    ID: 762,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Una plataforma modernizada de tecnologías de la información y las comunicaciones que cumple con las normas mundiales de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=20"
  },
  {
    ID: 763,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Mejor armonización de las políticas y prácticas sobre tecnologías de la información y las comunicaciones en las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "KE",
    Image: "29DUNON14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=21"
  },
  {
    ID: 764,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Facilitación de las deliberaciones intergubernamentales mediante la mejora y el mantenimiento de la tecnología para conferencias",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "KE",
    Image: "29DUNON15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=22"
  },
  {
    ID: 765,
    BudgetSection: "29D",
    Entity: "UNON",
    EntityFullName: "Oficina de las Naciones Unidas en Nairobi",
    Programme: "Administración, Nairobi",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Mayor interoperabilidad de la red en el marco de una plataforma única de proveedor de servicios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "KE",
    Image: "29DUNON16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29D)&l=es#page=22"
  },
  {
    ID: 766,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mejora en la puntualidad de los pagos a proveedores",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=7"
  },
  {
    ID: 767,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Las entidades tienen acceso a apoyo específico cuando se trasladan al Palacio de las Naciones o se marchan de él",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=8"
  },
  {
    ID: 768,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Procesos de transacciones de tesorería resilientes y eficientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=8"
  },
  {
    ID: 769,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Los clientes obtienen una visión más clara del desempeño del servicio mediante la presentación de informes trimestrales",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=9"
  },
  {
    ID: 770,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Apoyo del personal para la transición profesional y la separación del servicio anticipada",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=11"
  },
  {
    ID: 771,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "El personal y los candidatos externos entienden mejor el proceso de contratación de las Naciones Unidas y toman decisiones bien fundadas sobre su trayectoria profesional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=12"
  },
  {
    ID: 772,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Mayor implicación juvenil y diálogo intergeneracional",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Jóvenes",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=12"
  },
  {
    ID: 773,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Mejora del apoyo a la plantilla y de la preparación organizativa a través de transiciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=13"
  },
  {
    ID: 774,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de apoyo",
    Title: "Los sistemas audiovisuales del Salón de Asambleas contribuyen a la celebración de reuniones y eventos intergubernamentales a gran escala",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=15"
  },
  {
    ID: 775,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de apoyo",
    Title: "Segunda fase del centro de apoyo a eventos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=17"
  },
  {
    ID: 776,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de apoyo",
    Title: "Los clientes tienen a su disposición instalaciones modernas tras las obras de renovación realizadas en el marco del plan estratégico de conservación del patrimonio",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=17"
  },
  {
    ID: 777,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de apoyo",
    Title: "Mejora de la gestión energética en todo el Palacio de las Naciones",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Clima y medio ambiente ",
    SpecificResult: "Gestión sostenible de los recursos; avances en materia de energía renovable",
    SpecificResultOrder: 14,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=18"
  },
  {
    ID: 778,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Los clientes logran un uso más eficiente de la línea telefónica fija",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=20"
  },
  {
    ID: 779,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Primera fase del centro de apoyo a eventos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de las reuniones y deliberaciones multilaterales",
    SpecificResultOrder: 34,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=20"
  },
  {
    ID: 780,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Mayor eficiencia y seguridad mediante el Internet de los objetos en aras de una mejor experiencia de los clientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=21"
  },
  {
    ID: 781,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Servicios en red más rápidos y fiables para los clientes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=22"
  },
  {
    ID: 782,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de biblioteca",
    Title: "Colecciones bibliotecarias históricas e irreemplazables protegidas para las generaciones futuras durante las renovaciones",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG17.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=24"
  },
  {
    ID: 783,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de biblioteca",
    Title: "Los clientes disponen de más herramientas para consultar y utilizar recursos de información de un modo eficiente y responsable",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "CH",
    Image: "29EUNOG18.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=25"
  },
  {
    ID: 784,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de biblioteca",
    Title: "Mayor acceso a más conocimientos sobre las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "CH",
    Image: "29EUNOG19.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=25"
  },
  {
    ID: 785,
    BudgetSection: "29E",
    Entity: "UNOG",
    EntityFullName: "Oficina de las Naciones Unidas en Ginebra",
    Programme: "Administración, Ginebra",
    Subprogramme: "Servicios de biblioteca",
    Title: "Acceso sostenible a largo plazo a los archivos de las Naciones Unidas para los Estados Miembros y otras partes interesadas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "CH",
    Image: "29EUNOG20.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29E)&l=es#page=26"
  },
  {
    ID: 786,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mantener la ejecución de los programas ante una interrupción inesperada de la financiación",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=7"
  },
  {
    ID: 787,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mejora de la contabilidad financiera y la presentación de informes mediante la aplicación de la norma 47 de las IPSAS (Ingresos)",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=7"
  },
  {
    ID: 788,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Reducción de los problemas financieros sin resolver en las oficinas extrasede",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=8"
  },
  {
    ID: 789,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Planificación de programas, finanzas y presupuesto",
    Title: "Mejora de la transparencia financiera y la supervisión de la gestión",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=9"
  },
  {
    ID: 790,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Mejora de la modalidad contractual para el personal de proyectos extrasede",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=11"
  },
  {
    ID: 791,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Hacia la inclusión laboral de las personas con discapacidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la contratación y la dotación de personal en las entidades de las Naciones Unidas, entre otras cosas reduciendo las desigualdades en materia de género y representación geográfica",
    SpecificResultOrder: 36,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=11"
  },
  {
    ID: 792,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Los clientes están informados y son conscientes de todas las políticas de recursos humanos y novedades pertinentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la difusión de información y el acceso a ella",
    SpecificResultOrder: 30,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=12"
  },
  {
    ID: 793,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Gestión de los recursos humanos",
    Title: "Mayor concienciación sobre el Código de Conducta para Prevenir el Acoso, en particular el Acoso Sexual, en los Eventos del Sistema de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Fortalecimiento de los mecanismos de justicia interna y mediación para potenciar la conducta ética, la armonía y el acceso a la justicia en las Naciones Unidas",
    SpecificResultOrder: 23,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=13"
  },
  {
    ID: 794,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Servicios de apoyo",
    Title: "Refuerzo de la gestión de bienes",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=15"
  },
  {
    ID: 795,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Servicios de apoyo",
    Title: "Mejora de la supervisión de los asociados en la ejecución",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=16"
  },
  {
    ID: 796,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Servicios de apoyo",
    Title: "Flujo de trabajo simplificado para registrar y distribuir la correspondencia oficial",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AT",
    Image: "29FUNOV11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=16"
  },
  {
    ID: 797,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Servicios de apoyo",
    Title: "Utilización mejorada del espacio de oficinas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=17"
  },
  {
    ID: 798,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Mayor fiabilidad de las operaciones de tecnología de la información y las comunicaciones gracias a la consolidación de la infraestructura virtual y a una menor dependencia de las licencias por suscripción",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV13.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=19"
  },
  {
    ID: 799,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Refuerzo de la seguridad de la información extrasede",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AT",
    Image: "29FUNOV14.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=19"
  },
  {
    ID: 800,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Transformación digital de las entidades clientes para una mejor ejecución de los mandatos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV15.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=20"
  },
  {
    ID: 801,
    BudgetSection: "29F",
    Entity: "UNOV",
    EntityFullName: "Oficina de las Naciones Unidas en Viena",
    Programme: "Administración, Viena",
    Subprogramme: "Operaciones de tecnología de la información y las comunicaciones",
    Title: "Enfoque armonizado para la seguridad de la tecnología de la información y las comunicaciones en todas las ubicaciones de departamentos clientes de la Oficina de las Naciones Unidas en Viena",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AT",
    Image: "29FUNOV16.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.29F)&l=es#page=21"
  },
  {
    ID: 802,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Auditoría interna",
    Title: "Fortalecimiento de la rendición de cuentas en cuanto al tiempo y la asistencia del personal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=6"
  },
  {
    ID: 803,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Auditoría interna",
    Title: "Refuerzo de los sistemas de seguimiento para gestionar mejor la ejecución en apoyo del cumplimiento de los programas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=7"
  },
  {
    ID: 804,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Auditoría interna",
    Title: "Mejora de la ejecución de los mandatos y programas de las Naciones Unidas mediante el fortalecimiento de las capacidades organizativas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=8"
  },
  {
    ID: 805,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Auditoría interna",
    Title: "Mayores eficiencias en la administración de la Organización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=9"
  },
  {
    ID: 806,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Inspección y evaluación",
    Title: "Fortalecimiento de la capacidad de autoevaluación de la Secretaría",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=11"
  },
  {
    ID: 807,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Inspección y evaluación",
    Title: "Refuerzo del sistema de coordinadores residentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=11"
  },
  {
    ID: 808,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Inspección y evaluación",
    Title: "Mejora de los resultados del programa",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=12"
  },
  {
    ID: 809,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Inspección y evaluación",
    Title: "Mejor ejecución de los mandatos mediante el refuerzo de la planificación de los programas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=13"
  },
  {
    ID: 810,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Investigaciones",
    Title: "Capacidad fortalecida de la Organización para proteger sus recursos y exigir responsabilidades a su personal",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=15"
  },
  {
    ID: 811,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Investigaciones",
    Title: "Refuerzo de la respuesta a las investigaciones de faltas de conducta que requieren una solución centrada en la víctima",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=15"
  },
  {
    ID: 812,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Investigaciones",
    Title: "Mejora de la tramitación de las denuncias de conducta indebida y de la toma de decisiones oportuna al respecto",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=16"
  },
  {
    ID: 813,
    BudgetSection: "30",
    Entity: "OIOS",
    EntityFullName: "Oficina de Servicios de Supervisión Interna",
    Programme: "Supervisión interna",
    Subprogramme: "Investigaciones",
    Title: "Investigación oportuna de los casos que puedan acarrear pérdidas financieras para la Organización",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la respuesta ante la explotación y los abusos sexuales, el acoso sexual y el fraude y la corrupción; mejora de la transversalización del enfoque centrado en las víctimas",
    SpecificResultOrder: 22,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "30OIOS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.30)&l=es#page=16"
  },
  {
    ID: 814,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Comisión de Administración Pública Internacional",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Comisión de Administración Pública Internacional",
    Title: "Un modelo justo y equitativo de prestación personal de transición",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=4"
  },
  {
    ID: 815,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Comisión de Administración Pública Internacional",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Comisión de Administración Pública Internacional",
    Title: "Mayor flexibilidad para el personal que trabaja en lugares de destino difíciles",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=5"
  },
  {
    ID: 816,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Comisión de Administración Pública Internacional",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Comisión de Administración Pública Internacional",
    Title: "Normas de conducta revisadas para orientar a las organizaciones sobre las cuestiones emergentes",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=6"
  },
  {
    ID: 817,
    BudgetSection: "31",
    Entity: "ICSC",
    EntityFullName: "Comisión de Administración Pública Internacional",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Comisión de Administración Pública Internacional",
    Title: "Un paquete de remuneración que refleje los objetivos, criterios y parámetros aprobados por la Asamblea General",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=6"
  },
  {
    ID: 818,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Dependencia Común de Inspección",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Dependencia Común de Inspección",
    Title: "Mayor capacidad de respuesta a las recomendaciones de la Dependencia Común de Inspección gracias al acceso a una nueva herramienta de seguimiento de recomendaciones",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=14"
  },
  {
    ID: 819,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Dependencia Común de Inspección",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Dependencia Común de Inspección",
    Title: "Mejora de la gestión de las cuestiones administrativas y programáticas por parte de las organizaciones del sistema de las Naciones Unidas mediante la aplicación de las recomendaciones estratégicas y operacionales por la Dependencia Común de Inspección",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=15"
  },
  {
    ID: 820,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Dependencia Común de Inspección",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Dependencia Común de Inspección",
    Title: "Mayor repercusión de las recomendaciones de la Dependencia Común de Inspección",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=16"
  },
  {
    ID: 821,
    BudgetSection: "31",
    Entity: "JIU",
    EntityFullName: "Dependencia Común de Inspección",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Dependencia Común de Inspección",
    Title: "Fortalecimiento de la base de conocimientos a nivel de todo el sistema y toma de decisiones fundamentada a partir de conclusiones de supervisión basadas en datos empíricos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=17"
  },
  {
    ID: 822,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Title: "Iniciativas de eficiencia de gran alcance destinadas a racionalizar de manera conjunta las operaciones del sistema de las Naciones Unidas, reducir los costos y garantizar un impacto duradero",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=25"
  },
  {
    ID: 823,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Title: "La identificación digital de las Naciones Unidas, elemento básico para permitir la interoperabilidad entre las organizaciones de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Avances tecnológicos que dan lugar al aumento de la calidad, la disponibilidad, la accesibilidad y la seguridad de la información",
    SpecificResultOrder: 24,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=25"
  },
  {
    ID: 824,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Title: "Mayor coherencia de las actividades del sistema de las Naciones Unidas para la aceleración del progreso hacia la consecución de los Objetivos de Desarrollo Sostenible y la aplicación del Pacto para el Futuro",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aceleración de los avances hacia la consecución de los Objetivos de Desarrollo Sostenible, incluidas estructuras sólidas de coordinación, aprovechando los vínculos que existen entre los ODS",
    SpecificResultOrder: 5,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=26"
  },
  {
    ID: 825,
    BudgetSection: "31",
    Entity: "CEB",
    EntityFullName: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Programme: "Actividades administrativas financiadas conjuntamente",
    Subprogramme: "Junta de los Jefes Ejecutivos del Sistema de las Naciones Unidas para la Coordinación",
    Title: "La coordinación y la coherencia del sistema de las Naciones Unidas permiten una actuación eficaz, sostenida y basada en principios",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Simplificación, transparencia y facilidad de acceso para mejorar la aplicación de los programas",
    SpecificResultOrder: 33,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "31JFA12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.31)&l=es#page=27"
  },
  {
    ID: 826,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios de Seguridad",
    Title: "Un entorno seguro para todos los delegados y participantes durante el octogésimo período de sesiones de la Asamblea General",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Comunidad internacional ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS1.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=7"
  },
  {
    ID: 827,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios de Seguridad",
    Title: "Mayor facilidad de desplazamiento de los miembros de las delegaciones y el personal entre los distintos lugares de destino",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target not met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS2.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=8"
  },
  {
    ID: 828,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios de Seguridad",
    Title: "Mejores instalaciones de registro, expedición de tarjetas de identificación y seguridad para las personas con discapacidad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: "Refugiados, minorías y otros grupos en situación de vulnerabilidad",
    SpecificResult: "Mejora de la infraestructura que facilita las operaciones de las Naciones Unidas de manera más eficiente y eficaz",
    SpecificResultOrder: 35,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS3.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=9"
  },
  {
    ID: 829,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios de Seguridad",
    Title: "Mejor toma de decisiones en materia de seguridad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS4.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=9"
  },
  {
    ID: 830,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Operaciones sobre el terreno",
    Title: "Mayor eficiencia operacional, con especial atención a los lugares de alto riesgo",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS5.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=12"
  },
  {
    ID: 831,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Operaciones sobre el terreno",
    Title: "Mejor preparación y respuesta ante las crisis",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS6.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=12"
  },
  {
    ID: 832,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Operaciones sobre el terreno",
    Title: "Mejor toma de decisiones en materia de seguridad",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS7.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=13"
  },
  {
    ID: 833,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Operaciones sobre el terreno",
    Title: "Mejor toma de decisiones en materia de seguridad basada en el riesgo",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS8.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=14"
  },
  {
    ID: 834,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios especializados",
    Title: "Los nuevos sistemas digitales reforzaron la seguridad del personal de las Naciones Unidas",
    Story: " ",
    Type: 2025,
    TypeTwo: 0,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la eficiencia de los procesos gracias a la ciencia, la tecnología y la innovación",
    SpecificResultOrder: 25,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS9.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=16"
  },
  {
    ID: 835,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios especializados",
    Title: "Consistencia y coherencia en las operaciones en todo el sistema de gestión de la seguridad de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target met",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS10.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=17"
  },
  {
    ID: 836,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios especializados",
    Title: "Servicios de protección personal reforzados para los altos funcionarios de las Naciones Unidas",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "Target exceeded",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS11.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=17"
  },
  {
    ID: 837,
    BudgetSection: "34",
    Entity: "DSS",
    EntityFullName: "Departamento de Seguridad",
    Programme: "Seguridad",
    Subprogramme: "Servicios especializados",
    Title: "Enfoque armonizado del apoyo psicosocial tras incidentes críticos",
    Story: " ",
    Type: 2027,
    TypeTwo: 2025,
    Priority: "Facilitación de los progresos hacia la consecución de las ocho prioridades ",
    Beneficiary: "Que posibilita/n ",
    BeneficiaryTwo: " ",
    SpecificResult: "Aumento de la capacidad, la rendición de cuentas y la capacidad de respuesta institucionales para ejecutar los mandatos más eficazmente",
    SpecificResultOrder: 31,
    COVID_Related: "no",
    Target: "not applicable",
    ISO2: "AF,AI,AL,AW,DZ,AD,AO,AG,AR,AM,AU,AT,AZ,BM,BS,BH,SD,QQ,BD,BY,BE,BZ,BJ,BT,BO,BA,BW,BR,BN,BG,BF,BI,CV,KH,CM,CA,CF,TD,CL,CN,KX,TW,HK,MO,CO,KM,CG,CR,CI,HR,CU,CW,CY,CZ,KP,CD,DK,DJ,DM,DO,EC,EG,QG,SV,GQ,ER,EE,SZ,ET,FJ,FI,FR,GA,GM,GE,DE,GH,GR,GD,GT,GN,GW,GY,HT,HN,HU,IS,IN,AP,ID,IR,IQ,IE,IL,IT,JM,JP,JO,KZ,KE,KI,KW,KY,KG,LA,LV,LB,LS,LR,LY,LI,LT,LU,MG,MW,MY,MV,ML,MT,MH,MR,MU,MX,FM,MC,MN,ME,MA,MZ,MM,NA,NR,NP,NL,NZ,NI,NE,NG,MK,NO,OM,PK,PW,PA,PG,PY,PE,PH,PL,PT,PI,QA,KR,MD,RO,RU,KU,RW,KN,LC,VC,WS,SM,ST,SA,SN,RS,SC,SL,SG,SK,SI,SB,SO,ZA,SS,II,ES,EI,LK,SR,SE,CH,SY,TJ,TH,TL,TG,TO,TT,TN,TR,TM,TV,UG,UA,AE,GB,TZ,US,UY,UZ,VU,VE,VG,VN,YE,ZM,ZW,GP,GF,MQ,MS,PR,SX,TC,VI",
    Image: "34DSS12.jpg",
    URL: "https://documents.un.org/api/symbol/access?s=a/81/6(Sect.34)&l=es#page=18"
  }
]